webpackJsonp([137591856104208],{

/***/ 363:
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(363)
	var ieee754 = __webpack_require__(852)
	var isArray = __webpack_require__(364)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

	/*
	  Module dependencies
	*/
	var ElementType = __webpack_require__(86);
	var entities = __webpack_require__(617);
	
	var unencodedElements = {
	  __proto__: null,
	  style: true,
	  script: true,
	  xmp: true,
	  iframe: true,
	  noembed: true,
	  noframes: true,
	  plaintext: true,
	  noscript: true
	};
	
	/*
	  Format attributes
	*/
	function formatAttrs(attributes, opts) {
	  if (!attributes) return;
	
	  var output = '',
	      value;
	
	  // Loop through the attributes
	  for (var key in attributes) {
	    value = attributes[key];
	    if (output) {
	      output += ' ';
	    }
	
	    output += key;
	    if ((value !== null && value !== '') || opts.xmlMode) {
	        output += '="' + (opts.decodeEntities ? entities.encodeXML(value) : value) + '"';
	    }
	  }
	
	  return output;
	}
	
	/*
	  Self-enclosing tags (stolen from node-htmlparser)
	*/
	var singleTag = {
	  __proto__: null,
	  area: true,
	  base: true,
	  basefont: true,
	  br: true,
	  col: true,
	  command: true,
	  embed: true,
	  frame: true,
	  hr: true,
	  img: true,
	  input: true,
	  isindex: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true,
	};
	
	
	var render = module.exports = function(dom, opts) {
	  if (!Array.isArray(dom) && !dom.cheerio) dom = [dom];
	  opts = opts || {};
	
	  var output = '';
	
	  for(var i = 0; i < dom.length; i++){
	    var elem = dom[i];
	
	    if (elem.type === 'root')
	      output += render(elem.children, opts);
	    else if (ElementType.isTag(elem))
	      output += renderTag(elem, opts);
	    else if (elem.type === ElementType.Directive)
	      output += renderDirective(elem);
	    else if (elem.type === ElementType.Comment)
	      output += renderComment(elem);
	    else if (elem.type === ElementType.CDATA)
	      output += renderCdata(elem);
	    else
	      output += renderText(elem, opts);
	  }
	
	  return output;
	};
	
	function renderTag(elem, opts) {
	  // Handle SVG
	  if (elem.name === "svg") opts = {decodeEntities: opts.decodeEntities, xmlMode: true};
	
	  var tag = '<' + elem.name,
	      attribs = formatAttrs(elem.attribs, opts);
	
	  if (attribs) {
	    tag += ' ' + attribs;
	  }
	
	  if (
	    opts.xmlMode
	    && (!elem.children || elem.children.length === 0)
	  ) {
	    tag += '/>';
	  } else {
	    tag += '>';
	    if (elem.children) {
	      tag += render(elem.children, opts);
	    }
	
	    if (!singleTag[elem.name] || opts.xmlMode) {
	      tag += '</' + elem.name + '>';
	    }
	  }
	
	  return tag;
	}
	
	function renderDirective(elem) {
	  return '<' + elem.data + '>';
	}
	
	function renderText(elem, opts) {
	  var data = elem.data || '';
	
	  // if entities weren't decoded, no need to encode them back
	  if (opts.decodeEntities && !(elem.parent && elem.parent.name in unencodedElements)) {
	    data = entities.encodeXML(data);
	  }
	
	  return data;
	}
	
	function renderCdata(elem) {
	  return '<![CDATA[' + elem.children[0].data + ']]>';
	}
	
	function renderComment(elem) {
	  return '<!--' + elem.data + '-->';
	}


/***/ }),

/***/ 86:
/***/ (function(module, exports) {

	//Types of elements found in the DOM
	module.exports = {
		Text: "text", //Text
		Directive: "directive", //<? ... ?>
		Comment: "comment", //<!-- ... -->
		Script: "script", //<script> tags
		Style: "style", //<style> tags
		Tag: "tag", //Any tag
		CDATA: "cdata", //<![CDATA[ ... ]]>
		Doctype: "doctype",
	
		isTag: function(elem){
			return elem.type === "tag" || elem.type === "script" || elem.type === "style";
		}
	};


/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(86);
	
	var re_whitespace = /\s+/g;
	var NodePrototype = __webpack_require__(265);
	var ElementPrototype = __webpack_require__(605);
	
	function DomHandler(callback, options, elementCB){
		if(typeof callback === "object"){
			elementCB = options;
			options = callback;
			callback = null;
		} else if(typeof options === "function"){
			elementCB = options;
			options = defaultOpts;
		}
		this._callback = callback;
		this._options = options || defaultOpts;
		this._elementCB = elementCB;
		this.dom = [];
		this._done = false;
		this._tagStack = [];
		this._parser = this._parser || null;
	}
	
	//default options
	var defaultOpts = {
		normalizeWhitespace: false, //Replace all whitespace with single spaces
		withStartIndices: false, //Add startIndex properties to nodes
		withEndIndices: false, //Add endIndex properties to nodes
	};
	
	DomHandler.prototype.onparserinit = function(parser){
		this._parser = parser;
	};
	
	//Resets the handler back to starting state
	DomHandler.prototype.onreset = function(){
		DomHandler.call(this, this._callback, this._options, this._elementCB);
	};
	
	//Signals the handler that parsing is done
	DomHandler.prototype.onend = function(){
		if(this._done) return;
		this._done = true;
		this._parser = null;
		this._handleCallback(null);
	};
	
	DomHandler.prototype._handleCallback =
	DomHandler.prototype.onerror = function(error){
		if(typeof this._callback === "function"){
			this._callback(error, this.dom);
		} else {
			if(error) throw error;
		}
	};
	
	DomHandler.prototype.onclosetag = function(){
		//if(this._tagStack.pop().name !== name) this._handleCallback(Error("Tagname didn't match!"));
		
		var elem = this._tagStack.pop();
	
		if(this._options.withEndIndices && elem){
			elem.endIndex = this._parser.endIndex;
		}
	
		if(this._elementCB) this._elementCB(elem);
	};
	
	DomHandler.prototype._createDomElement = function(properties){
		if (!this._options.withDomLvl1) return properties;
	
		var element;
		if (properties.type === "tag") {
			element = Object.create(ElementPrototype);
		} else {
			element = Object.create(NodePrototype);
		}
	
		for (var key in properties) {
			if (properties.hasOwnProperty(key)) {
				element[key] = properties[key];
			}
		}
	
		return element;
	};
	
	DomHandler.prototype._addDomElement = function(element){
		var parent = this._tagStack[this._tagStack.length - 1];
		var siblings = parent ? parent.children : this.dom;
		var previousSibling = siblings[siblings.length - 1];
	
		element.next = null;
	
		if(this._options.withStartIndices){
			element.startIndex = this._parser.startIndex;
		}
		if(this._options.withEndIndices){
			element.endIndex = this._parser.endIndex;
		}
	
		if(previousSibling){
			element.prev = previousSibling;
			previousSibling.next = element;
		} else {
			element.prev = null;
		}
	
		siblings.push(element);
		element.parent = parent || null;
	};
	
	DomHandler.prototype.onopentag = function(name, attribs){
		var properties = {
			type: name === "script" ? ElementType.Script : name === "style" ? ElementType.Style : ElementType.Tag,
			name: name,
			attribs: attribs,
			children: []
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
	
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.ontext = function(data){
		//the ignoreWhitespace is officially dropped, but for now,
		//it's an alias for normalizeWhitespace
		var normalize = this._options.normalizeWhitespace || this._options.ignoreWhitespace;
	
		var lastTag;
	
		if(!this._tagStack.length && this.dom.length && (lastTag = this.dom[this.dom.length-1]).type === ElementType.Text){
			if(normalize){
				lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
			} else {
				lastTag.data += data;
			}
		} else {
			if(
				this._tagStack.length &&
				(lastTag = this._tagStack[this._tagStack.length - 1]) &&
				(lastTag = lastTag.children[lastTag.children.length - 1]) &&
				lastTag.type === ElementType.Text
			){
				if(normalize){
					lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
				} else {
					lastTag.data += data;
				}
			} else {
				if(normalize){
					data = data.replace(re_whitespace, " ");
				}
	
				var element = this._createDomElement({
					data: data,
					type: ElementType.Text
				});
	
				this._addDomElement(element);
			}
		}
	};
	
	DomHandler.prototype.oncomment = function(data){
		var lastTag = this._tagStack[this._tagStack.length - 1];
	
		if(lastTag && lastTag.type === ElementType.Comment){
			lastTag.data += data;
			return;
		}
	
		var properties = {
			data: data,
			type: ElementType.Comment
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.oncdatastart = function(){
		var properties = {
			children: [{
				data: "",
				type: ElementType.Text
			}],
			type: ElementType.CDATA
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.oncommentend = DomHandler.prototype.oncdataend = function(){
		this._tagStack.pop();
	};
	
	DomHandler.prototype.onprocessinginstruction = function(name, data){
		var element = this._createDomElement({
			name: name,
			data: data,
			type: ElementType.Directive
		});
	
		this._addDomElement(element);
	};
	
	module.exports = DomHandler;


/***/ }),

/***/ 605:
/***/ (function(module, exports, __webpack_require__) {

	// DOM-Level-1-compliant structure
	var NodePrototype = __webpack_require__(265);
	var ElementPrototype = module.exports = Object.create(NodePrototype);
	
	var domLvl1 = {
		tagName: "name"
	};
	
	Object.keys(domLvl1).forEach(function(key) {
		var shorthand = domLvl1[key];
		Object.defineProperty(ElementPrototype, key, {
			get: function() {
				return this[shorthand] || null;
			},
			set: function(val) {
				this[shorthand] = val;
				return val;
			}
		});
	});


/***/ }),

/***/ 265:
/***/ (function(module, exports) {

	// This object will be used as the prototype for Nodes when creating a
	// DOM-Level-1-compliant structure.
	var NodePrototype = module.exports = {
		get firstChild() {
			var children = this.children;
			return children && children[0] || null;
		},
		get lastChild() {
			var children = this.children;
			return children && children[children.length - 1] || null;
		},
		get nodeType() {
			return nodeTypes[this.type] || nodeTypes.element;
		}
	};
	
	var domLvl1 = {
		tagName: "name",
		childNodes: "children",
		parentNode: "parent",
		previousSibling: "prev",
		nextSibling: "next",
		nodeValue: "data"
	};
	
	var nodeTypes = {
		element: 1,
		text: 3,
		cdata: 4,
		comment: 8
	};
	
	Object.keys(domLvl1).forEach(function(key) {
		var shorthand = domLvl1[key];
		Object.defineProperty(NodePrototype, key, {
			get: function() {
				return this[shorthand] || null;
			},
			set: function(val) {
				this[shorthand] = val;
				return val;
			}
		});
	});


/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

	var DomUtils = module.exports;
	
	[
		__webpack_require__(611),
		__webpack_require__(612),
		__webpack_require__(609),
		__webpack_require__(610),
		__webpack_require__(608),
		__webpack_require__(607)
	].forEach(function(ext){
		Object.keys(ext).forEach(function(key){
			DomUtils[key] = ext[key].bind(DomUtils);
		});
	});


/***/ }),

/***/ 607:
/***/ (function(module, exports) {

	// removeSubsets
	// Given an array of nodes, remove any member that is contained by another.
	exports.removeSubsets = function(nodes) {
		var idx = nodes.length, node, ancestor, replace;
	
		// Check if each node (or one of its ancestors) is already contained in the
		// array.
		while (--idx > -1) {
			node = ancestor = nodes[idx];
	
			// Temporarily remove the node under consideration
			nodes[idx] = null;
			replace = true;
	
			while (ancestor) {
				if (nodes.indexOf(ancestor) > -1) {
					replace = false;
					nodes.splice(idx, 1);
					break;
				}
				ancestor = ancestor.parent;
			}
	
			// If the node has been found to be unique, re-insert it.
			if (replace) {
				nodes[idx] = node;
			}
		}
	
		return nodes;
	};
	
	// Source: http://dom.spec.whatwg.org/#dom-node-comparedocumentposition
	var POSITION = {
		DISCONNECTED: 1,
		PRECEDING: 2,
		FOLLOWING: 4,
		CONTAINS: 8,
		CONTAINED_BY: 16
	};
	
	// Compare the position of one node against another node in any other document.
	// The return value is a bitmask with the following values:
	//
	// document order:
	// > There is an ordering, document order, defined on all the nodes in the
	// > document corresponding to the order in which the first character of the
	// > XML representation of each node occurs in the XML representation of the
	// > document after expansion of general entities. Thus, the document element
	// > node will be the first node. Element nodes occur before their children.
	// > Thus, document order orders element nodes in order of the occurrence of
	// > their start-tag in the XML (after expansion of entities). The attribute
	// > nodes of an element occur after the element and before its children. The
	// > relative order of attribute nodes is implementation-dependent./
	// Source:
	// http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
	//
	// @argument {Node} nodaA The first node to use in the comparison
	// @argument {Node} nodeB The second node to use in the comparison
	//
	// @return {Number} A bitmask describing the input nodes' relative position.
	//         See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
	//         a description of these values.
	var comparePos = exports.compareDocumentPosition = function(nodeA, nodeB) {
		var aParents = [];
		var bParents = [];
		var current, sharedParent, siblings, aSibling, bSibling, idx;
	
		if (nodeA === nodeB) {
			return 0;
		}
	
		current = nodeA;
		while (current) {
			aParents.unshift(current);
			current = current.parent;
		}
		current = nodeB;
		while (current) {
			bParents.unshift(current);
			current = current.parent;
		}
	
		idx = 0;
		while (aParents[idx] === bParents[idx]) {
			idx++;
		}
	
		if (idx === 0) {
			return POSITION.DISCONNECTED;
		}
	
		sharedParent = aParents[idx - 1];
		siblings = sharedParent.children;
		aSibling = aParents[idx];
		bSibling = bParents[idx];
	
		if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
			if (sharedParent === nodeB) {
				return POSITION.FOLLOWING | POSITION.CONTAINED_BY;
			}
			return POSITION.FOLLOWING;
		} else {
			if (sharedParent === nodeA) {
				return POSITION.PRECEDING | POSITION.CONTAINS;
			}
			return POSITION.PRECEDING;
		}
	};
	
	// Sort an array of nodes based on their relative position in the document and
	// remove any duplicate nodes. If the array contains nodes that do not belong
	// to the same document, sort order is unspecified.
	//
	// @argument {Array} nodes Array of DOM nodes
	//
	// @returns {Array} collection of unique nodes, sorted in document order
	exports.uniqueSort = function(nodes) {
		var idx = nodes.length, node, position;
	
		nodes = nodes.slice();
	
		while (--idx > -1) {
			node = nodes[idx];
			position = nodes.indexOf(node);
			if (position > -1 && position < idx) {
				nodes.splice(idx, 1);
			}
		}
		nodes.sort(function(a, b) {
			var relative = comparePos(a, b);
			if (relative & POSITION.PRECEDING) {
				return -1;
			} else if (relative & POSITION.FOLLOWING) {
				return 1;
			}
			return 0;
		});
	
		return nodes;
	};


/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(86);
	var isTag = exports.isTag = ElementType.isTag;
	
	exports.testElement = function(options, element){
		for(var key in options){
			if(!options.hasOwnProperty(key));
			else if(key === "tag_name"){
				if(!isTag(element) || !options.tag_name(element.name)){
					return false;
				}
			} else if(key === "tag_type"){
				if(!options.tag_type(element.type)) return false;
			} else if(key === "tag_contains"){
				if(isTag(element) || !options.tag_contains(element.data)){
					return false;
				}
			} else if(!element.attribs || !options[key](element.attribs[key])){
				return false;
			}
		}
		return true;
	};
	
	var Checks = {
		tag_name: function(name){
			if(typeof name === "function"){
				return function(elem){ return isTag(elem) && name(elem.name); };
			} else if(name === "*"){
				return isTag;
			} else {
				return function(elem){ return isTag(elem) && elem.name === name; };
			}
		},
		tag_type: function(type){
			if(typeof type === "function"){
				return function(elem){ return type(elem.type); };
			} else {
				return function(elem){ return elem.type === type; };
			}
		},
		tag_contains: function(data){
			if(typeof data === "function"){
				return function(elem){ return !isTag(elem) && data(elem.data); };
			} else {
				return function(elem){ return !isTag(elem) && elem.data === data; };
			}
		}
	};
	
	function getAttribCheck(attrib, value){
		if(typeof value === "function"){
			return function(elem){ return elem.attribs && value(elem.attribs[attrib]); };
		} else {
			return function(elem){ return elem.attribs && elem.attribs[attrib] === value; };
		}
	}
	
	function combineFuncs(a, b){
		return function(elem){
			return a(elem) || b(elem);
		};
	}
	
	exports.getElements = function(options, element, recurse, limit){
		var funcs = Object.keys(options).map(function(key){
			var value = options[key];
			return key in Checks ? Checks[key](value) : getAttribCheck(key, value);
		});
	
		return funcs.length === 0 ? [] : this.filter(
			funcs.reduce(combineFuncs),
			element, recurse, limit
		);
	};
	
	exports.getElementById = function(id, element, recurse){
		if(!Array.isArray(element)) element = [element];
		return this.findOne(getAttribCheck("id", id), element, recurse !== false);
	};
	
	exports.getElementsByTagName = function(name, element, recurse, limit){
		return this.filter(Checks.tag_name(name), element, recurse, limit);
	};
	
	exports.getElementsByTagType = function(type, element, recurse, limit){
		return this.filter(Checks.tag_type(type), element, recurse, limit);
	};


/***/ }),

/***/ 609:
/***/ (function(module, exports) {

	exports.removeElement = function(elem){
		if(elem.prev) elem.prev.next = elem.next;
		if(elem.next) elem.next.prev = elem.prev;
	
		if(elem.parent){
			var childs = elem.parent.children;
			childs.splice(childs.lastIndexOf(elem), 1);
		}
	};
	
	exports.replaceElement = function(elem, replacement){
		var prev = replacement.prev = elem.prev;
		if(prev){
			prev.next = replacement;
		}
	
		var next = replacement.next = elem.next;
		if(next){
			next.prev = replacement;
		}
	
		var parent = replacement.parent = elem.parent;
		if(parent){
			var childs = parent.children;
			childs[childs.lastIndexOf(elem)] = replacement;
		}
	};
	
	exports.appendChild = function(elem, child){
		child.parent = elem;
	
		if(elem.children.push(child) !== 1){
			var sibling = elem.children[elem.children.length - 2];
			sibling.next = child;
			child.prev = sibling;
			child.next = null;
		}
	};
	
	exports.append = function(elem, next){
		var parent = elem.parent,
			currNext = elem.next;
	
		next.next = currNext;
		next.prev = elem;
		elem.next = next;
		next.parent = parent;
	
		if(currNext){
			currNext.prev = next;
			if(parent){
				var childs = parent.children;
				childs.splice(childs.lastIndexOf(currNext), 0, next);
			}
		} else if(parent){
			parent.children.push(next);
		}
	};
	
	exports.prepend = function(elem, prev){
		var parent = elem.parent;
		if(parent){
			var childs = parent.children;
			childs.splice(childs.lastIndexOf(elem), 0, prev);
		}
	
		if(elem.prev){
			elem.prev.next = prev;
		}
		
		prev.parent = parent;
		prev.prev = elem.prev;
		prev.next = elem;
		elem.prev = prev;
	};
	
	


/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

	var isTag = __webpack_require__(86).isTag;
	
	module.exports = {
		filter: filter,
		find: find,
		findOneChild: findOneChild,
		findOne: findOne,
		existsOne: existsOne,
		findAll: findAll
	};
	
	function filter(test, element, recurse, limit){
		if(!Array.isArray(element)) element = [element];
	
		if(typeof limit !== "number" || !isFinite(limit)){
			limit = Infinity;
		}
		return find(test, element, recurse !== false, limit);
	}
	
	function find(test, elems, recurse, limit){
		var result = [], childs;
	
		for(var i = 0, j = elems.length; i < j; i++){
			if(test(elems[i])){
				result.push(elems[i]);
				if(--limit <= 0) break;
			}
	
			childs = elems[i].children;
			if(recurse && childs && childs.length > 0){
				childs = find(test, childs, recurse, limit);
				result = result.concat(childs);
				limit -= childs.length;
				if(limit <= 0) break;
			}
		}
	
		return result;
	}
	
	function findOneChild(test, elems){
		for(var i = 0, l = elems.length; i < l; i++){
			if(test(elems[i])) return elems[i];
		}
	
		return null;
	}
	
	function findOne(test, elems){
		var elem = null;
	
		for(var i = 0, l = elems.length; i < l && !elem; i++){
			if(!isTag(elems[i])){
				continue;
			} else if(test(elems[i])){
				elem = elems[i];
			} else if(elems[i].children.length > 0){
				elem = findOne(test, elems[i].children);
			}
		}
	
		return elem;
	}
	
	function existsOne(test, elems){
		for(var i = 0, l = elems.length; i < l; i++){
			if(
				isTag(elems[i]) && (
					test(elems[i]) || (
						elems[i].children.length > 0 &&
						existsOne(test, elems[i].children)
					)
				)
			){
				return true;
			}
		}
	
		return false;
	}
	
	function findAll(test, elems){
		var result = [];
		for(var i = 0, j = elems.length; i < j; i++){
			if(!isTag(elems[i])) continue;
			if(test(elems[i])) result.push(elems[i]);
	
			if(elems[i].children.length > 0){
				result = result.concat(findAll(test, elems[i].children));
			}
		}
		return result;
	}


/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(86),
	    getOuterHTML = __webpack_require__(604),
	    isTag = ElementType.isTag;
	
	module.exports = {
		getInnerHTML: getInnerHTML,
		getOuterHTML: getOuterHTML,
		getText: getText
	};
	
	function getInnerHTML(elem, opts){
		return elem.children ? elem.children.map(function(elem){
			return getOuterHTML(elem, opts);
		}).join("") : "";
	}
	
	function getText(elem){
		if(Array.isArray(elem)) return elem.map(getText).join("");
		if(isTag(elem) || elem.type === ElementType.CDATA) return getText(elem.children);
		if(elem.type === ElementType.Text) return elem.data;
		return "";
	}


/***/ }),

/***/ 612:
/***/ (function(module, exports) {

	var getChildren = exports.getChildren = function(elem){
		return elem.children;
	};
	
	var getParent = exports.getParent = function(elem){
		return elem.parent;
	};
	
	exports.getSiblings = function(elem){
		var parent = getParent(elem);
		return parent ? getChildren(parent) : [elem];
	};
	
	exports.getAttributeValue = function(elem, name){
		return elem.attribs && elem.attribs[name];
	};
	
	exports.hasAttrib = function(elem, name){
		return !!elem.attribs && hasOwnProperty.call(elem.attribs, name);
	};
	
	exports.getName = function(elem){
		return elem.name;
	};


/***/ }),

/***/ 617:
/***/ (function(module, exports, __webpack_require__) {

	var encode = __webpack_require__(619),
	    decode = __webpack_require__(618);
	
	exports.decode = function(data, level) {
	    return (!level || level <= 0 ? decode.XML : decode.HTML)(data);
	};
	
	exports.decodeStrict = function(data, level) {
	    return (!level || level <= 0 ? decode.XML : decode.HTMLStrict)(data);
	};
	
	exports.encode = function(data, level) {
	    return (!level || level <= 0 ? encode.XML : encode.HTML)(data);
	};
	
	exports.encodeXML = encode.XML;
	
	exports.encodeHTML4 = exports.encodeHTML5 = exports.encodeHTML = encode.HTML;
	
	exports.decodeXML = exports.decodeXMLStrict = decode.XML;
	
	exports.decodeHTML4 = exports.decodeHTML5 = exports.decodeHTML = decode.HTML;
	
	exports.decodeHTML4Strict = exports.decodeHTML5Strict = exports.decodeHTMLStrict = decode.HTMLStrict;
	
	exports.escape = encode.escape;


/***/ }),

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {

	var entityMap = __webpack_require__(186),
	    legacyMap = __webpack_require__(279),
	    xmlMap = __webpack_require__(187),
	    decodeCodePoint = __webpack_require__(268);
	
	var decodeXMLStrict = getStrictDecoder(xmlMap),
	    decodeHTMLStrict = getStrictDecoder(entityMap);
	
	function getStrictDecoder(map) {
	    var keys = Object.keys(map).join("|"),
	        replace = getReplacer(map);
	
	    keys += "|#[xX][\\da-fA-F]+|#\\d+";
	
	    var re = new RegExp("&(?:" + keys + ");", "g");
	
	    return function(str) {
	        return String(str).replace(re, replace);
	    };
	}
	
	var decodeHTML = (function() {
	    var legacy = Object.keys(legacyMap).sort(sorter);
	
	    var keys = Object.keys(entityMap).sort(sorter);
	
	    for (var i = 0, j = 0; i < keys.length; i++) {
	        if (legacy[j] === keys[i]) {
	            keys[i] += ";?";
	            j++;
	        } else {
	            keys[i] += ";";
	        }
	    }
	
	    var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"),
	        replace = getReplacer(entityMap);
	
	    function replacer(str) {
	        if (str.substr(-1) !== ";") str += ";";
	        return replace(str);
	    }
	
	    //TODO consider creating a merged map
	    return function(str) {
	        return String(str).replace(re, replacer);
	    };
	})();
	
	function sorter(a, b) {
	    return a < b ? 1 : -1;
	}
	
	function getReplacer(map) {
	    return function replace(str) {
	        if (str.charAt(1) === "#") {
	            if (str.charAt(2) === "X" || str.charAt(2) === "x") {
	                return decodeCodePoint(parseInt(str.substr(3), 16));
	            }
	            return decodeCodePoint(parseInt(str.substr(2), 10));
	        }
	        return map[str.slice(1, -1)];
	    };
	}
	
	module.exports = {
	    XML: decodeXMLStrict,
	    HTML: decodeHTML,
	    HTMLStrict: decodeHTMLStrict
	};


/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

	var decodeMap = __webpack_require__(999);
	
	module.exports = decodeCodePoint;
	
	// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
	function decodeCodePoint(codePoint) {
	    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
	        return "\uFFFD";
	    }
	
	    if (codePoint in decodeMap) {
	        codePoint = decodeMap[codePoint];
	    }
	
	    var output = "";
	
	    if (codePoint > 0xffff) {
	        codePoint -= 0x10000;
	        output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
	        codePoint = 0xdc00 | (codePoint & 0x3ff);
	    }
	
	    output += String.fromCharCode(codePoint);
	    return output;
	}


/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

	var inverseXML = getInverseObj(__webpack_require__(187)),
	    xmlReplacer = getInverseReplacer(inverseXML);
	
	exports.XML = getInverse(inverseXML, xmlReplacer);
	
	var inverseHTML = getInverseObj(__webpack_require__(186)),
	    htmlReplacer = getInverseReplacer(inverseHTML);
	
	exports.HTML = getInverse(inverseHTML, htmlReplacer);
	
	function getInverseObj(obj) {
	    return Object.keys(obj)
	        .sort()
	        .reduce(function(inverse, name) {
	            inverse[obj[name]] = "&" + name + ";";
	            return inverse;
	        }, {});
	}
	
	function getInverseReplacer(inverse) {
	    var single = [],
	        multiple = [];
	
	    Object.keys(inverse).forEach(function(k) {
	        if (k.length === 1) {
	            single.push("\\" + k);
	        } else {
	            multiple.push(k);
	        }
	    });
	
	    //TODO add ranges
	    multiple.unshift("[" + single.join("") + "]");
	
	    return new RegExp(multiple.join("|"), "g");
	}
	
	var re_nonASCII = /[^\0-\x7F]/g,
	    re_astralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	
	function singleCharReplacer(c) {
	    return (
	        "&#x" +
	        c
	            .charCodeAt(0)
	            .toString(16)
	            .toUpperCase() +
	        ";"
	    );
	}
	
	function astralReplacer(c) {
	    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	    var high = c.charCodeAt(0);
	    var low = c.charCodeAt(1);
	    var codePoint = (high - 0xd800) * 0x400 + low - 0xdc00 + 0x10000;
	    return "&#x" + codePoint.toString(16).toUpperCase() + ";";
	}
	
	function getInverse(inverse, re) {
	    function func(name) {
	        return inverse[name];
	    }
	
	    return function(data) {
	        return data
	            .replace(re, func)
	            .replace(re_astralSymbols, astralReplacer)
	            .replace(re_nonASCII, singleCharReplacer);
	    };
	}
	
	var re_xmlChars = getInverseReplacer(inverseXML);
	
	function escapeXML(data) {
	    return data
	        .replace(re_xmlChars, singleCharReplacer)
	        .replace(re_astralSymbols, astralReplacer)
	        .replace(re_nonASCII, singleCharReplacer);
	}
	
	exports.escape = escapeXML;


/***/ }),

/***/ 999:
/***/ (function(module, exports) {

	module.exports = {"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}

/***/ }),

/***/ 186:
/***/ (function(module, exports) {

	module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),

/***/ 279:
/***/ (function(module, exports) {

	module.exports = {"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","QUOT":"\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),

/***/ 187:
/***/ (function(module, exports) {

	module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}

/***/ }),

/***/ 621:
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var R = typeof Reflect === 'object' ? Reflect : null
	var ReflectApply = R && typeof R.apply === 'function'
	  ? R.apply
	  : function ReflectApply(target, receiver, args) {
	    return Function.prototype.apply.call(target, receiver, args);
	  }
	
	var ReflectOwnKeys
	if (R && typeof R.ownKeys === 'function') {
	  ReflectOwnKeys = R.ownKeys
	} else if (Object.getOwnPropertySymbols) {
	  ReflectOwnKeys = function ReflectOwnKeys(target) {
	    return Object.getOwnPropertyNames(target)
	      .concat(Object.getOwnPropertySymbols(target));
	  };
	} else {
	  ReflectOwnKeys = function ReflectOwnKeys(target) {
	    return Object.getOwnPropertyNames(target);
	  };
	}
	
	function ProcessEmitWarning(warning) {
	  if (console && console.warn) console.warn(warning);
	}
	
	var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
	  return value !== value;
	}
	
	function EventEmitter() {
	  EventEmitter.init.call(this);
	}
	module.exports = EventEmitter;
	module.exports.once = once;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._eventsCount = 0;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	var defaultMaxListeners = 10;
	
	function checkListener(listener) {
	  if (typeof listener !== 'function') {
	    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
	  }
	}
	
	Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
	  enumerable: true,
	  get: function() {
	    return defaultMaxListeners;
	  },
	  set: function(arg) {
	    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
	      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
	    }
	    defaultMaxListeners = arg;
	  }
	});
	
	EventEmitter.init = function() {
	
	  if (this._events === undefined ||
	      this._events === Object.getPrototypeOf(this)._events) {
	    this._events = Object.create(null);
	    this._eventsCount = 0;
	  }
	
	  this._maxListeners = this._maxListeners || undefined;
	};
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
	  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
	    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
	  }
	  this._maxListeners = n;
	  return this;
	};
	
	function _getMaxListeners(that) {
	  if (that._maxListeners === undefined)
	    return EventEmitter.defaultMaxListeners;
	  return that._maxListeners;
	}
	
	EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
	  return _getMaxListeners(this);
	};
	
	EventEmitter.prototype.emit = function emit(type) {
	  var args = [];
	  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
	  var doError = (type === 'error');
	
	  var events = this._events;
	  if (events !== undefined)
	    doError = (doError && events.error === undefined);
	  else if (!doError)
	    return false;
	
	  // If there is no 'error' event listener then throw.
	  if (doError) {
	    var er;
	    if (args.length > 0)
	      er = args[0];
	    if (er instanceof Error) {
	      // Note: The comments on the `throw` lines are intentional, they show
	      // up in Node's output if this results in an unhandled exception.
	      throw er; // Unhandled 'error' event
	    }
	    // At least give some kind of context to the user
	    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
	    err.context = er;
	    throw err; // Unhandled 'error' event
	  }
	
	  var handler = events[type];
	
	  if (handler === undefined)
	    return false;
	
	  if (typeof handler === 'function') {
	    ReflectApply(handler, this, args);
	  } else {
	    var len = handler.length;
	    var listeners = arrayClone(handler, len);
	    for (var i = 0; i < len; ++i)
	      ReflectApply(listeners[i], this, args);
	  }
	
	  return true;
	};
	
	function _addListener(target, type, listener, prepend) {
	  var m;
	  var events;
	  var existing;
	
	  checkListener(listener);
	
	  events = target._events;
	  if (events === undefined) {
	    events = target._events = Object.create(null);
	    target._eventsCount = 0;
	  } else {
	    // To avoid recursion in the case that type === "newListener"! Before
	    // adding it to the listeners, first emit "newListener".
	    if (events.newListener !== undefined) {
	      target.emit('newListener', type,
	                  listener.listener ? listener.listener : listener);
	
	      // Re-assign `events` because a newListener handler could have caused the
	      // this._events to be assigned to a new object
	      events = target._events;
	    }
	    existing = events[type];
	  }
	
	  if (existing === undefined) {
	    // Optimize the case of one listener. Don't need the extra array object.
	    existing = events[type] = listener;
	    ++target._eventsCount;
	  } else {
	    if (typeof existing === 'function') {
	      // Adding the second element, need to change to array.
	      existing = events[type] =
	        prepend ? [listener, existing] : [existing, listener];
	      // If we've already got an array, just append.
	    } else if (prepend) {
	      existing.unshift(listener);
	    } else {
	      existing.push(listener);
	    }
	
	    // Check for listener leak
	    m = _getMaxListeners(target);
	    if (m > 0 && existing.length > m && !existing.warned) {
	      existing.warned = true;
	      // No error code for this since it is a Warning
	      // eslint-disable-next-line no-restricted-syntax
	      var w = new Error('Possible EventEmitter memory leak detected. ' +
	                          existing.length + ' ' + String(type) + ' listeners ' +
	                          'added. Use emitter.setMaxListeners() to ' +
	                          'increase limit');
	      w.name = 'MaxListenersExceededWarning';
	      w.emitter = target;
	      w.type = type;
	      w.count = existing.length;
	      ProcessEmitWarning(w);
	    }
	  }
	
	  return target;
	}
	
	EventEmitter.prototype.addListener = function addListener(type, listener) {
	  return _addListener(this, type, listener, false);
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.prependListener =
	    function prependListener(type, listener) {
	      return _addListener(this, type, listener, true);
	    };
	
	function onceWrapper() {
	  if (!this.fired) {
	    this.target.removeListener(this.type, this.wrapFn);
	    this.fired = true;
	    if (arguments.length === 0)
	      return this.listener.call(this.target);
	    return this.listener.apply(this.target, arguments);
	  }
	}
	
	function _onceWrap(target, type, listener) {
	  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
	  var wrapped = onceWrapper.bind(state);
	  wrapped.listener = listener;
	  state.wrapFn = wrapped;
	  return wrapped;
	}
	
	EventEmitter.prototype.once = function once(type, listener) {
	  checkListener(listener);
	  this.on(type, _onceWrap(this, type, listener));
	  return this;
	};
	
	EventEmitter.prototype.prependOnceListener =
	    function prependOnceListener(type, listener) {
	      checkListener(listener);
	      this.prependListener(type, _onceWrap(this, type, listener));
	      return this;
	    };
	
	// Emits a 'removeListener' event if and only if the listener was removed.
	EventEmitter.prototype.removeListener =
	    function removeListener(type, listener) {
	      var list, events, position, i, originalListener;
	
	      checkListener(listener);
	
	      events = this._events;
	      if (events === undefined)
	        return this;
	
	      list = events[type];
	      if (list === undefined)
	        return this;
	
	      if (list === listener || list.listener === listener) {
	        if (--this._eventsCount === 0)
	          this._events = Object.create(null);
	        else {
	          delete events[type];
	          if (events.removeListener)
	            this.emit('removeListener', type, list.listener || listener);
	        }
	      } else if (typeof list !== 'function') {
	        position = -1;
	
	        for (i = list.length - 1; i >= 0; i--) {
	          if (list[i] === listener || list[i].listener === listener) {
	            originalListener = list[i].listener;
	            position = i;
	            break;
	          }
	        }
	
	        if (position < 0)
	          return this;
	
	        if (position === 0)
	          list.shift();
	        else {
	          spliceOne(list, position);
	        }
	
	        if (list.length === 1)
	          events[type] = list[0];
	
	        if (events.removeListener !== undefined)
	          this.emit('removeListener', type, originalListener || listener);
	      }
	
	      return this;
	    };
	
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	
	EventEmitter.prototype.removeAllListeners =
	    function removeAllListeners(type) {
	      var listeners, events, i;
	
	      events = this._events;
	      if (events === undefined)
	        return this;
	
	      // not listening for removeListener, no need to emit
	      if (events.removeListener === undefined) {
	        if (arguments.length === 0) {
	          this._events = Object.create(null);
	          this._eventsCount = 0;
	        } else if (events[type] !== undefined) {
	          if (--this._eventsCount === 0)
	            this._events = Object.create(null);
	          else
	            delete events[type];
	        }
	        return this;
	      }
	
	      // emit removeListener for all listeners on all events
	      if (arguments.length === 0) {
	        var keys = Object.keys(events);
	        var key;
	        for (i = 0; i < keys.length; ++i) {
	          key = keys[i];
	          if (key === 'removeListener') continue;
	          this.removeAllListeners(key);
	        }
	        this.removeAllListeners('removeListener');
	        this._events = Object.create(null);
	        this._eventsCount = 0;
	        return this;
	      }
	
	      listeners = events[type];
	
	      if (typeof listeners === 'function') {
	        this.removeListener(type, listeners);
	      } else if (listeners !== undefined) {
	        // LIFO order
	        for (i = listeners.length - 1; i >= 0; i--) {
	          this.removeListener(type, listeners[i]);
	        }
	      }
	
	      return this;
	    };
	
	function _listeners(target, type, unwrap) {
	  var events = target._events;
	
	  if (events === undefined)
	    return [];
	
	  var evlistener = events[type];
	  if (evlistener === undefined)
	    return [];
	
	  if (typeof evlistener === 'function')
	    return unwrap ? [evlistener.listener || evlistener] : [evlistener];
	
	  return unwrap ?
	    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
	}
	
	EventEmitter.prototype.listeners = function listeners(type) {
	  return _listeners(this, type, true);
	};
	
	EventEmitter.prototype.rawListeners = function rawListeners(type) {
	  return _listeners(this, type, false);
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  if (typeof emitter.listenerCount === 'function') {
	    return emitter.listenerCount(type);
	  } else {
	    return listenerCount.call(emitter, type);
	  }
	};
	
	EventEmitter.prototype.listenerCount = listenerCount;
	function listenerCount(type) {
	  var events = this._events;
	
	  if (events !== undefined) {
	    var evlistener = events[type];
	
	    if (typeof evlistener === 'function') {
	      return 1;
	    } else if (evlistener !== undefined) {
	      return evlistener.length;
	    }
	  }
	
	  return 0;
	}
	
	EventEmitter.prototype.eventNames = function eventNames() {
	  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
	};
	
	function arrayClone(arr, n) {
	  var copy = new Array(n);
	  for (var i = 0; i < n; ++i)
	    copy[i] = arr[i];
	  return copy;
	}
	
	function spliceOne(list, index) {
	  for (; index + 1 < list.length; index++)
	    list[index] = list[index + 1];
	  list.pop();
	}
	
	function unwrapListeners(arr) {
	  var ret = new Array(arr.length);
	  for (var i = 0; i < ret.length; ++i) {
	    ret[i] = arr[i].listener || arr[i];
	  }
	  return ret;
	}
	
	function once(emitter, name) {
	  return new Promise(function (resolve, reject) {
	    function eventListener() {
	      if (errorListener !== undefined) {
	        emitter.removeListener('error', errorListener);
	      }
	      resolve([].slice.call(arguments));
	    };
	    var errorListener;
	
	    // Adding an error listener is not optional because
	    // if an error is thrown on an event emitter we cannot
	    // guarantee that the actual event we are waiting will
	    // be fired. The result could be a silent way to create
	    // memory or file descriptor leaks, which is something
	    // we should avoid.
	    if (name !== 'error') {
	      errorListener = function errorListener(err) {
	        emitter.removeListener(name, eventListener);
	        reject(err);
	      };
	
	      emitter.once('error', errorListener);
	    }
	
	    emitter.once(name, eventListener);
	  });
	}


/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {(function(a,b){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (b), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if("undefined"!=typeof exports)b();else{b(),a.FileSaver={exports:{}}.exports}})(this,function(){"use strict";function b(a,b){return"undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Deprecated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(b,c,d){var e=new XMLHttpRequest;e.open("GET",b),e.responseType="blob",e.onload=function(){a(e.response,c,d)},e.onerror=function(){console.error("could not download file")},e.send()}function d(a){var b=new XMLHttpRequest;b.open("HEAD",a,!1);try{b.send()}catch(a){}return 200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"))}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b)}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof global&&global.global===global?global:void 0,a=f.saveAs||("object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href)},4E4),setTimeout(function(){e(j)},0))}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else{var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i)})}}:function(a,b,d,e){if(e=e||open("","_blank"),e&&(e.document.title=e.document.body.innerText="downloading..."),"string"==typeof a)return c(a,b,d);var g="application/octet-stream"===a.type,h=/constructor/i.test(f.HTMLElement)||f.safari,i=/CriOS\/[\d]+/.test(navigator.userAgent);if((i||g&&h)&&"object"==typeof FileReader){var j=new FileReader;j.onloadend=function(){var a=j.result;a=i?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),e?e.location.href=a:location=a,e=null},j.readAsDataURL(a)}else{var k=f.URL||f.webkitURL,l=k.createObjectURL(a);e?e.location=l:location.href=l,e=null,setTimeout(function(){k.revokeObjectURL(l)},4E4)}});f.saveAs=a.saveAs=a,"undefined"!=typeof module&&(module.exports=a)});
	
	//# sourceMappingURL=FileSaver.min.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 848:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = CollectingHandler;
	
	function CollectingHandler(cbs) {
	    this._cbs = cbs || {};
	    this.events = [];
	}
	
	var EVENTS = __webpack_require__(87).EVENTS;
	Object.keys(EVENTS).forEach(function(name) {
	    if (EVENTS[name] === 0) {
	        name = "on" + name;
	        CollectingHandler.prototype[name] = function() {
	            this.events.push([name]);
	            if (this._cbs[name]) this._cbs[name]();
	        };
	    } else if (EVENTS[name] === 1) {
	        name = "on" + name;
	        CollectingHandler.prototype[name] = function(a) {
	            this.events.push([name, a]);
	            if (this._cbs[name]) this._cbs[name](a);
	        };
	    } else if (EVENTS[name] === 2) {
	        name = "on" + name;
	        CollectingHandler.prototype[name] = function(a, b) {
	            this.events.push([name, a, b]);
	            if (this._cbs[name]) this._cbs[name](a, b);
	        };
	    } else {
	        throw Error("wrong number of arguments");
	    }
	});
	
	CollectingHandler.prototype.onreset = function() {
	    this.events = [];
	    if (this._cbs.onreset) this._cbs.onreset();
	};
	
	CollectingHandler.prototype.restart = function() {
	    if (this._cbs.onreset) this._cbs.onreset();
	
	    for (var i = 0, len = this.events.length; i < len; i++) {
	        if (this._cbs[this.events[i][0]]) {
	            var num = this.events[i].length;
	
	            if (num === 1) {
	                this._cbs[this.events[i][0]]();
	            } else if (num === 2) {
	                this._cbs[this.events[i][0]](this.events[i][1]);
	            } else {
	                this._cbs[this.events[i][0]](
	                    this.events[i][1],
	                    this.events[i][2]
	                );
	            }
	        }
	    }
	};


/***/ }),

/***/ 849:
/***/ (function(module, exports, __webpack_require__) {

	var DomHandler = __webpack_require__(264);
	var DomUtils = __webpack_require__(266);
	
	//TODO: make this a streamable handler
	function FeedHandler(callback, options) {
	    this.init(callback, options);
	}
	
	__webpack_require__(134)(FeedHandler, DomHandler);
	
	FeedHandler.prototype.init = DomHandler;
	
	function getElements(what, where) {
	    return DomUtils.getElementsByTagName(what, where, true);
	}
	function getOneElement(what, where) {
	    return DomUtils.getElementsByTagName(what, where, true, 1)[0];
	}
	function fetch(what, where, recurse) {
	    return DomUtils.getText(
	        DomUtils.getElementsByTagName(what, where, recurse, 1)
	    ).trim();
	}
	
	function addConditionally(obj, prop, what, where, recurse) {
	    var tmp = fetch(what, where, recurse);
	    if (tmp) obj[prop] = tmp;
	}
	
	var isValidFeed = function(value) {
	    return value === "rss" || value === "feed" || value === "rdf:RDF";
	};
	
	FeedHandler.prototype.onend = function() {
	    var feed = {},
	        feedRoot = getOneElement(isValidFeed, this.dom),
	        tmp,
	        childs;
	
	    if (feedRoot) {
	        if (feedRoot.name === "feed") {
	            childs = feedRoot.children;
	
	            feed.type = "atom";
	            addConditionally(feed, "id", "id", childs);
	            addConditionally(feed, "title", "title", childs);
	            if (
	                (tmp = getOneElement("link", childs)) &&
	                (tmp = tmp.attribs) &&
	                (tmp = tmp.href)
	            )
	                feed.link = tmp;
	            addConditionally(feed, "description", "subtitle", childs);
	            if ((tmp = fetch("updated", childs))) feed.updated = new Date(tmp);
	            addConditionally(feed, "author", "email", childs, true);
	
	            feed.items = getElements("entry", childs).map(function(item) {
	                var entry = {},
	                    tmp;
	
	                item = item.children;
	
	                addConditionally(entry, "id", "id", item);
	                addConditionally(entry, "title", "title", item);
	                if (
	                    (tmp = getOneElement("link", item)) &&
	                    (tmp = tmp.attribs) &&
	                    (tmp = tmp.href)
	                )
	                    entry.link = tmp;
	                if ((tmp = fetch("summary", item) || fetch("content", item)))
	                    entry.description = tmp;
	                if ((tmp = fetch("updated", item)))
	                    entry.pubDate = new Date(tmp);
	                return entry;
	            });
	        } else {
	            childs = getOneElement("channel", feedRoot.children).children;
	
	            feed.type = feedRoot.name.substr(0, 3);
	            feed.id = "";
	            addConditionally(feed, "title", "title", childs);
	            addConditionally(feed, "link", "link", childs);
	            addConditionally(feed, "description", "description", childs);
	            if ((tmp = fetch("lastBuildDate", childs)))
	                feed.updated = new Date(tmp);
	            addConditionally(feed, "author", "managingEditor", childs, true);
	
	            feed.items = getElements("item", feedRoot.children).map(function(
	                item
	            ) {
	                var entry = {},
	                    tmp;
	
	                item = item.children;
	
	                addConditionally(entry, "id", "guid", item);
	                addConditionally(entry, "title", "title", item);
	                addConditionally(entry, "link", "link", item);
	                addConditionally(entry, "description", "description", item);
	                if ((tmp = fetch("pubDate", item)))
	                    entry.pubDate = new Date(tmp);
	                return entry;
	            });
	        }
	    }
	    this.dom = feed;
	    DomHandler.prototype._handleCallback.call(
	        this,
	        feedRoot ? null : Error("couldn't find root of feed")
	    );
	};
	
	module.exports = FeedHandler;


/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

	var Tokenizer = __webpack_require__(277);
	
	/*
		Options:
	
		xmlMode: Disables the special behavior for script/style tags (false by default)
		lowerCaseAttributeNames: call .toLowerCase for each attribute name (true if xmlMode is `false`)
		lowerCaseTags: call .toLowerCase for each tag name (true if xmlMode is `false`)
	*/
	
	/*
		Callbacks:
	
		oncdataend,
		oncdatastart,
		onclosetag,
		oncomment,
		oncommentend,
		onerror,
		onopentag,
		onprocessinginstruction,
		onreset,
		ontext
	*/
	
	var formTags = {
	    input: true,
	    option: true,
	    optgroup: true,
	    select: true,
	    button: true,
	    datalist: true,
	    textarea: true
	};
	
	var openImpliesClose = {
	    tr: { tr: true, th: true, td: true },
	    th: { th: true },
	    td: { thead: true, th: true, td: true },
	    body: { head: true, link: true, script: true },
	    li: { li: true },
	    p: { p: true },
	    h1: { p: true },
	    h2: { p: true },
	    h3: { p: true },
	    h4: { p: true },
	    h5: { p: true },
	    h6: { p: true },
	    select: formTags,
	    input: formTags,
	    output: formTags,
	    button: formTags,
	    datalist: formTags,
	    textarea: formTags,
	    option: { option: true },
	    optgroup: { optgroup: true }
	};
	
	var voidElements = {
	    __proto__: null,
	    area: true,
	    base: true,
	    basefont: true,
	    br: true,
	    col: true,
	    command: true,
	    embed: true,
	    frame: true,
	    hr: true,
	    img: true,
	    input: true,
	    isindex: true,
	    keygen: true,
	    link: true,
	    meta: true,
	    param: true,
	    source: true,
	    track: true,
	    wbr: true
	};
	
	var foreignContextElements = {
	    __proto__: null,
	    math: true,
	    svg: true
	};
	var htmlIntegrationElements = {
	    __proto__: null,
	    mi: true,
	    mo: true,
	    mn: true,
	    ms: true,
	    mtext: true,
	    "annotation-xml": true,
	    foreignObject: true,
	    desc: true,
	    title: true
	};
	
	var re_nameEnd = /\s|\//;
	
	function Parser(cbs, options) {
	    this._options = options || {};
	    this._cbs = cbs || {};
	
	    this._tagname = "";
	    this._attribname = "";
	    this._attribvalue = "";
	    this._attribs = null;
	    this._stack = [];
	    this._foreignContext = [];
	
	    this.startIndex = 0;
	    this.endIndex = null;
	
	    this._lowerCaseTagNames =
	        "lowerCaseTags" in this._options
	            ? !!this._options.lowerCaseTags
	            : !this._options.xmlMode;
	    this._lowerCaseAttributeNames =
	        "lowerCaseAttributeNames" in this._options
	            ? !!this._options.lowerCaseAttributeNames
	            : !this._options.xmlMode;
	
	    if (this._options.Tokenizer) {
	        Tokenizer = this._options.Tokenizer;
	    }
	    this._tokenizer = new Tokenizer(this._options, this);
	
	    if (this._cbs.onparserinit) this._cbs.onparserinit(this);
	}
	
	__webpack_require__(134)(Parser, __webpack_require__(621).EventEmitter);
	
	Parser.prototype._updatePosition = function(initialOffset) {
	    if (this.endIndex === null) {
	        if (this._tokenizer._sectionStart <= initialOffset) {
	            this.startIndex = 0;
	        } else {
	            this.startIndex = this._tokenizer._sectionStart - initialOffset;
	        }
	    } else this.startIndex = this.endIndex + 1;
	    this.endIndex = this._tokenizer.getAbsoluteIndex();
	};
	
	//Tokenizer event handlers
	Parser.prototype.ontext = function(data) {
	    this._updatePosition(1);
	    this.endIndex--;
	
	    if (this._cbs.ontext) this._cbs.ontext(data);
	};
	
	Parser.prototype.onopentagname = function(name) {
	    if (this._lowerCaseTagNames) {
	        name = name.toLowerCase();
	    }
	
	    this._tagname = name;
	
	    if (!this._options.xmlMode && name in openImpliesClose) {
	        for (
	            var el;
	            (el = this._stack[this._stack.length - 1]) in
	            openImpliesClose[name];
	            this.onclosetag(el)
	        );
	    }
	
	    if (this._options.xmlMode || !(name in voidElements)) {
	        this._stack.push(name);
	        if (name in foreignContextElements) this._foreignContext.push(true);
	        else if (name in htmlIntegrationElements)
	            this._foreignContext.push(false);
	    }
	
	    if (this._cbs.onopentagname) this._cbs.onopentagname(name);
	    if (this._cbs.onopentag) this._attribs = {};
	};
	
	Parser.prototype.onopentagend = function() {
	    this._updatePosition(1);
	
	    if (this._attribs) {
	        if (this._cbs.onopentag)
	            this._cbs.onopentag(this._tagname, this._attribs);
	        this._attribs = null;
	    }
	
	    if (
	        !this._options.xmlMode &&
	        this._cbs.onclosetag &&
	        this._tagname in voidElements
	    ) {
	        this._cbs.onclosetag(this._tagname);
	    }
	
	    this._tagname = "";
	};
	
	Parser.prototype.onclosetag = function(name) {
	    this._updatePosition(1);
	
	    if (this._lowerCaseTagNames) {
	        name = name.toLowerCase();
	    }
	    
	    if (name in foreignContextElements || name in htmlIntegrationElements) {
	        this._foreignContext.pop();
	    }
	
	    if (
	        this._stack.length &&
	        (!(name in voidElements) || this._options.xmlMode)
	    ) {
	        var pos = this._stack.lastIndexOf(name);
	        if (pos !== -1) {
	            if (this._cbs.onclosetag) {
	                pos = this._stack.length - pos;
	                while (pos--) this._cbs.onclosetag(this._stack.pop());
	            } else this._stack.length = pos;
	        } else if (name === "p" && !this._options.xmlMode) {
	            this.onopentagname(name);
	            this._closeCurrentTag();
	        }
	    } else if (!this._options.xmlMode && (name === "br" || name === "p")) {
	        this.onopentagname(name);
	        this._closeCurrentTag();
	    }
	};
	
	Parser.prototype.onselfclosingtag = function() {
	    if (
	        this._options.xmlMode ||
	        this._options.recognizeSelfClosing ||
	        this._foreignContext[this._foreignContext.length - 1]
	    ) {
	        this._closeCurrentTag();
	    } else {
	        this.onopentagend();
	    }
	};
	
	Parser.prototype._closeCurrentTag = function() {
	    var name = this._tagname;
	
	    this.onopentagend();
	
	    //self-closing tags will be on the top of the stack
	    //(cheaper check than in onclosetag)
	    if (this._stack[this._stack.length - 1] === name) {
	        if (this._cbs.onclosetag) {
	            this._cbs.onclosetag(name);
	        }
	        this._stack.pop();
	        
	    }
	};
	
	Parser.prototype.onattribname = function(name) {
	    if (this._lowerCaseAttributeNames) {
	        name = name.toLowerCase();
	    }
	    this._attribname = name;
	};
	
	Parser.prototype.onattribdata = function(value) {
	    this._attribvalue += value;
	};
	
	Parser.prototype.onattribend = function() {
	    if (this._cbs.onattribute)
	        this._cbs.onattribute(this._attribname, this._attribvalue);
	    if (
	        this._attribs &&
	        !Object.prototype.hasOwnProperty.call(this._attribs, this._attribname)
	    ) {
	        this._attribs[this._attribname] = this._attribvalue;
	    }
	    this._attribname = "";
	    this._attribvalue = "";
	};
	
	Parser.prototype._getInstructionName = function(value) {
	    var idx = value.search(re_nameEnd),
	        name = idx < 0 ? value : value.substr(0, idx);
	
	    if (this._lowerCaseTagNames) {
	        name = name.toLowerCase();
	    }
	
	    return name;
	};
	
	Parser.prototype.ondeclaration = function(value) {
	    if (this._cbs.onprocessinginstruction) {
	        var name = this._getInstructionName(value);
	        this._cbs.onprocessinginstruction("!" + name, "!" + value);
	    }
	};
	
	Parser.prototype.onprocessinginstruction = function(value) {
	    if (this._cbs.onprocessinginstruction) {
	        var name = this._getInstructionName(value);
	        this._cbs.onprocessinginstruction("?" + name, "?" + value);
	    }
	};
	
	Parser.prototype.oncomment = function(value) {
	    this._updatePosition(4);
	
	    if (this._cbs.oncomment) this._cbs.oncomment(value);
	    if (this._cbs.oncommentend) this._cbs.oncommentend();
	};
	
	Parser.prototype.oncdata = function(value) {
	    this._updatePosition(1);
	
	    if (this._options.xmlMode || this._options.recognizeCDATA) {
	        if (this._cbs.oncdatastart) this._cbs.oncdatastart();
	        if (this._cbs.ontext) this._cbs.ontext(value);
	        if (this._cbs.oncdataend) this._cbs.oncdataend();
	    } else {
	        this.oncomment("[CDATA[" + value + "]]");
	    }
	};
	
	Parser.prototype.onerror = function(err) {
	    if (this._cbs.onerror) this._cbs.onerror(err);
	};
	
	Parser.prototype.onend = function() {
	    if (this._cbs.onclosetag) {
	        for (
	            var i = this._stack.length;
	            i > 0;
	            this._cbs.onclosetag(this._stack[--i])
	        );
	    }
	    if (this._cbs.onend) this._cbs.onend();
	};
	
	//Resets the parser to a blank state, ready to parse a new HTML document
	Parser.prototype.reset = function() {
	    if (this._cbs.onreset) this._cbs.onreset();
	    this._tokenizer.reset();
	
	    this._tagname = "";
	    this._attribname = "";
	    this._attribs = null;
	    this._stack = [];
	
	    if (this._cbs.onparserinit) this._cbs.onparserinit(this);
	};
	
	//Parses a complete HTML document and pushes it to the handler
	Parser.prototype.parseComplete = function(data) {
	    this.reset();
	    this.end(data);
	};
	
	Parser.prototype.write = function(chunk) {
	    this._tokenizer.write(chunk);
	};
	
	Parser.prototype.end = function(chunk) {
	    this._tokenizer.end(chunk);
	};
	
	Parser.prototype.pause = function() {
	    this._tokenizer.pause();
	};
	
	Parser.prototype.resume = function() {
	    this._tokenizer.resume();
	};
	
	//alias for backwards compat
	Parser.prototype.parseChunk = Parser.prototype.write;
	Parser.prototype.done = Parser.prototype.end;
	
	module.exports = Parser;


/***/ }),

/***/ 850:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = ProxyHandler;
	
	function ProxyHandler(cbs) {
	    this._cbs = cbs || {};
	}
	
	var EVENTS = __webpack_require__(87).EVENTS;
	Object.keys(EVENTS).forEach(function(name) {
	    if (EVENTS[name] === 0) {
	        name = "on" + name;
	        ProxyHandler.prototype[name] = function() {
	            if (this._cbs[name]) this._cbs[name]();
	        };
	    } else if (EVENTS[name] === 1) {
	        name = "on" + name;
	        ProxyHandler.prototype[name] = function(a) {
	            if (this._cbs[name]) this._cbs[name](a);
	        };
	    } else if (EVENTS[name] === 2) {
	        name = "on" + name;
	        ProxyHandler.prototype[name] = function(a, b) {
	            if (this._cbs[name]) this._cbs[name](a, b);
	        };
	    } else {
	        throw Error("wrong number of arguments");
	    }
	});


/***/ }),

/***/ 851:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = Stream;
	
	var Parser = __webpack_require__(278);
	
	function Stream(options) {
	    Parser.call(this, new Cbs(this), options);
	}
	
	__webpack_require__(134)(Stream, Parser);
	
	Stream.prototype.readable = true;
	
	function Cbs(scope) {
	    this.scope = scope;
	}
	
	var EVENTS = __webpack_require__(87).EVENTS;
	
	Object.keys(EVENTS).forEach(function(name) {
	    if (EVENTS[name] === 0) {
	        Cbs.prototype["on" + name] = function() {
	            this.scope.emit(name);
	        };
	    } else if (EVENTS[name] === 1) {
	        Cbs.prototype["on" + name] = function(a) {
	            this.scope.emit(name, a);
	        };
	    } else if (EVENTS[name] === 2) {
	        Cbs.prototype["on" + name] = function(a, b) {
	            this.scope.emit(name, a, b);
	        };
	    } else {
	        throw Error("wrong number of arguments!");
	    }
	});


/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = Tokenizer;
	
	var decodeCodePoint = __webpack_require__(268);
	var entityMap = __webpack_require__(186);
	var legacyMap = __webpack_require__(279);
	var xmlMap = __webpack_require__(187);
	
	var i = 0;
	
	var TEXT = i++;
	var BEFORE_TAG_NAME = i++; //after <
	var IN_TAG_NAME = i++;
	var IN_SELF_CLOSING_TAG = i++;
	var BEFORE_CLOSING_TAG_NAME = i++;
	var IN_CLOSING_TAG_NAME = i++;
	var AFTER_CLOSING_TAG_NAME = i++;
	
	//attributes
	var BEFORE_ATTRIBUTE_NAME = i++;
	var IN_ATTRIBUTE_NAME = i++;
	var AFTER_ATTRIBUTE_NAME = i++;
	var BEFORE_ATTRIBUTE_VALUE = i++;
	var IN_ATTRIBUTE_VALUE_DQ = i++; // "
	var IN_ATTRIBUTE_VALUE_SQ = i++; // '
	var IN_ATTRIBUTE_VALUE_NQ = i++;
	
	//declarations
	var BEFORE_DECLARATION = i++; // !
	var IN_DECLARATION = i++;
	
	//processing instructions
	var IN_PROCESSING_INSTRUCTION = i++; // ?
	
	//comments
	var BEFORE_COMMENT = i++;
	var IN_COMMENT = i++;
	var AFTER_COMMENT_1 = i++;
	var AFTER_COMMENT_2 = i++;
	
	//cdata
	var BEFORE_CDATA_1 = i++; // [
	var BEFORE_CDATA_2 = i++; // C
	var BEFORE_CDATA_3 = i++; // D
	var BEFORE_CDATA_4 = i++; // A
	var BEFORE_CDATA_5 = i++; // T
	var BEFORE_CDATA_6 = i++; // A
	var IN_CDATA = i++; // [
	var AFTER_CDATA_1 = i++; // ]
	var AFTER_CDATA_2 = i++; // ]
	
	//special tags
	var BEFORE_SPECIAL = i++; //S
	var BEFORE_SPECIAL_END = i++; //S
	
	var BEFORE_SCRIPT_1 = i++; //C
	var BEFORE_SCRIPT_2 = i++; //R
	var BEFORE_SCRIPT_3 = i++; //I
	var BEFORE_SCRIPT_4 = i++; //P
	var BEFORE_SCRIPT_5 = i++; //T
	var AFTER_SCRIPT_1 = i++; //C
	var AFTER_SCRIPT_2 = i++; //R
	var AFTER_SCRIPT_3 = i++; //I
	var AFTER_SCRIPT_4 = i++; //P
	var AFTER_SCRIPT_5 = i++; //T
	
	var BEFORE_STYLE_1 = i++; //T
	var BEFORE_STYLE_2 = i++; //Y
	var BEFORE_STYLE_3 = i++; //L
	var BEFORE_STYLE_4 = i++; //E
	var AFTER_STYLE_1 = i++; //T
	var AFTER_STYLE_2 = i++; //Y
	var AFTER_STYLE_3 = i++; //L
	var AFTER_STYLE_4 = i++; //E
	
	var BEFORE_ENTITY = i++; //&
	var BEFORE_NUMERIC_ENTITY = i++; //#
	var IN_NAMED_ENTITY = i++;
	var IN_NUMERIC_ENTITY = i++;
	var IN_HEX_ENTITY = i++; //X
	
	var j = 0;
	
	var SPECIAL_NONE = j++;
	var SPECIAL_SCRIPT = j++;
	var SPECIAL_STYLE = j++;
	
	function whitespace(c) {
	    return c === " " || c === "\n" || c === "\t" || c === "\f" || c === "\r";
	}
	
	function ifElseState(upper, SUCCESS, FAILURE) {
	    var lower = upper.toLowerCase();
	
	    if (upper === lower) {
	        return function(c) {
	            if (c === lower) {
	                this._state = SUCCESS;
	            } else {
	                this._state = FAILURE;
	                this._index--;
	            }
	        };
	    } else {
	        return function(c) {
	            if (c === lower || c === upper) {
	                this._state = SUCCESS;
	            } else {
	                this._state = FAILURE;
	                this._index--;
	            }
	        };
	    }
	}
	
	function consumeSpecialNameChar(upper, NEXT_STATE) {
	    var lower = upper.toLowerCase();
	
	    return function(c) {
	        if (c === lower || c === upper) {
	            this._state = NEXT_STATE;
	        } else {
	            this._state = IN_TAG_NAME;
	            this._index--; //consume the token again
	        }
	    };
	}
	
	function Tokenizer(options, cbs) {
	    this._state = TEXT;
	    this._buffer = "";
	    this._sectionStart = 0;
	    this._index = 0;
	    this._bufferOffset = 0; //chars removed from _buffer
	    this._baseState = TEXT;
	    this._special = SPECIAL_NONE;
	    this._cbs = cbs;
	    this._running = true;
	    this._ended = false;
	    this._xmlMode = !!(options && options.xmlMode);
	    this._decodeEntities = !!(options && options.decodeEntities);
	}
	
	Tokenizer.prototype._stateText = function(c) {
	    if (c === "<") {
	        if (this._index > this._sectionStart) {
	            this._cbs.ontext(this._getSection());
	        }
	        this._state = BEFORE_TAG_NAME;
	        this._sectionStart = this._index;
	    } else if (
	        this._decodeEntities &&
	        this._special === SPECIAL_NONE &&
	        c === "&"
	    ) {
	        if (this._index > this._sectionStart) {
	            this._cbs.ontext(this._getSection());
	        }
	        this._baseState = TEXT;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateBeforeTagName = function(c) {
	    if (c === "/") {
	        this._state = BEFORE_CLOSING_TAG_NAME;
	    } else if (c === "<") {
	        this._cbs.ontext(this._getSection());
	        this._sectionStart = this._index;
	    } else if (c === ">" || this._special !== SPECIAL_NONE || whitespace(c)) {
	        this._state = TEXT;
	    } else if (c === "!") {
	        this._state = BEFORE_DECLARATION;
	        this._sectionStart = this._index + 1;
	    } else if (c === "?") {
	        this._state = IN_PROCESSING_INSTRUCTION;
	        this._sectionStart = this._index + 1;
	    } else {
	        this._state =
	            !this._xmlMode && (c === "s" || c === "S")
	                ? BEFORE_SPECIAL
	                : IN_TAG_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInTagName = function(c) {
	    if (c === "/" || c === ">" || whitespace(c)) {
	        this._emitToken("onopentagname");
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateBeforeCloseingTagName = function(c) {
	    if (whitespace(c));
	    else if (c === ">") {
	        this._state = TEXT;
	    } else if (this._special !== SPECIAL_NONE) {
	        if (c === "s" || c === "S") {
	            this._state = BEFORE_SPECIAL_END;
	        } else {
	            this._state = TEXT;
	            this._index--;
	        }
	    } else {
	        this._state = IN_CLOSING_TAG_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInCloseingTagName = function(c) {
	    if (c === ">" || whitespace(c)) {
	        this._emitToken("onclosetag");
	        this._state = AFTER_CLOSING_TAG_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateAfterCloseingTagName = function(c) {
	    //skip everything until ">"
	    if (c === ">") {
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    }
	};
	
	Tokenizer.prototype._stateBeforeAttributeName = function(c) {
	    if (c === ">") {
	        this._cbs.onopentagend();
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (c === "/") {
	        this._state = IN_SELF_CLOSING_TAG;
	    } else if (!whitespace(c)) {
	        this._state = IN_ATTRIBUTE_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInSelfClosingTag = function(c) {
	    if (c === ">") {
	        this._cbs.onselfclosingtag();
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (!whitespace(c)) {
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateInAttributeName = function(c) {
	    if (c === "=" || c === "/" || c === ">" || whitespace(c)) {
	        this._cbs.onattribname(this._getSection());
	        this._sectionStart = -1;
	        this._state = AFTER_ATTRIBUTE_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateAfterAttributeName = function(c) {
	    if (c === "=") {
	        this._state = BEFORE_ATTRIBUTE_VALUE;
	    } else if (c === "/" || c === ">") {
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    } else if (!whitespace(c)) {
	        this._cbs.onattribend();
	        this._state = IN_ATTRIBUTE_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateBeforeAttributeValue = function(c) {
	    if (c === '"') {
	        this._state = IN_ATTRIBUTE_VALUE_DQ;
	        this._sectionStart = this._index + 1;
	    } else if (c === "'") {
	        this._state = IN_ATTRIBUTE_VALUE_SQ;
	        this._sectionStart = this._index + 1;
	    } else if (!whitespace(c)) {
	        this._state = IN_ATTRIBUTE_VALUE_NQ;
	        this._sectionStart = this._index;
	        this._index--; //reconsume token
	    }
	};
	
	Tokenizer.prototype._stateInAttributeValueDoubleQuotes = function(c) {
	    if (c === '"') {
	        this._emitToken("onattribdata");
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	    } else if (this._decodeEntities && c === "&") {
	        this._emitToken("onattribdata");
	        this._baseState = this._state;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInAttributeValueSingleQuotes = function(c) {
	    if (c === "'") {
	        this._emitToken("onattribdata");
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	    } else if (this._decodeEntities && c === "&") {
	        this._emitToken("onattribdata");
	        this._baseState = this._state;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInAttributeValueNoQuotes = function(c) {
	    if (whitespace(c) || c === ">") {
	        this._emitToken("onattribdata");
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    } else if (this._decodeEntities && c === "&") {
	        this._emitToken("onattribdata");
	        this._baseState = this._state;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateBeforeDeclaration = function(c) {
	    this._state =
	        c === "["
	            ? BEFORE_CDATA_1
	            : c === "-"
	                ? BEFORE_COMMENT
	                : IN_DECLARATION;
	};
	
	Tokenizer.prototype._stateInDeclaration = function(c) {
	    if (c === ">") {
	        this._cbs.ondeclaration(this._getSection());
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    }
	};
	
	Tokenizer.prototype._stateInProcessingInstruction = function(c) {
	    if (c === ">") {
	        this._cbs.onprocessinginstruction(this._getSection());
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    }
	};
	
	Tokenizer.prototype._stateBeforeComment = function(c) {
	    if (c === "-") {
	        this._state = IN_COMMENT;
	        this._sectionStart = this._index + 1;
	    } else {
	        this._state = IN_DECLARATION;
	    }
	};
	
	Tokenizer.prototype._stateInComment = function(c) {
	    if (c === "-") this._state = AFTER_COMMENT_1;
	};
	
	Tokenizer.prototype._stateAfterComment1 = function(c) {
	    if (c === "-") {
	        this._state = AFTER_COMMENT_2;
	    } else {
	        this._state = IN_COMMENT;
	    }
	};
	
	Tokenizer.prototype._stateAfterComment2 = function(c) {
	    if (c === ">") {
	        //remove 2 trailing chars
	        this._cbs.oncomment(
	            this._buffer.substring(this._sectionStart, this._index - 2)
	        );
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (c !== "-") {
	        this._state = IN_COMMENT;
	    }
	    // else: stay in AFTER_COMMENT_2 (`--->`)
	};
	
	Tokenizer.prototype._stateBeforeCdata1 = ifElseState(
	    "C",
	    BEFORE_CDATA_2,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata2 = ifElseState(
	    "D",
	    BEFORE_CDATA_3,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata3 = ifElseState(
	    "A",
	    BEFORE_CDATA_4,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata4 = ifElseState(
	    "T",
	    BEFORE_CDATA_5,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata5 = ifElseState(
	    "A",
	    BEFORE_CDATA_6,
	    IN_DECLARATION
	);
	
	Tokenizer.prototype._stateBeforeCdata6 = function(c) {
	    if (c === "[") {
	        this._state = IN_CDATA;
	        this._sectionStart = this._index + 1;
	    } else {
	        this._state = IN_DECLARATION;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateInCdata = function(c) {
	    if (c === "]") this._state = AFTER_CDATA_1;
	};
	
	Tokenizer.prototype._stateAfterCdata1 = function(c) {
	    if (c === "]") this._state = AFTER_CDATA_2;
	    else this._state = IN_CDATA;
	};
	
	Tokenizer.prototype._stateAfterCdata2 = function(c) {
	    if (c === ">") {
	        //remove 2 trailing chars
	        this._cbs.oncdata(
	            this._buffer.substring(this._sectionStart, this._index - 2)
	        );
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (c !== "]") {
	        this._state = IN_CDATA;
	    }
	    //else: stay in AFTER_CDATA_2 (`]]]>`)
	};
	
	Tokenizer.prototype._stateBeforeSpecial = function(c) {
	    if (c === "c" || c === "C") {
	        this._state = BEFORE_SCRIPT_1;
	    } else if (c === "t" || c === "T") {
	        this._state = BEFORE_STYLE_1;
	    } else {
	        this._state = IN_TAG_NAME;
	        this._index--; //consume the token again
	    }
	};
	
	Tokenizer.prototype._stateBeforeSpecialEnd = function(c) {
	    if (this._special === SPECIAL_SCRIPT && (c === "c" || c === "C")) {
	        this._state = AFTER_SCRIPT_1;
	    } else if (this._special === SPECIAL_STYLE && (c === "t" || c === "T")) {
	        this._state = AFTER_STYLE_1;
	    } else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeScript1 = consumeSpecialNameChar(
	    "R",
	    BEFORE_SCRIPT_2
	);
	Tokenizer.prototype._stateBeforeScript2 = consumeSpecialNameChar(
	    "I",
	    BEFORE_SCRIPT_3
	);
	Tokenizer.prototype._stateBeforeScript3 = consumeSpecialNameChar(
	    "P",
	    BEFORE_SCRIPT_4
	);
	Tokenizer.prototype._stateBeforeScript4 = consumeSpecialNameChar(
	    "T",
	    BEFORE_SCRIPT_5
	);
	
	Tokenizer.prototype._stateBeforeScript5 = function(c) {
	    if (c === "/" || c === ">" || whitespace(c)) {
	        this._special = SPECIAL_SCRIPT;
	    }
	    this._state = IN_TAG_NAME;
	    this._index--; //consume the token again
	};
	
	Tokenizer.prototype._stateAfterScript1 = ifElseState("R", AFTER_SCRIPT_2, TEXT);
	Tokenizer.prototype._stateAfterScript2 = ifElseState("I", AFTER_SCRIPT_3, TEXT);
	Tokenizer.prototype._stateAfterScript3 = ifElseState("P", AFTER_SCRIPT_4, TEXT);
	Tokenizer.prototype._stateAfterScript4 = ifElseState("T", AFTER_SCRIPT_5, TEXT);
	
	Tokenizer.prototype._stateAfterScript5 = function(c) {
	    if (c === ">" || whitespace(c)) {
	        this._special = SPECIAL_NONE;
	        this._state = IN_CLOSING_TAG_NAME;
	        this._sectionStart = this._index - 6;
	        this._index--; //reconsume the token
	    } else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeStyle1 = consumeSpecialNameChar(
	    "Y",
	    BEFORE_STYLE_2
	);
	Tokenizer.prototype._stateBeforeStyle2 = consumeSpecialNameChar(
	    "L",
	    BEFORE_STYLE_3
	);
	Tokenizer.prototype._stateBeforeStyle3 = consumeSpecialNameChar(
	    "E",
	    BEFORE_STYLE_4
	);
	
	Tokenizer.prototype._stateBeforeStyle4 = function(c) {
	    if (c === "/" || c === ">" || whitespace(c)) {
	        this._special = SPECIAL_STYLE;
	    }
	    this._state = IN_TAG_NAME;
	    this._index--; //consume the token again
	};
	
	Tokenizer.prototype._stateAfterStyle1 = ifElseState("Y", AFTER_STYLE_2, TEXT);
	Tokenizer.prototype._stateAfterStyle2 = ifElseState("L", AFTER_STYLE_3, TEXT);
	Tokenizer.prototype._stateAfterStyle3 = ifElseState("E", AFTER_STYLE_4, TEXT);
	
	Tokenizer.prototype._stateAfterStyle4 = function(c) {
	    if (c === ">" || whitespace(c)) {
	        this._special = SPECIAL_NONE;
	        this._state = IN_CLOSING_TAG_NAME;
	        this._sectionStart = this._index - 5;
	        this._index--; //reconsume the token
	    } else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeEntity = ifElseState(
	    "#",
	    BEFORE_NUMERIC_ENTITY,
	    IN_NAMED_ENTITY
	);
	Tokenizer.prototype._stateBeforeNumericEntity = ifElseState(
	    "X",
	    IN_HEX_ENTITY,
	    IN_NUMERIC_ENTITY
	);
	
	//for entities terminated with a semicolon
	Tokenizer.prototype._parseNamedEntityStrict = function() {
	    //offset = 1
	    if (this._sectionStart + 1 < this._index) {
	        var entity = this._buffer.substring(
	                this._sectionStart + 1,
	                this._index
	            ),
	            map = this._xmlMode ? xmlMap : entityMap;
	
	        if (map.hasOwnProperty(entity)) {
	            this._emitPartial(map[entity]);
	            this._sectionStart = this._index + 1;
	        }
	    }
	};
	
	//parses legacy entities (without trailing semicolon)
	Tokenizer.prototype._parseLegacyEntity = function() {
	    var start = this._sectionStart + 1,
	        limit = this._index - start;
	
	    if (limit > 6) limit = 6; //the max length of legacy entities is 6
	
	    while (limit >= 2) {
	        //the min length of legacy entities is 2
	        var entity = this._buffer.substr(start, limit);
	
	        if (legacyMap.hasOwnProperty(entity)) {
	            this._emitPartial(legacyMap[entity]);
	            this._sectionStart += limit + 1;
	            return;
	        } else {
	            limit--;
	        }
	    }
	};
	
	Tokenizer.prototype._stateInNamedEntity = function(c) {
	    if (c === ";") {
	        this._parseNamedEntityStrict();
	        if (this._sectionStart + 1 < this._index && !this._xmlMode) {
	            this._parseLegacyEntity();
	        }
	        this._state = this._baseState;
	    } else if (
	        (c < "a" || c > "z") &&
	        (c < "A" || c > "Z") &&
	        (c < "0" || c > "9")
	    ) {
	        if (this._xmlMode);
	        else if (this._sectionStart + 1 === this._index);
	        else if (this._baseState !== TEXT) {
	            if (c !== "=") {
	                this._parseNamedEntityStrict();
	            }
	        } else {
	            this._parseLegacyEntity();
	        }
	
	        this._state = this._baseState;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._decodeNumericEntity = function(offset, base) {
	    var sectionStart = this._sectionStart + offset;
	
	    if (sectionStart !== this._index) {
	        //parse entity
	        var entity = this._buffer.substring(sectionStart, this._index);
	        var parsed = parseInt(entity, base);
	
	        this._emitPartial(decodeCodePoint(parsed));
	        this._sectionStart = this._index;
	    } else {
	        this._sectionStart--;
	    }
	
	    this._state = this._baseState;
	};
	
	Tokenizer.prototype._stateInNumericEntity = function(c) {
	    if (c === ";") {
	        this._decodeNumericEntity(2, 10);
	        this._sectionStart++;
	    } else if (c < "0" || c > "9") {
	        if (!this._xmlMode) {
	            this._decodeNumericEntity(2, 10);
	        } else {
	            this._state = this._baseState;
	        }
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateInHexEntity = function(c) {
	    if (c === ";") {
	        this._decodeNumericEntity(3, 16);
	        this._sectionStart++;
	    } else if (
	        (c < "a" || c > "f") &&
	        (c < "A" || c > "F") &&
	        (c < "0" || c > "9")
	    ) {
	        if (!this._xmlMode) {
	            this._decodeNumericEntity(3, 16);
	        } else {
	            this._state = this._baseState;
	        }
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._cleanup = function() {
	    if (this._sectionStart < 0) {
	        this._buffer = "";
	        this._bufferOffset += this._index;
	        this._index = 0;
	    } else if (this._running) {
	        if (this._state === TEXT) {
	            if (this._sectionStart !== this._index) {
	                this._cbs.ontext(this._buffer.substr(this._sectionStart));
	            }
	            this._buffer = "";
	            this._bufferOffset += this._index;
	            this._index = 0;
	        } else if (this._sectionStart === this._index) {
	            //the section just started
	            this._buffer = "";
	            this._bufferOffset += this._index;
	            this._index = 0;
	        } else {
	            //remove everything unnecessary
	            this._buffer = this._buffer.substr(this._sectionStart);
	            this._index -= this._sectionStart;
	            this._bufferOffset += this._sectionStart;
	        }
	
	        this._sectionStart = 0;
	    }
	};
	
	//TODO make events conditional
	Tokenizer.prototype.write = function(chunk) {
	    if (this._ended) this._cbs.onerror(Error(".write() after done!"));
	
	    this._buffer += chunk;
	    this._parse();
	};
	
	Tokenizer.prototype._parse = function() {
	    while (this._index < this._buffer.length && this._running) {
	        var c = this._buffer.charAt(this._index);
	        if (this._state === TEXT) {
	            this._stateText(c);
	        } else if (this._state === BEFORE_TAG_NAME) {
	            this._stateBeforeTagName(c);
	        } else if (this._state === IN_TAG_NAME) {
	            this._stateInTagName(c);
	        } else if (this._state === BEFORE_CLOSING_TAG_NAME) {
	            this._stateBeforeCloseingTagName(c);
	        } else if (this._state === IN_CLOSING_TAG_NAME) {
	            this._stateInCloseingTagName(c);
	        } else if (this._state === AFTER_CLOSING_TAG_NAME) {
	            this._stateAfterCloseingTagName(c);
	        } else if (this._state === IN_SELF_CLOSING_TAG) {
	            this._stateInSelfClosingTag(c);
	        } else if (this._state === BEFORE_ATTRIBUTE_NAME) {
	
	        /*
			*	attributes
			*/
	            this._stateBeforeAttributeName(c);
	        } else if (this._state === IN_ATTRIBUTE_NAME) {
	            this._stateInAttributeName(c);
	        } else if (this._state === AFTER_ATTRIBUTE_NAME) {
	            this._stateAfterAttributeName(c);
	        } else if (this._state === BEFORE_ATTRIBUTE_VALUE) {
	            this._stateBeforeAttributeValue(c);
	        } else if (this._state === IN_ATTRIBUTE_VALUE_DQ) {
	            this._stateInAttributeValueDoubleQuotes(c);
	        } else if (this._state === IN_ATTRIBUTE_VALUE_SQ) {
	            this._stateInAttributeValueSingleQuotes(c);
	        } else if (this._state === IN_ATTRIBUTE_VALUE_NQ) {
	            this._stateInAttributeValueNoQuotes(c);
	        } else if (this._state === BEFORE_DECLARATION) {
	
	        /*
			*	declarations
			*/
	            this._stateBeforeDeclaration(c);
	        } else if (this._state === IN_DECLARATION) {
	            this._stateInDeclaration(c);
	        } else if (this._state === IN_PROCESSING_INSTRUCTION) {
	
	        /*
			*	processing instructions
			*/
	            this._stateInProcessingInstruction(c);
	        } else if (this._state === BEFORE_COMMENT) {
	
	        /*
			*	comments
			*/
	            this._stateBeforeComment(c);
	        } else if (this._state === IN_COMMENT) {
	            this._stateInComment(c);
	        } else if (this._state === AFTER_COMMENT_1) {
	            this._stateAfterComment1(c);
	        } else if (this._state === AFTER_COMMENT_2) {
	            this._stateAfterComment2(c);
	        } else if (this._state === BEFORE_CDATA_1) {
	
	        /*
			*	cdata
			*/
	            this._stateBeforeCdata1(c);
	        } else if (this._state === BEFORE_CDATA_2) {
	            this._stateBeforeCdata2(c);
	        } else if (this._state === BEFORE_CDATA_3) {
	            this._stateBeforeCdata3(c);
	        } else if (this._state === BEFORE_CDATA_4) {
	            this._stateBeforeCdata4(c);
	        } else if (this._state === BEFORE_CDATA_5) {
	            this._stateBeforeCdata5(c);
	        } else if (this._state === BEFORE_CDATA_6) {
	            this._stateBeforeCdata6(c);
	        } else if (this._state === IN_CDATA) {
	            this._stateInCdata(c);
	        } else if (this._state === AFTER_CDATA_1) {
	            this._stateAfterCdata1(c);
	        } else if (this._state === AFTER_CDATA_2) {
	            this._stateAfterCdata2(c);
	        } else if (this._state === BEFORE_SPECIAL) {
	
	        /*
			* special tags
			*/
	            this._stateBeforeSpecial(c);
	        } else if (this._state === BEFORE_SPECIAL_END) {
	            this._stateBeforeSpecialEnd(c);
	        } else if (this._state === BEFORE_SCRIPT_1) {
	
	        /*
			* script
			*/
	            this._stateBeforeScript1(c);
	        } else if (this._state === BEFORE_SCRIPT_2) {
	            this._stateBeforeScript2(c);
	        } else if (this._state === BEFORE_SCRIPT_3) {
	            this._stateBeforeScript3(c);
	        } else if (this._state === BEFORE_SCRIPT_4) {
	            this._stateBeforeScript4(c);
	        } else if (this._state === BEFORE_SCRIPT_5) {
	            this._stateBeforeScript5(c);
	        } else if (this._state === AFTER_SCRIPT_1) {
	            this._stateAfterScript1(c);
	        } else if (this._state === AFTER_SCRIPT_2) {
	            this._stateAfterScript2(c);
	        } else if (this._state === AFTER_SCRIPT_3) {
	            this._stateAfterScript3(c);
	        } else if (this._state === AFTER_SCRIPT_4) {
	            this._stateAfterScript4(c);
	        } else if (this._state === AFTER_SCRIPT_5) {
	            this._stateAfterScript5(c);
	        } else if (this._state === BEFORE_STYLE_1) {
	
	        /*
			* style
			*/
	            this._stateBeforeStyle1(c);
	        } else if (this._state === BEFORE_STYLE_2) {
	            this._stateBeforeStyle2(c);
	        } else if (this._state === BEFORE_STYLE_3) {
	            this._stateBeforeStyle3(c);
	        } else if (this._state === BEFORE_STYLE_4) {
	            this._stateBeforeStyle4(c);
	        } else if (this._state === AFTER_STYLE_1) {
	            this._stateAfterStyle1(c);
	        } else if (this._state === AFTER_STYLE_2) {
	            this._stateAfterStyle2(c);
	        } else if (this._state === AFTER_STYLE_3) {
	            this._stateAfterStyle3(c);
	        } else if (this._state === AFTER_STYLE_4) {
	            this._stateAfterStyle4(c);
	        } else if (this._state === BEFORE_ENTITY) {
	
	        /*
			* entities
			*/
	            this._stateBeforeEntity(c);
	        } else if (this._state === BEFORE_NUMERIC_ENTITY) {
	            this._stateBeforeNumericEntity(c);
	        } else if (this._state === IN_NAMED_ENTITY) {
	            this._stateInNamedEntity(c);
	        } else if (this._state === IN_NUMERIC_ENTITY) {
	            this._stateInNumericEntity(c);
	        } else if (this._state === IN_HEX_ENTITY) {
	            this._stateInHexEntity(c);
	        } else {
	            this._cbs.onerror(Error("unknown _state"), this._state);
	        }
	
	        this._index++;
	    }
	
	    this._cleanup();
	};
	
	Tokenizer.prototype.pause = function() {
	    this._running = false;
	};
	Tokenizer.prototype.resume = function() {
	    this._running = true;
	
	    if (this._index < this._buffer.length) {
	        this._parse();
	    }
	    if (this._ended) {
	        this._finish();
	    }
	};
	
	Tokenizer.prototype.end = function(chunk) {
	    if (this._ended) this._cbs.onerror(Error(".end() after done!"));
	    if (chunk) this.write(chunk);
	
	    this._ended = true;
	
	    if (this._running) this._finish();
	};
	
	Tokenizer.prototype._finish = function() {
	    //if there is remaining data, emit it in a reasonable way
	    if (this._sectionStart < this._index) {
	        this._handleTrailingData();
	    }
	
	    this._cbs.onend();
	};
	
	Tokenizer.prototype._handleTrailingData = function() {
	    var data = this._buffer.substr(this._sectionStart);
	
	    if (
	        this._state === IN_CDATA ||
	        this._state === AFTER_CDATA_1 ||
	        this._state === AFTER_CDATA_2
	    ) {
	        this._cbs.oncdata(data);
	    } else if (
	        this._state === IN_COMMENT ||
	        this._state === AFTER_COMMENT_1 ||
	        this._state === AFTER_COMMENT_2
	    ) {
	        this._cbs.oncomment(data);
	    } else if (this._state === IN_NAMED_ENTITY && !this._xmlMode) {
	        this._parseLegacyEntity();
	        if (this._sectionStart < this._index) {
	            this._state = this._baseState;
	            this._handleTrailingData();
	        }
	    } else if (this._state === IN_NUMERIC_ENTITY && !this._xmlMode) {
	        this._decodeNumericEntity(2, 10);
	        if (this._sectionStart < this._index) {
	            this._state = this._baseState;
	            this._handleTrailingData();
	        }
	    } else if (this._state === IN_HEX_ENTITY && !this._xmlMode) {
	        this._decodeNumericEntity(3, 16);
	        if (this._sectionStart < this._index) {
	            this._state = this._baseState;
	            this._handleTrailingData();
	        }
	    } else if (
	        this._state !== IN_TAG_NAME &&
	        this._state !== BEFORE_ATTRIBUTE_NAME &&
	        this._state !== BEFORE_ATTRIBUTE_VALUE &&
	        this._state !== AFTER_ATTRIBUTE_NAME &&
	        this._state !== IN_ATTRIBUTE_NAME &&
	        this._state !== IN_ATTRIBUTE_VALUE_SQ &&
	        this._state !== IN_ATTRIBUTE_VALUE_DQ &&
	        this._state !== IN_ATTRIBUTE_VALUE_NQ &&
	        this._state !== IN_CLOSING_TAG_NAME
	    ) {
	        this._cbs.ontext(data);
	    }
	    //else, ignore remaining data
	    //TODO add a way to remove current tag
	};
	
	Tokenizer.prototype.reset = function() {
	    Tokenizer.call(
	        this,
	        { xmlMode: this._xmlMode, decodeEntities: this._decodeEntities },
	        this._cbs
	    );
	};
	
	Tokenizer.prototype.getAbsoluteIndex = function() {
	    return this._bufferOffset + this._index;
	};
	
	Tokenizer.prototype._getSection = function() {
	    return this._buffer.substring(this._sectionStart, this._index);
	};
	
	Tokenizer.prototype._emitToken = function(name) {
	    this._cbs[name](this._getSection());
	    this._sectionStart = -1;
	};
	
	Tokenizer.prototype._emitPartial = function(value) {
	    if (this._baseState !== TEXT) {
	        this._cbs.onattribdata(value); //TODO implement the new event
	    } else {
	        this._cbs.ontext(value);
	    }
	};


/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = Stream;
	
	var Parser = __webpack_require__(276);
	var WritableStream = __webpack_require__(1178).Writable;
	var StringDecoder = __webpack_require__(1161).StringDecoder;
	var Buffer = __webpack_require__(210).Buffer;
	
	function Stream(cbs, options) {
	    var parser = (this._parser = new Parser(cbs, options));
	    var decoder = (this._decoder = new StringDecoder());
	
	    WritableStream.call(this, { decodeStrings: false });
	
	    this.once("finish", function() {
	        parser.end(decoder.end());
	    });
	}
	
	__webpack_require__(134)(Stream, WritableStream);
	
	Stream.prototype._write = function(chunk, encoding, cb) {
	    if (chunk instanceof Buffer) chunk = this._decoder.write(chunk);
	    this._parser.write(chunk);
	    cb();
	};


/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

	var Parser = __webpack_require__(276);
	var DomHandler = __webpack_require__(264);
	
	function defineProp(name, value) {
	    delete module.exports[name];
	    module.exports[name] = value;
	    return value;
	}
	
	module.exports = {
	    Parser: Parser,
	    Tokenizer: __webpack_require__(277),
	    ElementType: __webpack_require__(86),
	    DomHandler: DomHandler,
	    get FeedHandler() {
	        return defineProp("FeedHandler", __webpack_require__(849));
	    },
	    get Stream() {
	        return defineProp("Stream", __webpack_require__(851));
	    },
	    get WritableStream() {
	        return defineProp("WritableStream", __webpack_require__(278));
	    },
	    get ProxyHandler() {
	        return defineProp("ProxyHandler", __webpack_require__(850));
	    },
	    get DomUtils() {
	        return defineProp("DomUtils", __webpack_require__(266));
	    },
	    get CollectingHandler() {
	        return defineProp(
	            "CollectingHandler",
	            __webpack_require__(848)
	        );
	    },
	    // For legacy support
	    DefaultHandler: DomHandler,
	    get RssHandler() {
	        return defineProp("RssHandler", this.FeedHandler);
	    },
	    //helper methods
	    parseDOM: function(data, options) {
	        var handler = new DomHandler(options);
	        new Parser(handler, options).end(data);
	        return handler.dom;
	    },
	    parseFeed: function(feed, options) {
	        var handler = new module.exports.FeedHandler(options);
	        new Parser(handler, options).end(feed);
	        return handler.dom;
	    },
	    createDomStream: function(cb, options, elementCb) {
	        var handler = new DomHandler(cb, options, elementCb);
	        return new Parser(handler, options);
	    },
	    // List of all events that the parser emits
	    EVENTS: {
	        /* Format: eventname: number of arguments */
	        attribute: 2,
	        cdatastart: 0,
	        cdataend: 0,
	        text: 1,
	        processinginstruction: 2,
	        comment: 1,
	        commentend: 0,
	        closetag: 1,
	        opentag: 2,
	        opentagname: 1,
	        error: 1,
	        end: 0
	    }
	};


/***/ }),

/***/ 852:
/***/ (function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),

/***/ 134:
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ }),

/***/ 1101:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HtmlParser;
	
	var _htmlparser = __webpack_require__(87);
	
	var _htmlparser2 = _interopRequireDefault(_htmlparser);
	
	var _processNodes = __webpack_require__(189);
	
	var _processNodes2 = _interopRequireDefault(_processNodes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Parses a HTML string and returns a list of React components generated from it
	 *
	 * @param {String} html The HTML to convert into React component
	 * @param {Object} options Options to pass
	 * @returns {Array} List of top level React elements
	 */
	function HtmlParser(html) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$decodeEntities = _ref.decodeEntities,
	      decodeEntities = _ref$decodeEntities === undefined ? true : _ref$decodeEntities,
	      transform = _ref.transform,
	      _ref$preprocessNodes = _ref.preprocessNodes,
	      preprocessNodes = _ref$preprocessNodes === undefined ? function (nodes) {
	    return nodes;
	  } : _ref$preprocessNodes;
	
	  var nodes = preprocessNodes(_htmlparser2.default.parseDOM(html, { decodeEntities: decodeEntities }));
	  return (0, _processNodes2.default)(nodes, transform);
	}

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = convertNodeToElement;
	
	var _elementTypes = __webpack_require__(1109);
	
	var _elementTypes2 = _interopRequireDefault(_elementTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Converts a htmlparser2 node to a React element
	 *
	 * @param {Object} node The htmlparser2 node to convert
	 * @param {Number} index The index of the current node
	 * @param {Function} transform Transform function to apply to children of the node
	 * @returns {React.Element}
	 */
	function convertNodeToElement(node, index, transform) {
	  return _elementTypes2.default[node.type](node, index, transform);
	}

/***/ }),

/***/ 1102:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * List of boolean attributes
	 * These attributes should have their React attribute value set to be the same as their name
	 * E.g. <input disabled> = <input disabled>
	 *      <input disabled=""> = <input disabled>
	 *      <input disabled="disabled"> = <input disabled>
	 * @type {Array}
	 */
	exports.default = ['allowfullScreen', 'async', 'autoplay', 'capture', 'checked', 'controls', 'default', 'defer', 'disabled', 'formnovalidate', 'hidden', 'loop', 'multiple', 'muted', 'novalidate', 'open', 'playsinline', 'readonly', 'required', 'reversed', 'scoped', 'seamless', 'selected', 'itemscope'];

/***/ }),

/***/ 1103:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Mapping of standard HTML attributes to their React counterparts
	 * List taken and reversed from react/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
	 * https://github.com/facebook/react/blob/c9c3c339b757682f1154f1c915eb55e6a8766933/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
	 * @type {Object}
	 */
	exports.default = {
	  /**
	   * Standard Properties
	   */
	  accept: 'accept',
	  'accept-charset': 'acceptCharset',
	  accesskey: 'accessKey',
	  action: 'action',
	  allowfullscreen: 'allowFullScreen',
	  allowtransparency: 'allowTransparency',
	  alt: 'alt',
	  as: 'as',
	  async: 'async',
	  autocomplete: 'autoComplete',
	  autoplay: 'autoPlay',
	  capture: 'capture',
	  cellpadding: 'cellPadding',
	  cellspacing: 'cellSpacing',
	  charset: 'charSet',
	  challenge: 'challenge',
	  checked: 'checked',
	  cite: 'cite',
	  classid: 'classID',
	  class: 'className',
	  cols: 'cols',
	  colspan: 'colSpan',
	  content: 'content',
	  contenteditable: 'contentEditable',
	  contextmenu: 'contextMenu',
	  controls: 'controls',
	  controlsList: 'controlsList',
	  coords: 'coords',
	  crossorigin: 'crossOrigin',
	  data: 'data',
	  datetime: 'dateTime',
	  default: 'default',
	  defer: 'defer',
	  dir: 'dir',
	  disabled: 'disabled',
	  download: 'download',
	  draggable: 'draggable',
	  enctype: 'encType',
	  form: 'form',
	  formaction: 'formAction',
	  formenctype: 'formEncType',
	  formmethod: 'formMethod',
	  formnovalidate: 'formNoValidate',
	  formtarget: 'formTarget',
	  frameborder: 'frameBorder',
	  headers: 'headers',
	  height: 'height',
	  hidden: 'hidden',
	  high: 'high',
	  href: 'href',
	  hreflang: 'hrefLang',
	  for: 'htmlFor',
	  'http-equiv': 'httpEquiv',
	  icon: 'icon',
	  id: 'id',
	  inputmode: 'inputMode',
	  integrity: 'integrity',
	  is: 'is',
	  keyparams: 'keyParams',
	  keytype: 'keyType',
	  kind: 'kind',
	  label: 'label',
	  lang: 'lang',
	  list: 'list',
	  loop: 'loop',
	  low: 'low',
	  manifest: 'manifest',
	  marginheight: 'marginHeight',
	  marginwidth: 'marginWidth',
	  max: 'max',
	  maxlength: 'maxLength',
	  media: 'media',
	  mediagroup: 'mediaGroup',
	  method: 'method',
	  min: 'min',
	  minlength: 'minLength',
	  multiple: 'multiple',
	  muted: 'muted',
	  name: 'name',
	  nonce: 'nonce',
	  novalidate: 'noValidate',
	  open: 'open',
	  optimum: 'optimum',
	  pattern: 'pattern',
	  placeholder: 'placeholder',
	  playsinline: 'playsInline',
	  poster: 'poster',
	  preload: 'preload',
	  profile: 'profile',
	  radiogroup: 'radioGroup',
	  readonly: 'readOnly',
	  referrerpolicy: 'referrerPolicy',
	  rel: 'rel',
	  required: 'required',
	  reversed: 'reversed',
	  role: 'role',
	  rows: 'rows',
	  rowspan: 'rowSpan',
	  sandbox: 'sandbox',
	  scope: 'scope',
	  scoped: 'scoped',
	  scrolling: 'scrolling',
	  seamless: 'seamless',
	  selected: 'selected',
	  shape: 'shape',
	  size: 'size',
	  sizes: 'sizes',
	  slot: 'slot',
	  span: 'span',
	  spellcheck: 'spellCheck',
	  src: 'src',
	  srcdoc: 'srcDoc',
	  srclang: 'srcLang',
	  srcset: 'srcSet',
	  start: 'start',
	  step: 'step',
	  style: 'style',
	  summary: 'summary',
	  tabindex: 'tabIndex',
	  target: 'target',
	  title: 'title',
	  type: 'type',
	  usemap: 'useMap',
	  value: 'value',
	  width: 'width',
	  wmode: 'wmode',
	  wrap: 'wrap',
	  /**
	   * RDFa Properties
	   */
	  about: 'about',
	  datatype: 'datatype',
	  inlist: 'inlist',
	  prefix: 'prefix',
	  property: 'property',
	  resource: 'resource',
	  typeof: 'typeof',
	  vocab: 'vocab',
	  /**
	   * Non-standard Properties
	   */
	  autocapitalize: 'autoCapitalize',
	  autocorrect: 'autoCorrect',
	  autosave: 'autoSave',
	  color: 'color',
	  itemprop: 'itemProp',
	  itemscope: 'itemScope',
	  itemtype: 'itemType',
	  itemid: 'itemID',
	  itemref: 'itemRef',
	  results: 'results',
	  security: 'security',
	  unselectable: 'unselectable'
	};

/***/ }),

/***/ 1104:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * List of void elements
	 * These elements are not allowed to have children
	 * @type {Array}
	 */
	exports.default = ['area', 'base', 'br', 'col', 'command', 'embed', 'hr', 'img', 'input', 'keygen', 'link', 'meta', 'param', 'source', 'track', 'wbr'];

/***/ }),

/***/ 1105:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = StyleElementType;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _generatePropsFromAttributes = __webpack_require__(283);
	
	var _generatePropsFromAttributes2 = _interopRequireDefault(_generatePropsFromAttributes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Converts a <style> element to a React element
	 *
	 * @param {Object} node The style node
	 * @param {String} index The index of the React element relative to it's parent
	 * @returns {React.Element} The React style element
	 */
	function StyleElementType(node, index) {
	
	  // The style element only ever has a single child which is the styles so try and find this to add as
	  // a child to the style element that will be created
	  var styles = void 0;
	  if (node.children.length > 0) {
	    styles = node.children[0].data;
	  }
	
	  // generate props
	  var props = (0, _generatePropsFromAttributes2.default)(node.attribs, index);
	
	  // create and return the element
	  return _react2.default.createElement('style', props, styles);
	}

/***/ }),

/***/ 1106:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TagElementType;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _processNodes = __webpack_require__(189);
	
	var _processNodes2 = _interopRequireDefault(_processNodes);
	
	var _generatePropsFromAttributes = __webpack_require__(283);
	
	var _generatePropsFromAttributes2 = _interopRequireDefault(_generatePropsFromAttributes);
	
	var _VoidElements = __webpack_require__(1104);
	
	var _VoidElements2 = _interopRequireDefault(_VoidElements);
	
	var _isValidTagOrAttributeName = __webpack_require__(284);
	
	var _isValidTagOrAttributeName2 = _interopRequireDefault(_isValidTagOrAttributeName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Converts any element (excluding style - see StyleElementType - and script) to a react element.
	 *
	 * @param {Object} node The tag node
	 * @param {String} index The index of the React element relative to it's parent
	 * @param {Function} transform The transform function to apply to all children
	 * @returns {React.Element} The React tag element
	 */
	function TagElementType(node, index, transform) {
	
	  var tagName = node.name;
	
	  // validate tag name
	  if (!(0, _isValidTagOrAttributeName2.default)(tagName)) {
	    return null;
	  }
	
	  // generate props
	  var props = (0, _generatePropsFromAttributes2.default)(node.attribs, index);
	
	  // If the node is not a void element and has children then process them
	  var children = null;
	  if (_VoidElements2.default.indexOf(tagName) === -1) {
	    children = (0, _processNodes2.default)(node.children, transform);
	  }
	
	  // create and return the element
	  return _react2.default.createElement(tagName, props, children);
	}

/***/ }),

/***/ 1107:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TextElementType;
	/**
	 * Converts a text node to a React text element
	 *
	 * @param {Object} node The text node
	 * @returns {String} The text
	 */
	function TextElementType(node) {
	
	  // React will accept plain text for rendering so just return the node data
	  return node.data;
	}

/***/ }),

/***/ 1108:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = UnsupportedElementType;
	/**
	 * Handles an unsupported element type by returning null so nothing is rendered
	 * @returns {null}
	 */
	function UnsupportedElementType() {
	
	  // do nothing because the element type is unsupported
	  // comment, directive, script, cdata, doctype are all currently unsupported
	  return null;
	}

/***/ }),

/***/ 1109:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ElementType$Text$Ele;
	
	var _htmlparser = __webpack_require__(87);
	
	var _TextElementType = __webpack_require__(1107);
	
	var _TextElementType2 = _interopRequireDefault(_TextElementType);
	
	var _TagElementType = __webpack_require__(1106);
	
	var _TagElementType2 = _interopRequireDefault(_TagElementType);
	
	var _StyleElementType = __webpack_require__(1105);
	
	var _StyleElementType2 = _interopRequireDefault(_StyleElementType);
	
	var _UnsupportedElementType = __webpack_require__(1108);
	
	var _UnsupportedElementType2 = _interopRequireDefault(_UnsupportedElementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*
	                                                                                                                                                                                                                   * Map each htmlparser2 element type to a function which will convert that element type to a React element
	                                                                                                                                                                                                                   * Not all of the element types are supported so the UnsupportedElementType is used for them which will not return any
	                                                                                                                                                                                                                   * value
	                                                                                                                                                                                                                   */
	
	exports.default = (_ElementType$Text$Ele = {}, _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Text, _TextElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Tag, _TagElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Style, _StyleElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Directive, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Comment, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Script, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.CDATA, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Doctype, _UnsupportedElementType2.default), _ElementType$Text$Ele);

/***/ }),

/***/ 1110:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.htmlparser2 = exports.convertNodeToElement = exports.processNodes = undefined;
	
	var _processNodes = __webpack_require__(189);
	
	Object.defineProperty(exports, 'processNodes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_processNodes).default;
	  }
	});
	
	var _convertNodeToElement = __webpack_require__(282);
	
	Object.defineProperty(exports, 'convertNodeToElement', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_convertNodeToElement).default;
	  }
	});
	
	var _htmlparser = __webpack_require__(87);
	
	Object.defineProperty(exports, 'htmlparser2', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_htmlparser).default;
	  }
	});
	
	var _HtmlParser = __webpack_require__(1101);
	
	var _HtmlParser2 = _interopRequireDefault(_HtmlParser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _HtmlParser2.default;

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = processNodes;
	
	var _isEmptyTextNode = __webpack_require__(1113);
	
	var _isEmptyTextNode2 = _interopRequireDefault(_isEmptyTextNode);
	
	var _convertNodeToElement = __webpack_require__(282);
	
	var _convertNodeToElement2 = _interopRequireDefault(_convertNodeToElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Processes the nodes generated by htmlparser2 and convert them all into React elements
	 *
	 * @param {Object[]} nodes List of nodes to process
	 * @param {Function} transform Transform function to optionally apply to nodes
	 * @returns {React.Element[]} The list of processed React elements
	 */
	function processNodes(nodes, transform) {
	
	  return nodes.filter(function (node) {
	    return !(0, _isEmptyTextNode2.default)(node);
	  }).map(function (node, index) {
	
	    // return the result of the transform function if applicable
	    var transformed = void 0;
	    if (typeof transform === 'function') {
	      transformed = transform(node, index);
	      if (transformed === null || !!transformed) {
	        return transformed;
	      }
	    }
	
	    // otherwise convert the node as standard
	    return (0, _convertNodeToElement2.default)(node, index, transform);
	  });
	}

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = generatePropsFromAttributes;
	
	var _htmlAttributesToReact = __webpack_require__(1111);
	
	var _htmlAttributesToReact2 = _interopRequireDefault(_htmlAttributesToReact);
	
	var _inlineStyleToObject = __webpack_require__(1112);
	
	var _inlineStyleToObject2 = _interopRequireDefault(_inlineStyleToObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Generates props for a React element from an object of HTML attributes
	 *
	 * @param {Object} attributes The HTML attributes
	 * @param {String} key The key to give the react element
	 */
	function generatePropsFromAttributes(attributes, key) {
	
	  // generate props
	  var props = _extends({}, (0, _htmlAttributesToReact2.default)(attributes), { key: key });
	
	  // if there is an inline/string style prop then convert it to a React style object
	  // otherwise, it is invalid and omitted
	  if (typeof props.style === 'string' || props.style instanceof String) {
	    props.style = (0, _inlineStyleToObject2.default)(props.style);
	  } else {
	    delete props.style;
	  }
	
	  return props;
	}

/***/ }),

/***/ 1111:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = htmlAttributesToReact;
	
	var _BooleanAttributes = __webpack_require__(1102);
	
	var _BooleanAttributes2 = _interopRequireDefault(_BooleanAttributes);
	
	var _ReactAttributes = __webpack_require__(1103);
	
	var _ReactAttributes2 = _interopRequireDefault(_ReactAttributes);
	
	var _isValidTagOrAttributeName = __webpack_require__(284);
	
	var _isValidTagOrAttributeName2 = _interopRequireDefault(_isValidTagOrAttributeName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns the parsed attribute value taking into account things like boolean attributes
	 *
	 * @param {String} attribute The name of the attribute
	 * @param {*} value The value of the attribute from the HTML
	 * @returns {*} The parsed attribute value
	 */
	var getParsedAttributeValue = function getParsedAttributeValue(attribute, value) {
	
	  // if the attribute if a boolean then it's value should be the same as it's name
	  // e.g. disabled="disabled"
	  var lowerBooleanAttributes = _BooleanAttributes2.default.map(function (attr) {
	    return attr.toLowerCase();
	  });
	  if (lowerBooleanAttributes.indexOf(attribute.toLowerCase()) >= 0) {
	    value = attribute;
	  }
	
	  return value;
	};
	
	/**
	 * Takes an object of standard HTML property names and converts them to their React counterpart. If the react
	 * version does not exist for an attribute then just use it as it is
	 *
	 * @param {Object} attributes The HTML attributes to convert
	 * @returns {Object} The React attributes
	 */
	function htmlAttributesToReact(attributes) {
	
	  return Object.keys(attributes).filter(function (attr) {
	    return (0, _isValidTagOrAttributeName2.default)(attr);
	  }).reduce(function (mappedAttributes, attribute) {
	
	    // lowercase the attribute name and find it in the react attribute map
	    var lowerCaseAttribute = attribute.toLowerCase();
	
	    // format the attribute name
	    var name = _ReactAttributes2.default[lowerCaseAttribute] || lowerCaseAttribute;
	
	    // add the parsed attribute value to the mapped attributes
	    mappedAttributes[name] = getParsedAttributeValue(name, attributes[attribute]);
	
	    return mappedAttributes;
	  }, {});
	}

/***/ }),

/***/ 1112:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = InlineStyleToObject;
	/**
	 * Converts an inline style string into an object of React style properties
	 *
	 * @param {String} inlineStyle='' The inline style to convert
	 * @returns {Object} The converted style
	 */
	function InlineStyleToObject() {
	  var inlineStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	
	  // just return empty object if the inlineStyle is empty
	  if (inlineStyle === '') {
	    return {};
	  }
	
	  return inlineStyle.split(';').reduce(function (styleObject, stylePropertyValue) {
	
	    // extract the style property name and value
	    var _stylePropertyValue$s = stylePropertyValue.split(/^([^:]+):/).filter(function (val, i) {
	      return i > 0;
	    }).map(function (item) {
	      return item.trim().toLowerCase();
	    }),
	        _stylePropertyValue$s2 = _slicedToArray(_stylePropertyValue$s, 2),
	        property = _stylePropertyValue$s2[0],
	        value = _stylePropertyValue$s2[1];
	
	    // if there is no value (i.e. no : in the style) then ignore it
	
	
	    if (value === undefined) {
	      return styleObject;
	    }
	
	    // convert the property name into the correct React format
	    // remove all hyphens and convert the letter immediately after each hyphen to upper case
	    // additionally don't uppercase any -ms- prefix
	    // e.g. -ms-style-property = msStyleProperty
	    //      -webkit-style-property = WebkitStyleProperty
	    property = property.replace(/^-ms-/, 'ms-').replace(/-(.)/g, function (_, character) {
	      return character.toUpperCase();
	    });
	
	    // add the new style property and value to the style object
	    styleObject[property] = value;
	
	    return styleObject;
	  }, {});
	}

/***/ }),

/***/ 1113:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEmptyTextNode;
	/**
	 * Tests a htmlparser2 node and returns whether is it a text node at the start and end of the line containing only
	 * white space. This allows these node types to be excluded from the rendering because they are unnecessary.
	 *
	 * @param {Object} node The element object as created by htmlparser2
	 * @returns {boolean} Whether the node is an empty text node
	 */
	function isEmptyTextNode(node) {
	  return node.type === 'text' && /\r?\n/.test(node.data) && node.data.trim() === '';
	}

/***/ }),

/***/ 284:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValidTagOrAttributeName;
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/;
	
	var nameCache = {};
	
	function isValidTagOrAttributeName(tagName) {
	  if (!nameCache.hasOwnProperty(tagName)) {
	    nameCache[tagName] = VALID_TAG_REGEX.test(tagName);
	  }
	  return nameCache[tagName];
	}

/***/ }),

/***/ 1161:
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var Buffer = __webpack_require__(210).Buffer;
	
	var isBufferEncoding = Buffer.isEncoding
	  || function(encoding) {
	       switch (encoding && encoding.toLowerCase()) {
	         case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
	         default: return false;
	       }
	     }
	
	
	function assertEncoding(encoding) {
	  if (encoding && !isBufferEncoding(encoding)) {
	    throw new Error('Unknown encoding: ' + encoding);
	  }
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters. CESU-8 is handled as part of the UTF-8 encoding.
	//
	// @TODO Handling all encodings inside a single object makes it very difficult
	// to reason about this code, so it should be split up in the future.
	// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
	// points as used by CESU-8.
	var StringDecoder = exports.StringDecoder = function(encoding) {
	  this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
	  assertEncoding(encoding);
	  switch (this.encoding) {
	    case 'utf8':
	      // CESU-8 represents each of Surrogate Pair by 3-bytes
	      this.surrogateSize = 3;
	      break;
	    case 'ucs2':
	    case 'utf16le':
	      // UTF-16 represents each of Surrogate Pair by 2-bytes
	      this.surrogateSize = 2;
	      this.detectIncompleteChar = utf16DetectIncompleteChar;
	      break;
	    case 'base64':
	      // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
	      this.surrogateSize = 3;
	      this.detectIncompleteChar = base64DetectIncompleteChar;
	      break;
	    default:
	      this.write = passThroughWrite;
	      return;
	  }
	
	  // Enough space to store all bytes of a single character. UTF-8 needs 4
	  // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
	  this.charBuffer = new Buffer(6);
	  // Number of bytes received for the current incomplete multi-byte character.
	  this.charReceived = 0;
	  // Number of bytes expected for the current incomplete multi-byte character.
	  this.charLength = 0;
	};
	
	
	// write decodes the given buffer and returns it as JS string that is
	// guaranteed to not contain any partial multi-byte characters. Any partial
	// character found at the end of the buffer is buffered up, and will be
	// returned when calling write again with the remaining bytes.
	//
	// Note: Converting a Buffer containing an orphan surrogate to a String
	// currently works, but converting a String to a Buffer (via `new Buffer`, or
	// Buffer#write) will replace incomplete surrogates with the unicode
	// replacement character. See https://codereview.chromium.org/121173009/ .
	StringDecoder.prototype.write = function(buffer) {
	  var charStr = '';
	  // if our last write ended with an incomplete multibyte character
	  while (this.charLength) {
	    // determine how many remaining bytes this buffer has to offer for this char
	    var available = (buffer.length >= this.charLength - this.charReceived) ?
	        this.charLength - this.charReceived :
	        buffer.length;
	
	    // add the new bytes to the char buffer
	    buffer.copy(this.charBuffer, this.charReceived, 0, available);
	    this.charReceived += available;
	
	    if (this.charReceived < this.charLength) {
	      // still not enough chars in this buffer? wait for more ...
	      return '';
	    }
	
	    // remove bytes belonging to the current character from the buffer
	    buffer = buffer.slice(available, buffer.length);
	
	    // get the character that was split
	    charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);
	
	    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	    var charCode = charStr.charCodeAt(charStr.length - 1);
	    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	      this.charLength += this.surrogateSize;
	      charStr = '';
	      continue;
	    }
	    this.charReceived = this.charLength = 0;
	
	    // if there are no more bytes in this buffer, just emit our char
	    if (buffer.length === 0) {
	      return charStr;
	    }
	    break;
	  }
	
	  // determine and set charLength / charReceived
	  this.detectIncompleteChar(buffer);
	
	  var end = buffer.length;
	  if (this.charLength) {
	    // buffer the incomplete character bytes we got
	    buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
	    end -= this.charReceived;
	  }
	
	  charStr += buffer.toString(this.encoding, 0, end);
	
	  var end = charStr.length - 1;
	  var charCode = charStr.charCodeAt(end);
	  // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	  if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	    var size = this.surrogateSize;
	    this.charLength += size;
	    this.charReceived += size;
	    this.charBuffer.copy(this.charBuffer, size, 0, size);
	    buffer.copy(this.charBuffer, 0, 0, size);
	    return charStr.substring(0, end);
	  }
	
	  // or just emit the charStr
	  return charStr;
	};
	
	// detectIncompleteChar determines if there is an incomplete UTF-8 character at
	// the end of the given buffer. If so, it sets this.charLength to the byte
	// length that character, and sets this.charReceived to the number of bytes
	// that are available for this character.
	StringDecoder.prototype.detectIncompleteChar = function(buffer) {
	  // determine how many bytes we have to check at the end of this buffer
	  var i = (buffer.length >= 3) ? 3 : buffer.length;
	
	  // Figure out if one of the last i bytes of our buffer announces an
	  // incomplete char.
	  for (; i > 0; i--) {
	    var c = buffer[buffer.length - i];
	
	    // See http://en.wikipedia.org/wiki/UTF-8#Description
	
	    // 110XXXXX
	    if (i == 1 && c >> 5 == 0x06) {
	      this.charLength = 2;
	      break;
	    }
	
	    // 1110XXXX
	    if (i <= 2 && c >> 4 == 0x0E) {
	      this.charLength = 3;
	      break;
	    }
	
	    // 11110XXX
	    if (i <= 3 && c >> 3 == 0x1E) {
	      this.charLength = 4;
	      break;
	    }
	  }
	  this.charReceived = i;
	};
	
	StringDecoder.prototype.end = function(buffer) {
	  var res = '';
	  if (buffer && buffer.length)
	    res = this.write(buffer);
	
	  if (this.charReceived) {
	    var cr = this.charReceived;
	    var buf = this.charBuffer;
	    var enc = this.encoding;
	    res += buf.slice(0, cr).toString(enc);
	  }
	
	  return res;
	};
	
	function passThroughWrite(buffer) {
	  return buffer.toString(this.encoding);
	}
	
	function utf16DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 2;
	  this.charLength = this.charReceived ? 2 : 0;
	}
	
	function base64DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 3;
	  this.charLength = this.charReceived ? 3 : 0;
	}


/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.AccordionContainer = exports.Accordion = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n\n   margin: 6rem auto;\n\t.accor:last-of-type{\n\t\tborder-bottom: 1px solid ", ";\n\n\t}\n   h3,\n   h4,\n   h5 {\n      padding: 0;\n   }\n\n   h5 {\n      margin: 1.5rem 0 1rem;\n\t\t\tfont-size: 1.3rem;\n   }\n"], ["\n\n   margin: 6rem auto;\n\t.accor:last-of-type{\n\t\tborder-bottom: 1px solid ", ";\n\n\t}\n   h3,\n   h4,\n   h5 {\n      padding: 0;\n   }\n\n   h5 {\n      margin: 1.5rem 0 1rem;\n\t\t\tfont-size: 1.3rem;\n   }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n   position: relative;\n   transition: background-color 0.3s ease-in-out;\n   margin: 0 auto;\n\n   .img-news-item {\n      img {\n         max-height: 490px;\n      }\n   }\n\n   &.active {\n      background: #dedede;\n   }\n"], ["\n   position: relative;\n   transition: background-color 0.3s ease-in-out;\n   margin: 0 auto;\n\n   .img-news-item {\n      img {\n         max-height: 490px;\n      }\n   }\n\n   &.active {\n      background: #dedede;\n   }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n   display: flex;\n   justify-content: space-between;\n   align-items: center;\n   padding: 2rem 3.5rem;\n   border-top: 1px solid ", ";\n   cursor: pointer;\n\t.logo{\n\t\tmargin-bottom:0;\n    filter: grayscale(100%);\n\t}\n   .down-arrow,\n   .close-button {\n      width: 4rem;\n   }\n\n   .close-button {\n      display: none;\n   }\n\n   .active & {\n      .down-arrow {\n         display: none;\n      }\n      .close-button {\n         display: block;\n      }\n   }\n\n   ", "\n"], ["\n   display: flex;\n   justify-content: space-between;\n   align-items: center;\n   padding: 2rem 3.5rem;\n   border-top: 1px solid ", ";\n   cursor: pointer;\n\t.logo{\n\t\tmargin-bottom:0;\n    filter: grayscale(100%);\n\t}\n   .down-arrow,\n   .close-button {\n      width: 4rem;\n   }\n\n   .close-button {\n      display: none;\n   }\n\n   .active & {\n      .down-arrow {\n         display: none;\n      }\n      .close-button {\n         display: block;\n      }\n   }\n\n   ", "\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n      padding: 1rem;\n      "], ["\n      padding: 1rem;\n      "]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n   transition: max-height 0.6s ease-in-out;\n   overflow: hidden;\n   max-height: 0;\n\n   .active & {\n      height: auto;\n      max-height: 1500px;\n   }\n\n   .col {\n      margin-bottom: 2rem;\n\t\t\t&:first-of-type{\n\t\t\t\tpadding-left: 0 !important;\n\t\t\t\tborder-left: none !important;\n\t\t\t}\n   }\n"], ["\n   transition: max-height 0.6s ease-in-out;\n   overflow: hidden;\n   max-height: 0;\n\n   .active & {\n      height: auto;\n      max-height: 1500px;\n   }\n\n   .col {\n      margin-bottom: 2rem;\n\t\t\t&:first-of-type{\n\t\t\t\tpadding-left: 0 !important;\n\t\t\t\tborder-left: none !important;\n\t\t\t}\n   }\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n   height: 30px;\n   object-fit: contain;\n   margin-bottom: 3rem;\n"], ["\n   height: 30px;\n   object-fit: contain;\n   margin-bottom: 3rem;\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n   margin-right: 3rem;\n   margin-left: 1rem;\n   ", "\n"], ["\n   margin-right: 3rem;\n   margin-left: 1rem;\n   ", "\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n      vertical-align: super;\n   "], ["\n      vertical-align: super;\n   "]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _functions = __webpack_require__(6);
	
	var _close = __webpack_require__(198);
	
	var _close2 = _interopRequireDefault(_close);
	
	var _downCircle = __webpack_require__(199);
	
	var _downCircle2 = _interopRequireDefault(_downCircle);
	
	var _vars = __webpack_require__(7);
	
	var vars = _interopRequireWildcard(_vars);
	
	var _prismicReactjs = __webpack_require__(19);
	
	var _bed = __webpack_require__(202);
	
	var _bed2 = _interopRequireDefault(_bed);
	
	var _bath = __webpack_require__(201);
	
	var _bath2 = _interopRequireDefault(_bath);
	
	var _car = __webpack_require__(203);
	
	var _car2 = _interopRequireDefault(_car);
	
	var _study = __webpack_require__(204);
	
	var _study2 = _interopRequireDefault(_study);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import RightArrowCircle from "../svg/right-arrow-circle"
	
	
	var Accordion = function (_React$Component) {
	   _inherits(Accordion, _React$Component);
	
	   function Accordion() {
	      _classCallCheck(this, Accordion);
	
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	      _this.handleClick = function (event) {
	         _this.container.classList.toggle("active");
	
	         // let children = this.container.parentNode.childNodes
	         // children.forEach(function(item) {
	         //    if (item.classList.contains("active")) {
	         //       item.classList.remove("active")
	         //    }
	         // })
	         // if (event.target.tagName !== "circle") {
	         //    this.container.classList.toggle("active")
	         // }
	      };
	
	      _this.setContainerRef = function (element) {
	         _this.container = element;
	      };
	      // this.handleClick = this.handleClick.bind(this)
	      return _this;
	   }
	
	   Accordion.prototype.render = function render() {
	      var _props = this.props,
	          image = _props.image,
	          dir = _props.dir,
	          cta = _props.cta,
	          name = _props.name,
	          title = _props.title,
	          logo = _props.logo,
	          html = _props.html,
	          bed = _props.bed,
	          bath = _props.bath,
	          car = _props.car,
	          study = _props.study;
	
	      return _react2.default.createElement(
	         AccordionItem,
	         { innerRef: this.setContainerRef, className: "accor" },
	         _react2.default.createElement(
	            AccorTitle,
	            { className: "accorTitle", onClick: this.handleClick },
	            _react2.default.createElement(
	               "div",
	               { className: "" },
	               logo ? _react2.default.createElement(LogoImg, { className: "logo", src: logo, alt: name }) : _react2.default.createElement(
	                  "h3",
	                  null,
	                  bed && _react2.default.createElement(
	                     _react.Fragment,
	                     null,
	                     _react2.default.createElement("img", { src: _bed2.default, alt: "bed icon", width: "30px" }),
	                     _react2.default.createElement(
	                        Spec,
	                        { className: "spec" },
	                        bed
	                     )
	                  ),
	                  bath && _react2.default.createElement(
	                     _react.Fragment,
	                     null,
	                     _react2.default.createElement("img", { src: _bath2.default, alt: "bath icon", width: "30px" }),
	                     _react2.default.createElement(
	                        Spec,
	                        { className: "spec" },
	                        bath
	                     )
	                  ),
	                  car && _react2.default.createElement(
	                     _react.Fragment,
	                     null,
	                     _react2.default.createElement("img", { src: _car2.default, alt: "car icon", width: "42px" }),
	                     _react2.default.createElement(
	                        Spec,
	                        { className: "spec" },
	                        car
	                     )
	                  ),
	                  study && _react2.default.createElement(
	                     _react.Fragment,
	                     null,
	                     _react2.default.createElement("img", { src: _study2.default, alt: "study icon", width: "30px" }),
	                     _react2.default.createElement(
	                        Spec,
	                        { className: "spec" },
	                        study
	                     )
	                  )
	               )
	            ),
	            _react2.default.createElement("img", { src: _downCircle2.default, alt: "down arrow", className: "down-arrow" }),
	            _react2.default.createElement("img", { src: _close2.default, alt: "close button", className: "close-button" })
	         ),
	         _react2.default.createElement(
	            AccorBody,
	            { className: "accorBody grid two-columns" },
	            _react2.default.createElement(
	               "div",
	               { className: "col col-xs-12 col-06 padd-r" },
	               dir !== "right" && _react2.default.createElement(
	                  "div",
	                  { className: "col col-12 img-news-item" },
	                  _react2.default.createElement("img", { src: image, alt: name })
	               ),
	               dir === "right" && html && _react2.default.createElement(
	                  "div",
	                  null,
	                  html
	               ),
	               dir === "right" && cta.link && _react2.default.createElement(
	                  "a",
	                  { href: cta.link, className: "btn btn-arrow", target: "_blank" },
	                  cta.text
	               )
	            ),
	            _react2.default.createElement(
	               "div",
	               { className: "col col-xs-12 col-06 padd-r" },
	               dir === "right" && _react2.default.createElement(
	                  "div",
	                  { className: "col col-12 img-news-item" },
	                  _react2.default.createElement("img", { src: image, alt: name })
	               ),
	               dir !== "right" && html && _react2.default.createElement(
	                  "div",
	                  null,
	                  html
	               ),
	               dir !== "right" && cta.linik && _react2.default.createElement(
	                  "a",
	                  { href: cta.link, className: "btn btn-arrow", target: "_blank" },
	                  cta.text
	               )
	            )
	         )
	      );
	   };
	
	   return Accordion;
	}(_react2.default.Component);
	
	var AccordionContainer = _styledComponents2.default.section(_templateObject, vars.colors.body);
	
	var AccordionItem = _styledComponents2.default.div(_templateObject2);
	
	var AccorTitle = _styledComponents2.default.div(_templateObject3, vars.colors.body, _functions.below.tablet(_templateObject4));
	
	var AccorBody = _styledComponents2.default.div(_templateObject5);
	var LogoImg = _styledComponents2.default.img(_templateObject6);
	
	var Spec = _styledComponents2.default.span(_templateObject7, _functions.below.mobile(_templateObject8));
	
	exports.Accordion = Accordion;
	exports.AccordionContainer = AccordionContainer;

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.NextArrow = NextArrow;
	exports.PrevArrow = PrevArrow;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function NextArrow(props) {
		var className = props.className,
		    style = props.style,
		    onClick = props.onClick;
	
		return _react2.default.createElement("div", { className: "arrow next-arrow", onClick: onClick });
	}
	
	function PrevArrow(props) {
		var className = props.className,
		    style = props.style,
		    onClick = props.onClick;
	
		return _react2.default.createElement("div", { className: "arrow prev-arrow", onClick: onClick });
	}

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n   padding: 0;\n   position: relative;\n   margin-bottom: ", "rem;\n\n\t ", "\n\n   h1 {\n      letter-spacing: .03rem;\n      font-family: ", ";\n      font-weight: normal;\n      font-size:5.7rem;\n      padding-bottom: ", "rem;\n      line-height:1;\n      padding-right: 40px;\n      ", "\n      ", "\n   }\n\n\n   h2 {\n\t\tfont-family: ", ";\n\t\tfont-size:2.3rem;\n\t\tfont-weight: normal;\n\t\t", "\n\t\t", "\n      padding-bottom: ", "rem;\n   }\n\n   .grid .col {\n      min-height: 20rem;\n      ", "\n   }\n\n   .grid .col:first-of-type {\n      border-left: 1px solid ", ";\n      padding-left: ", "rem;\n      ", "\n   }\n\n   .border-left {\n      border-left: 1px solid ", ";\n      padding-left: ", "rem;\n   }\n\n   .mob-border-left {\n      border-left-width: 0;\n      padding-left: ", "rem;\n\n      ", "\n   }\n\n   &.invert-color {\n      background: ", ";\n      color: ", ";\n      margin-top: 6rem;\n\n      .grid .inner div {\n         border-color: ", ";\n      }\n   }\n"], ["\n   padding: 0;\n   position: relative;\n   margin-bottom: ", "rem;\n\n\t ", "\n\n   h1 {\n      letter-spacing: .03rem;\n      font-family: ", ";\n      font-weight: normal;\n      font-size:5.7rem;\n      padding-bottom: ", "rem;\n      line-height:1;\n      padding-right: 40px;\n      ", "\n      ", "\n   }\n\n\n   h2 {\n\t\tfont-family: ", ";\n\t\tfont-size:2.3rem;\n\t\tfont-weight: normal;\n\t\t", "\n\t\t", "\n      padding-bottom: ", "rem;\n   }\n\n   .grid .col {\n      min-height: 20rem;\n      ", "\n   }\n\n   .grid .col:first-of-type {\n      border-left: 1px solid ", ";\n      padding-left: ", "rem;\n      ", "\n   }\n\n   .border-left {\n      border-left: 1px solid ", ";\n      padding-left: ", "rem;\n   }\n\n   .mob-border-left {\n      border-left-width: 0;\n      padding-left: ", "rem;\n\n      ", "\n   }\n\n   &.invert-color {\n      background: ", ";\n      color: ", ";\n      margin-top: 6rem;\n\n      .grid .inner div {\n         border-color: ", ";\n      }\n   }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n\t \tmargin-top:0 !important;\n\t\t .grid{\n\t\t\t margin: 3rem auto 7rem auto !important;\n\t\t }\n\t "], ["\n\t \tmargin-top:0 !important;\n\t\t .grid{\n\t\t\t margin: 3rem auto 7rem auto !important;\n\t\t }\n\t "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n         padding-right: 0;\n         font-size:4rem;\n      "], ["\n         padding-right: 0;\n         font-size:4rem;\n      "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n         font-size:2.6rem;\n      "], ["\n         font-size:2.6rem;\n      "]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n\t\t\tfont-size:2.3rem;\n\t\t"], ["\n\t\t\tfont-size:2.3rem;\n\t\t"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n\t\t\tfont-size:2rem;\n\t\t"], ["\n\t\t\tfont-size:2rem;\n\t\t"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n         min-height: 0;\n         padding-left: ", "rem;\n         border-left: 1px solid ", ";\n      "], ["\n         min-height: 0;\n         padding-left: ", "rem;\n         border-left: 1px solid ", ";\n      "]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n         padding-left: ", "rem;\n      "], ["\n         padding-left: ", "rem;\n      "]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n         border-left-width: 0.2rem;\n      "], ["\n         border-left-width: 0.2rem;\n      "]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n   padding-bottom: ", "rem;\n   div:last-of-type {\n      max-width: 30rem;\n      }\n   }\n\n\n   ", ";\n\n"], ["\n   padding-bottom: ", "rem;\n   div:last-of-type {\n      max-width: 30rem;\n      }\n   }\n\n\n   ", ";\n\n"]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n      padding-bottom: 0;\n   "], ["\n      padding-bottom: 0;\n   "]),
	    _templateObject12 = _taggedTemplateLiteralLoose(["\n   padding-left: ", "rem;\n   border-left: 1px solid ", ";\n   padding-bottom: ", "rem;\n   ", ";\n\n   ", ";\n"], ["\n   padding-left: ", "rem;\n   border-left: 1px solid ", ";\n   padding-bottom: ", "rem;\n   ", ";\n\n   ", ";\n"]),
	    _templateObject13 = _taggedTemplateLiteralLoose(["\n      width: 35.33% !important;\n   "], ["\n      width: 35.33% !important;\n   "]),
	    _templateObject14 = _taggedTemplateLiteralLoose(["\n      border-left: none;\n      padding-left: 0;\n   "], ["\n      border-left: none;\n      padding-left: 0;\n   "]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactSlick = __webpack_require__(44);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _slick = __webpack_require__(101);
	
	var _slick2 = _interopRequireDefault(_slick);
	
	var _slickTheme = __webpack_require__(100);
	
	var _slickTheme2 = _interopRequireDefault(_slickTheme);
	
	var _rightCircle = __webpack_require__(51);
	
	var _rightCircle2 = _interopRequireDefault(_rightCircle);
	
	var _rightCircleWhite = __webpack_require__(20);
	
	var _rightCircleWhite2 = _interopRequireDefault(_rightCircleWhite);
	
	var _vars = __webpack_require__(7);
	
	var vars = _interopRequireWildcard(_vars);
	
	var _functions = __webpack_require__(6);
	
	var _prismicReactjs = __webpack_require__(19);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var TextBlock = function TextBlock(_ref) {
	   var header = _ref.header,
	       subheader = _ref.subheader,
	       text = _ref.text,
	       cta = _ref.cta,
	       invertColor = _ref.invertColor,
	       _ref$home = _ref.home,
	       home = _ref$home === undefined ? false : _ref$home,
	       _ref$ctaText = _ref.ctaText,
	       ctaText = _ref$ctaText === undefined ? 'Learn more' : _ref$ctaText;
	
	   return _react2.default.createElement(
	      Container,
	      { className: invertColor ? 'invert-color' : '', home: home },
	      _react2.default.createElement(
	         "div",
	         { className: "grid " },
	         _react2.default.createElement(
	            "div",
	            { className: "inner" },
	            _react2.default.createElement(
	               MainCopy,
	               { className: "col col-xs-12 col-06 " },
	               _prismicReactjs.RichText.render(header),
	               _prismicReactjs.RichText.render(subheader)
	            ),
	            text && _react2.default.createElement(
	               Text,
	               { className: "col col-xs-12 col-04" },
	               _prismicReactjs.RichText.render(text),
	               cta && _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: cta, className: "btn btn-square " + (invertColor && 'white') + " " },
	                  _react2.default.createElement(
	                     "span",
	                     null,
	                     ctaText
	                  )
	               )
	            )
	         )
	      )
	   );
	};
	
	var Container = _styledComponents2.default.div(_templateObject, vars.padding.inner * 2, function (props) {
	   return props.home && _functions.below.mobile(_templateObject2);
	}, vars.fonts.feature, vars.padding.inner / 2, _functions.below.tablet(_templateObject3), _functions.below.mobile(_templateObject4), vars.fonts.main, _functions.below.tablet(_templateObject5), _functions.below.mobile(_templateObject6), vars.padding.mobInner, _functions.below.tablet(_templateObject7, vars.padding.mobInner, vars.colors.body), vars.colors.body, vars.padding.inner, _functions.below.tablet(_templateObject8, vars.padding.mobInner), vars.colors.body, vars.padding.inner, vars.padding.inner, _functions.below.tablet(_templateObject9), vars.colors.body, vars.colors.blank, vars.colors.blank);
	
	var MainCopy = _styledComponents2.default.div(_templateObject10, vars.padding.inner, _functions.below.tablet(_templateObject11));
	
	var Text = _styledComponents2.default.div(_templateObject12, vars.padding.inner, vars.colors.body, vars.padding.mobInner, _functions.above.desktop(_templateObject13), _functions.below.tablet(_templateObject14));
	
	exports.default = TextBlock;
	module.exports = exports["default"];

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose([""], [""]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  height: 4rem;\n  width: 4rem;\n  position: absolute;\n  top: 3rem;\n  right: 3rem;\n  color: ", ";\n  cursor: pointer;\n\ttransition: color ", ";\n\n  &:after {\n    content: '';\n    display: block;\n    width: 100%;\n    height: 1px;\n    background-color: currentColor;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: rotate(45deg);\n  }\n  &:before {\n    content: '';\n    display: block;\n    width: 100%;\n    height: 1px;\n    background-color: currentColor;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: rotate(-45deg);\n  }\n\t&:hover{\n\t\tcolor: #66523e;\n\n\t}\n"], ["\n  height: 4rem;\n  width: 4rem;\n  position: absolute;\n  top: 3rem;\n  right: 3rem;\n  color: ", ";\n  cursor: pointer;\n\ttransition: color ", ";\n\n  &:after {\n    content: '';\n    display: block;\n    width: 100%;\n    height: 1px;\n    background-color: currentColor;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: rotate(45deg);\n  }\n  &:before {\n    content: '';\n    display: block;\n    width: 100%;\n    height: 1px;\n    background-color: currentColor;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: rotate(-45deg);\n  }\n\t&:hover{\n\t\tcolor: #66523e;\n\n\t}\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n   width: 90%;\n   max-width: 76rem;\n   display: flex;\n   flex-direction: row;\n   flex-wrap: wrap;\n   justify-content: space-between;\n   .btn {\n      margin: ", "rem auto auto auto;\n      flex-basis: 53%;\n   }\n   ", "\n   ", ";\n"], ["\n   width: 90%;\n   max-width: 76rem;\n   display: flex;\n   flex-direction: row;\n   flex-wrap: wrap;\n   justify-content: space-between;\n   .btn {\n      margin: ", "rem auto auto auto;\n      flex-basis: 53%;\n   }\n   ", "\n   ", ";\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n\t\tmax-width: 100%;\n\t\twidth: 100%;\n\t"], ["\n\t\tmax-width: 100%;\n\t\twidth: 100%;\n\t"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n    padding-top: 0;\n    display:block;\n  "], ["\n    padding-top: 0;\n    display:block;\n  "]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n   border-bottom: 1px solid ", ";\n   width: calc(50% - 1rem);\n   display: inline-block;\n   margin-bottom: 0rem;\n   @supports (display: flex) {\n      display: block;\n   }\n\n   ", ";\n"], ["\n   border-bottom: 1px solid ", ";\n   width: calc(50% - 1rem);\n   display: inline-block;\n   margin-bottom: 0rem;\n   @supports (display: flex) {\n      display: block;\n   }\n\n   ", ";\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n\t\twidth: 100%;\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n    display:block;\n    margin-bottom: 0;\n\t"], ["\n\t\twidth: 100%;\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n    display:block;\n    margin-bottom: 0;\n\t"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n   border-bottom: 1px solid ", ";\n   width: 100%;\n   display: inline-block;\n   margin-bottom: 0rem;\n   @supports (display: flex) {\n      display: block;\n   }\n\n   ", ";\n\n"], ["\n   border-bottom: 1px solid ", ";\n   width: 100%;\n   display: inline-block;\n   margin-bottom: 0rem;\n   @supports (display: flex) {\n      display: block;\n   }\n\n   ", ";\n\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n   position: relative;\n   width: 11rem;\n   flex: 0 0 auto;\n   text-align: left;\n   font-size: 1.4rem;\n   background: ", ";\n   color: ", ";\n   text-decoration: underline;\n   margin-top: ", "rem;\n   padding: 1.2rem 1.75rem;\n   cursor: pointer;\n   transition: margin-left .3s;\n   text-decoration: none;\n\n   :after {\n      content: '\u2192';\n      margin-left: .5rem;\n      transition: margin-left .5s;\n      text-decoration: none;\n   }\n\n   :hover:after {\n      margin-left: .9rem;\n   }\n\n   span {\n      text-decoration: underline;\n   }\n"], ["\n   position: relative;\n   width: 11rem;\n   flex: 0 0 auto;\n   text-align: left;\n   font-size: 1.4rem;\n   background: ", ";\n   color: ", ";\n   text-decoration: underline;\n   margin-top: ", "rem;\n   padding: 1.2rem 1.75rem;\n   cursor: pointer;\n   transition: margin-left .3s;\n   text-decoration: none;\n\n   :after {\n      content: '\u2192';\n      margin-left: .5rem;\n      transition: margin-left .5s;\n      text-decoration: none;\n   }\n\n   :hover:after {\n      margin-left: .9rem;\n   }\n\n   span {\n      text-decoration: underline;\n   }\n"]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n  padding: 1rem 0;\n\n  /* width: 100%; */\n  /* font-family: \"Salome Fine\"; */\n  /* color: ", "; */\n  /* text-transform: uppercase; */\n  /* font-size: 3rem; */\n  /* text-align: center; */\n  /* margin-bottom: 3rem; */\n"], ["\n  padding: 1rem 0;\n\n  /* width: 100%; */\n  /* font-family: \"Salome Fine\"; */\n  /* color: ", "; */\n  /* text-transform: uppercase; */\n  /* font-size: 3rem; */\n  /* text-align: center; */\n  /* margin-bottom: 3rem; */\n"]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n  /* font-size: 1.5rem; */\n  /* color: ", "; */\n  /* text-align: center; */\n"], ["\n  /* font-size: 1.5rem; */\n  /* color: ", "; */\n  /* text-align: center; */\n"]),
	    _templateObject12 = _taggedTemplateLiteralLoose(["\n   text-transform: uppercase;\n   color: ", ";\n   text-align: center;\n   width: 100%;\n   margin-top: 2rem;\n   font-size: 1.4rem;\n"], ["\n   text-transform: uppercase;\n   color: ", ";\n   text-align: center;\n   width: 100%;\n   margin-top: 2rem;\n   font-size: 1.4rem;\n"]),
	    _templateObject13 = _taggedTemplateLiteralLoose(["\n   width: 14em;\n   width: 14em;\n   display: block;\n   position: relative;\n   margin: 0 auto 3em;\n"], ["\n   width: 14em;\n   width: 14em;\n   display: block;\n   position: relative;\n   margin: 0 auto 3em;\n"]),
	    _templateObject14 = _taggedTemplateLiteralLoose(["\n\n    padding: 1em;\n    background-color: #dc3545;\n    color: #fff;\n    margin-bottom: 2em;\n\n"], ["\n\n    padding: 1em;\n    background-color: #dc3545;\n    color: #fff;\n    margin-bottom: 2em;\n\n"]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	__webpack_require__(45);
	
	var _vars = __webpack_require__(7);
	
	var vars = _interopRequireWildcard(_vars);
	
	var _functions = __webpack_require__(6);
	
	var _input = __webpack_require__(23);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _autofill = __webpack_require__(37);
	
	var _autofill2 = _interopRequireDefault(_autofill);
	
	var _suburbs = __webpack_require__(53);
	
	var _suburbs2 = _interopRequireDefault(_suburbs);
	
	var _fileSaver = __webpack_require__(132);
	
	var _fileSaver2 = _interopRequireDefault(_fileSaver);
	
	var _rightCircleWhite = __webpack_require__(20);
	
	var _rightCircleWhite2 = _interopRequireDefault(_rightCircleWhite);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var theme = {
	   color: _vars.colors.inactiveColor,
	   backgroundColor: "transparent",
	   paddingLeft: "1rem",
	   fontSize: "1.5rem"
	};
	
	var RegisterForm = function (_React$Component) {
	   _inherits(RegisterForm, _React$Component);
	
	   function RegisterForm() {
	      _classCallCheck(this, RegisterForm);
	
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	      var url = void 0;
	      if (typeof window !== "undefined") {
	         url = window.location.href.replace("https://", "").replace("http://", "").replace(/\/$/, "");
	      } else {
	         url = "";
	      }
	      _this.state = {
	         formStatus: "incomplete",
	         values: {},
	         url: url,
	         declineSuburb: false
	      };
	      return _this;
	   }
	
	   RegisterForm.prototype.updateForm = function updateForm(e) {
	      var values = this.state.values;
	      if (e.target.getAttribute("name") !== "Postcode") {
	         values[e.target.getAttribute("name")] = e.target.value;
	         this.setState({ values: values });
	      } else {
	         return false;
	      }
	   };
	
	   RegisterForm.prototype.componentDidMount = function componentDidMount() {
	
	      this.updateForm = this.updateForm.bind(this);
	      this.handleSubmit = this.handleSubmit.bind(this);
	   };
	
	   RegisterForm.prototype.SaveToDisk = function SaveToDisk(fileURL, fileName) {
	      // for non-IE
	      if (!window.ActiveXObject) {
	         var save = document.createElement('a');
	         save.href = fileURL;
	         save.target = '_blank';
	         save.download = fileName || 'unknown';
	
	         var evt = new MouseEvent('click', {
	            'view': window,
	            'bubbles': true,
	            'cancelable': false
	         });
	         save.dispatchEvent(evt);
	
	         (window.URL || window.webkitURL).revokeObjectURL(save.href);
	      }
	
	      // for IE < 11
	      else if (!!window.ActiveXObject && document.execCommand) {
	            var _window = window.open(fileURL, '_blank');
	            _window.document.close();
	            _window.document.execCommand('SaveAs', true, fileName || fileURL);
	            _window.close();
	         }
	   };
	
	   RegisterForm.prototype.prettify = function prettify(str) {
	      return str.split('-').map(function capitalize(part) {
	         return part.charAt(0).toUpperCase() + part.slice(1);
	      }).join(' ');
	   };
	
	   RegisterForm.prototype.handleSubmit = function handleSubmit(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	      var submitBtn = document.getElementById("submit");
	      submitBtn.style.cursor = "progress";
	      submitBtn.disabled = true;
	      submitBtn.innerHTML = 'LOADING';
	      var fields = [].slice.call(e.target.querySelectorAll("[name]"));
	      fields.map(function (f) {
	         var values = _this2.state.values;
	         values[f.getAttribute("name")] = f.value;
	      });
	      var values = _extends({}, this.state.values);
	
	      //if no tags pass empty tag
	      values['tags'] = [];
	
	      if (values['tags_2']) {
	         values['tags'].push(decodeURI(values['tags_2']));
	      }
	      if (values['tags_3']) {
	         values['tags'].push(decodeURI(values['tags_3']));
	      }
	      if (values['tags_4']) {
	         values['tags'].push(decodeURI(values['tags_4']));
	      }
	
	      if (values['alt_project']) {
	         values['property'] = values['alt_project'];
	
	         values['project_name'] = this.prettify(values['property']);
	      }
	
	      // submitToInsite(values).then(function(){
	      fetch("https://vds9c5imf1.execute-api.ap-southeast-2.amazonaws.com/prod/yarrabend-v4", {
	         method: "POST",
	         headers: { "Content-Type": "application/json" },
	         body: JSON.stringify(values)
	      }).then(function (res) {
	         return res.json();
	      }).then(function (json) {
	         if (json.errorMessage) {
	            alert('Error submitting request please call +61 (0)3 9573 8320');
	         } else {
	            var formStatus = "complete";
	            _this2.setState({ formStatus: formStatus });
	            if (_this2.props.brochure != '') {
	               _this2.SaveToDisk("" + _this2.props.brochure_full, 'brochure.pdf');
	            } else {
	               _this2.SaveToDisk("/" + _this2.props.brochure + ".pdf", 'brochure.pdf');
	            }
	         }
	      }).catch(function (err) {
	         return console.log(err);
	      });
	      // }.bind(this))
	   };
	
	   RegisterForm.prototype.render = function render() {
	      var brochure_file_path = '';
	
	      if (this.props.brochure != '') {
	         brochure_file_path = this.props.brochure_full;
	      } else {
	         brochure_file_path = "/" + this.props.brochure + ".pdf";
	      }
	
	      var property = '';
	
	      if (this.props.product) {
	         property = this.props.product;
	      }
	
	      var project_name = '';
	
	      // if(this.props.utm.utm_campaign){
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("artisan-residences")){
	      //       project_name = 'Artisan Residences';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("culinary-house")){
	      //       project_name = 'Culinary House';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("fourdrinier-house")){
	      //       project_name = 'Fourdrinier House';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("sheahan-townhouses")){
	      //       project_name = 'Sheahan Townhouses';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("camber-lofts")){
	      //       project_name = 'Camber lofts';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("papersmith")){
	      //       project_name = 'Papersmith';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("PVA")){
	      //       project_name = 'Parkview Apartments';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("Parkview-houses")){
	      //       project_name = 'Parkview Houses';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("Parkview-townhouses")){
	      //       project_name = 'Parkview Townhouses';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("Mills-41")){
	      //       project_name = 'The Mills 4.1';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("Mills-42")){
	      //       project_name = 'The Mills 4.2';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("Mills-43")){
	      //       project_name = 'The Mills 4.3';
	      //    }
	      // }
	
	      function prettify(str) {
	         return str.split('-').map(function capitalize(part) {
	            return part.charAt(0).toUpperCase() + part.slice(1);
	         }).join(' ');
	      }
	      if (this.props.product) {
	         if (this.props.product === "papersmith-apartments") {
	            project_name = "Papersmith";
	         } else if (this.props.product === "sheahan-townhouses") {
	            project_name = "Sheahan Townhouses";
	         } else if (this.props.product === "artisan-residences") {
	            project_name = "Artisan Residences";
	         } else if (this.props.product === "parkview-houses") {
	            project_name = "Parkview Houses";
	         } else if (this.props.product === "parkview-apartments-2") {
	            project_name = "Parkview Apartments";
	         } else if (this.props.product === "parkview-apartments") {
	            project_name = "Parkview Apartments";
	         } else if (this.props.product === "the-mills-townhouses") {
	            project_name = "The Mills 4.1";
	         } else if (this.props.product === "fourdrinier-house") {
	            project_name = "Fourdrinier House";
	         } else if (this.props.product === "completed-homes") {
	            project_name = "Completed Homes";
	         } else if (this.props.product === "seren-row") {
	            project_name = "Outer Circle";
	         } else {
	            project_name = this.prettify(this.props.product);
	         }
	      }
	
	      return _react2.default.createElement(
	         Container,
	         { popup: this.props.popup, shown: this.props.shown },
	         this.props.popup && _react2.default.createElement(Close, { onClick: this.props.toggleForm }),
	         this.state.formStatus === "complete" ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	               Heading,
	               null,
	               "THANK YOU"
	            ),
	            _react2.default.createElement(
	               ThankYouText,
	               { className: 'form__thankyou' },
	               "Your download should begin shortly. Alternatively, ",
	               _react2.default.createElement(
	                  "a",
	                  { href: brochure_file_path, download: true },
	                  "click here"
	               ),
	               " to download brochure."
	            )
	         ) : _react2.default.createElement(
	            _styledComponents.ThemeProvider,
	            { theme: theme },
	            _react2.default.createElement(
	               "div",
	               null,
	               this.state.declineSuburb && _react2.default.createElement(
	                  FormError,
	                  { className: 'form__error' },
	                  "ERROR: The suburb you submitted does not match any on our system, ",
	                  _react2.default.createElement("br", null),
	                  "please select an option in the dropdown. "
	               ),
	               _react2.default.createElement(
	                  Form,
	                  { action: "", onSubmit: this.handleSubmit },
	                  _react2.default.createElement(
	                     Field,
	                     null,
	                     _react2.default.createElement(_input2.default, {
	                        name: "first_name",
	                        label: "First Name",
	                        required: true,
	                        onChange: this.updateForm
	                     })
	                  ),
	                  _react2.default.createElement(
	                     Field,
	                     null,
	                     _react2.default.createElement(_input2.default, {
	                        name: "last_name",
	                        label: "Surname",
	                        required: true,
	                        onChange: this.updateForm
	                     })
	                  ),
	                  _react2.default.createElement(
	                     Field,
	                     null,
	                     _react2.default.createElement(_input2.default, {
	                        name: "phone",
	                        label: "Phone Number",
	                        required: true,
	                        onChange: this.updateForm
	                     })
	                  ),
	                  _react2.default.createElement(
	                     Field,
	                     null,
	                     _react2.default.createElement(_input2.default, {
	                        name: "email",
	                        label: "Email address",
	                        required: true,
	                        onChange: this.updateForm
	                     })
	                  ),
	                  _react2.default.createElement(
	                     Field,
	                     { style: { opacity: '0' } },
	                     _react2.default.createElement("input", { type: "hidden", name: "tags", value: this.props.tags })
	                  ),
	                  _react2.default.createElement("input", { type: "hidden", name: "comment", value: " " }),
	                  _react2.default.createElement("input", { type: "hidden", name: "property", value: property }),
	                  _react2.default.createElement("input", { type: "hidden", id: "project_name", name: "project_name", value: project_name }),
	                  _react2.default.createElement("input", { type: "hidden", name: "interactive", value: "true" }),
	                  _react2.default.createElement("input", { type: "hidden", id: "utm_source", name: "tags_2", value: this.props.utm.utm_source }),
	                  _react2.default.createElement("input", { type: "hidden", id: "utm_medium", name: "tags_3", value: this.props.utm.utm_medium }),
	                  _react2.default.createElement("input", { type: "hidden", id: "utm_campaign", name: "tags_4", value: this.props.utm.utm_campaign }),
	                  _react2.default.createElement("input", { type: "hidden", id: "referrer", name: "referrer", value: this.props.utm.referrer }),
	                  this.props.square ? _react2.default.createElement(
	                     "button",
	                     { id: "submit", className: "btn btn-square" },
	                     _react2.default.createElement(
	                        "span",
	                        null,
	                        "Enquire"
	                     )
	                  ) : _react2.default.createElement(
	                     Submit,
	                     { id: "submit", square: this.props.square },
	                     _react2.default.createElement(
	                        "span",
	                        null,
	                        "Enquire"
	                     )
	                  )
	               )
	            )
	         )
	      );
	   };
	
	   return RegisterForm;
	}(_react2.default.Component);
	
	exports.default = RegisterForm;
	
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var Close = _styledComponents2.default.div(_templateObject2, _vars.colors.blank, vars.time);
	
	var Form = _styledComponents2.default.form(_templateObject3, vars.padding.inner, _functions.below.tablet(_templateObject4), _functions.below.mobile(_templateObject5));
	
	var Field = _styledComponents2.default.div(_templateObject6, _vars.colors.inactiveColor, _functions.below.mobile(_templateObject7));
	var FieldFull = _styledComponents2.default.div(_templateObject8, _vars.colors.inactiveColor, _functions.below.mobile(_templateObject7));
	
	var Submit = _styledComponents2.default.button(_templateObject9, _vars.colors.body, _vars.colors.blank, vars.padding.inner / 2);
	
	var Heading = _styledComponents2.default.p(_templateObject10, _vars.colors.brandHighlight);
	
	var ThankYouText = _styledComponents2.default.p(_templateObject11, _vars.colors.white);
	
	var FormNote = _styledComponents2.default.p(_templateObject12, _vars.colors.brandHighlight);
	
	var Logo = _styledComponents2.default.img(_templateObject13);
	
	var FormError = _styledComponents2.default.p(_templateObject14);
	module.exports = exports["default"];

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n\n.form__thankyou a:not(.link-email):after {\n   content: url(/svg/arrow.svg)!important;\n}\n\n.form__thankyou .buttonWrapper{\n   padding-top:2em;\n   display:block;\n}\n"], ["\n\n.form__thankyou a:not(.link-email):after {\n   content: url(/svg/arrow.svg)!important;\n}\n\n.form__thankyou .buttonWrapper{\n   padding-top:2em;\n   display:block;\n}\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  height: 4rem;\n  width: 4rem;\n  position: absolute;\n  top: 3rem;\n  right: 3rem;\n  color: ", ";\n  cursor: pointer;\n\ttransition: color ", ";\n\n  &:after {\n    content: '';\n    display: block;\n    width: 100%;\n    height: 1px;\n    background-color: currentColor;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: rotate(45deg);\n  }\n  &:before {\n    content: '';\n    display: block;\n    width: 100%;\n    height: 1px;\n    background-color: currentColor;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: rotate(-45deg);\n  }\n\t&:hover{\n\t\tcolor: #66523e;\n\n\t}\n"], ["\n  height: 4rem;\n  width: 4rem;\n  position: absolute;\n  top: 3rem;\n  right: 3rem;\n  color: ", ";\n  cursor: pointer;\n\ttransition: color ", ";\n\n  &:after {\n    content: '';\n    display: block;\n    width: 100%;\n    height: 1px;\n    background-color: currentColor;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: rotate(45deg);\n  }\n  &:before {\n    content: '';\n    display: block;\n    width: 100%;\n    height: 1px;\n    background-color: currentColor;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: rotate(-45deg);\n  }\n\t&:hover{\n\t\tcolor: #66523e;\n\n\t}\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n   width: 90%;\n   max-width: 76rem;\n   display: flex;\n   flex-direction: row;\n   flex-wrap: wrap;\n   justify-content: space-between;\n   .btn {\n      margin: ", "rem auto auto auto;\n      flex-basis: 53%;\n   }\n   ", "\n   ", ";\n"], ["\n   width: 90%;\n   max-width: 76rem;\n   display: flex;\n   flex-direction: row;\n   flex-wrap: wrap;\n   justify-content: space-between;\n   .btn {\n      margin: ", "rem auto auto auto;\n      flex-basis: 53%;\n   }\n   ", "\n   ", ";\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n\t\tmax-width: 100%;\n\t\twidth: 100%;\n\t"], ["\n\t\tmax-width: 100%;\n\t\twidth: 100%;\n\t"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n    padding-top: 0;\n    display:block;\n  "], ["\n    padding-top: 0;\n    display:block;\n  "]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n   border-bottom: 1px solid ", ";\n   width: calc(50% - 1rem);\n   display: inline-block;\n   margin-bottom: 0rem;\n   @supports (display: flex) {\n      display: block;\n   }\n\n   ", ";\n"], ["\n   border-bottom: 1px solid ", ";\n   width: calc(50% - 1rem);\n   display: inline-block;\n   margin-bottom: 0rem;\n   @supports (display: flex) {\n      display: block;\n   }\n\n   ", ";\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n\t\twidth: 100%;\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n    display:block;\n    margin-bottom: 0;\n\t"], ["\n\t\twidth: 100%;\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n    display:block;\n    margin-bottom: 0;\n\t"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n   position: relative;\n   width: 11rem;\n   flex: 0 0 auto;\n   text-align: left;\n   font-size: 1.4rem;\n   background: ", ";\n   color: ", ";\n   text-decoration: underline;\n   margin-top: ", "rem;\n   padding: 1.2rem 1.75rem;\n   cursor: pointer;\n   transition: margin-left .3s;\n   text-decoration: none;\n\n   :after {\n      content: '\u2192';\n      margin-left: .5rem;\n      transition: margin-left .5s;\n      text-decoration: none;\n   }\n\n   :hover:after {\n      margin-left: .9rem;\n   }\n\n   span {\n      text-decoration: underline;\n   }\n"], ["\n   position: relative;\n   width: 11rem;\n   flex: 0 0 auto;\n   text-align: left;\n   font-size: 1.4rem;\n   background: ", ";\n   color: ", ";\n   text-decoration: underline;\n   margin-top: ", "rem;\n   padding: 1.2rem 1.75rem;\n   cursor: pointer;\n   transition: margin-left .3s;\n   text-decoration: none;\n\n   :after {\n      content: '\u2192';\n      margin-left: .5rem;\n      transition: margin-left .5s;\n      text-decoration: none;\n   }\n\n   :hover:after {\n      margin-left: .9rem;\n   }\n\n   span {\n      text-decoration: underline;\n   }\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n  padding: 1rem 0;\n\n  /* width: 100%; */\n  /* font-family: \"Salome Fine\"; */\n  /* color: ", "; */\n  /* text-transform: uppercase; */\n  /* font-size: 3rem; */\n  /* text-align: center; */\n  /* margin-bottom: 3rem; */\n"], ["\n  padding: 1rem 0;\n\n  /* width: 100%; */\n  /* font-family: \"Salome Fine\"; */\n  /* color: ", "; */\n  /* text-transform: uppercase; */\n  /* font-size: 3rem; */\n  /* text-align: center; */\n  /* margin-bottom: 3rem; */\n"]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n  /* font-size: 1.5rem; */\n  /* color: ", "; */\n  /* text-align: center; */\n"], ["\n  /* font-size: 1.5rem; */\n  /* color: ", "; */\n  /* text-align: center; */\n"]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n   text-transform: uppercase;\n   color: ", ";\n   text-align: center;\n   width: 100%;\n   margin-top: 2rem;\n   font-size: 1.4rem;\n"], ["\n   text-transform: uppercase;\n   color: ", ";\n   text-align: center;\n   width: 100%;\n   margin-top: 2rem;\n   font-size: 1.4rem;\n"]),
	    _templateObject12 = _taggedTemplateLiteralLoose(["\n   width: 14em;\n   width: 14em;\n   display: block;\n   position: relative;\n   margin: 0 auto 3em;\n"], ["\n   width: 14em;\n   width: 14em;\n   display: block;\n   position: relative;\n   margin: 0 auto 3em;\n"]),
	    _templateObject13 = _taggedTemplateLiteralLoose(["\n\n    padding: 1em;\n    background-color: #dc3545;\n    color: #fff;\n    margin-bottom: 2em;\n\n"], ["\n\n    padding: 1em;\n    background-color: #dc3545;\n    color: #fff;\n    margin-bottom: 2em;\n\n"]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	__webpack_require__(45);
	
	var _vars = __webpack_require__(7);
	
	var vars = _interopRequireWildcard(_vars);
	
	var _functions = __webpack_require__(6);
	
	var _input = __webpack_require__(23);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _autofill = __webpack_require__(37);
	
	var _autofill2 = _interopRequireDefault(_autofill);
	
	var _suburbs = __webpack_require__(53);
	
	var _suburbs2 = _interopRequireDefault(_suburbs);
	
	var _fileSaver = __webpack_require__(132);
	
	var _fileSaver2 = _interopRequireDefault(_fileSaver);
	
	var _rightCircleWhite = __webpack_require__(20);
	
	var _rightCircleWhite2 = _interopRequireDefault(_rightCircleWhite);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var theme = {
	   color: _vars.colors.inactiveColor,
	   backgroundColor: "transparent",
	   paddingLeft: "1rem",
	   fontSize: "1.5rem"
	};
	
	var RegisterFloorplanForm = function (_React$Component) {
	   _inherits(RegisterFloorplanForm, _React$Component);
	
	   function RegisterFloorplanForm() {
	      _classCallCheck(this, RegisterFloorplanForm);
	
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	      var url = void 0;
	      if (typeof window !== "undefined") {
	         url = window.location.href.replace("https://", "").replace("http://", "").replace(/\/$/, "");
	      } else {
	         url = "";
	      }
	      _this.state = {
	         formStatus: "incomplete",
	         values: {},
	         url: url,
	         declineSuburb: false
	      };
	      return _this;
	   }
	
	   RegisterFloorplanForm.prototype.updateForm = function updateForm(e) {
	      var values = this.state.values;
	      if (e.target.getAttribute("name") !== "Postcode") {
	         values[e.target.getAttribute("name")] = e.target.value;
	         this.setState({ values: values });
	      } else {
	         return false;
	      }
	   };
	
	   RegisterFloorplanForm.prototype.componentDidMount = function componentDidMount() {
	
	      this.updateForm = this.updateForm.bind(this);
	      this.handleSubmit = this.handleSubmit.bind(this);
	   };
	
	   RegisterFloorplanForm.prototype.handleSubmit = function handleSubmit(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	      var submitBtn = document.getElementById("submit");
	      submitBtn.style.cursor = "progress";
	      submitBtn.disabled = true;
	      submitBtn.innerHTML = 'LOADING';
	      var fields = [].slice.call(e.target.querySelectorAll("[name]"));
	      fields.map(function (f) {
	         var values = _this2.state.values;
	         values[f.getAttribute("name")] = f.value;
	      });
	      var values = _extends({}, this.state.values);
	
	      //hard code missing values
	      values['suburb'] = "";
	      values['state'] = "";
	      values['postcode'] = "";
	
	      //if no tags pass empty tag
	      values['tags'] = [];
	
	      if (values['tags_2']) {
	         values['tags'].push(decodeURI(values['tags_2']));
	      }
	      if (values['tags_3']) {
	         values['tags'].push(decodeURI(values['tags_3']));
	      }
	      if (values['tags_4']) {
	         values['tags'].push(decodeURI(values['tags_4']));
	      }
	
	      if (!values['property']) {
	         values['property'] = "";
	      }
	
	      // submitToInsite(values).then(function(){
	      fetch("https://vds9c5imf1.execute-api.ap-southeast-2.amazonaws.com/prod/yarrabend-v4", {
	         method: "POST",
	         headers: { "Content-Type": "application/json" },
	         body: JSON.stringify(values)
	      }).then(function (res) {
	         return res.json();
	      }).then(function (json) {
	         if (json.errorMessage) {
	            alert('Error submitting request please call +61 (0)3 9573 8320');
	         } else {
	            var formStatus = "complete";
	            _this2.setState({ formStatus: formStatus });
	         }
	      }).catch(function (err) {
	         return console.log(err);
	      });
	      // }.bind(this))
	   };
	
	   RegisterFloorplanForm.prototype.render = function render() {
	      // var brochure_file_path = ''
	
	      // if (this.props.brochure != '') {
	      //    brochure_file_path = this.props.brochure_full
	      // } else {
	      //    brochure_file_path = `/${this.props.brochure}.pdf`
	      // }
	      var url = this.props.url;
	      var property = '';
	
	      if (this.props.product) {
	         property = this.props.product;
	      }
	
	      var project_name = '';
	
	      // if(this.props.utm.utm_campaign){
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("artisan-residences")){
	      //       project_name = 'Artisan Residences';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("culinary-house")){
	      //       project_name = 'Culinary House';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("fourdrinier-house")){
	      //       project_name = 'Fourdrinier House';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("sheahan-townhouses")){
	      //       project_name = 'Sheahan Townhouses';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("camber-lofts")){
	      //       project_name = 'Camber lofts';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("papersmith")){
	      //       project_name = 'Papersmith';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("PVA")){
	      //       project_name = 'Parkview Apartments';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("Parkview-houses")){
	      //       project_name = 'Parkview Houses';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("Parkview-townhouses")){
	      //       project_name = 'Parkview Townhouses';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("Mills-41")){
	      //       project_name = 'The Mills 4.1';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("Mills-42")){
	      //       project_name = 'The Mills 4.2';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("Mills-43")){
	      //       project_name = 'The Mills 4.3';
	      //    }
	      // }
	
	      function prettify(str) {
	         return str.split('-').map(function capitalize(part) {
	            return part.charAt(0).toUpperCase() + part.slice(1);
	         }).join(' ');
	      }
	      if (this.props.product) {
	         if (this.props.product === "papersmith-apartments") {
	            project_name = "Papersmith";
	         } else if (this.props.product === "sheahan-townhouses") {
	            project_name = "Sheahan Townhouses";
	         } else if (this.props.product === "artisan-residences") {
	            project_name = "Artisan Residences";
	         } else if (this.props.product === "parkview-houses") {
	            project_name = "Parkview Houses";
	         } else if (this.props.product === "parkview-apartments-2") {
	            project_name = "Parkview Apartments";
	         } else if (this.props.product === "fourdrinier-house") {
	            project_name = "Fourdrinier House";
	         } else if (this.props.product === "completed-homes") {
	            project_name = "Completed Homes";
	         } else if (this.props.product === "seren-row") {
	            project_name = "Outer Circle";
	         } else {
	            project_name = prettify(this.props.product);
	         }
	      }
	
	      return _react2.default.createElement(
	         Container,
	         { popup: this.props.popup, shown: this.props.shown },
	         this.props.popup && _react2.default.createElement(Close, { onClick: this.props.toggleForm }),
	         this.state.formStatus === "complete" ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	               ThankYouText,
	               { className: 'form__thankyou' },
	               "Thank you your registration was successfully submitted. Click through to view floorplans.",
	               _react2.default.createElement(
	                  "div",
	                  { className: "buttonWrapper" },
	                  /^\/(?!\/)/.test(url) === true ? _react2.default.createElement(
	                     _gatsbyLink2.default,
	                     { className: "btn btn-square ", to: { pathname: url } },
	                     _react2.default.createElement(
	                        "span",
	                        null,
	                        "View Floorplans"
	                     )
	                  ) : _react2.default.createElement(
	                     "a",
	                     { href: url, className: "btn btn-square ", target: "_blank" },
	                     _react2.default.createElement(
	                        "span",
	                        null,
	                        "View Floorplans"
	                     )
	                  )
	               )
	            )
	         ) : _react2.default.createElement(
	            _styledComponents.ThemeProvider,
	            { theme: theme },
	            _react2.default.createElement(
	               "div",
	               null,
	               this.state.declineSuburb && _react2.default.createElement(
	                  FormError,
	                  { className: 'form__error' },
	                  "ERROR: The suburb you submitted does not match any on our system, ",
	                  _react2.default.createElement("br", null),
	                  "please select an option in the dropdown. "
	               ),
	               _react2.default.createElement(
	                  Form,
	                  { action: "", onSubmit: this.handleSubmit },
	                  _react2.default.createElement(
	                     Field,
	                     null,
	                     _react2.default.createElement(_input2.default, {
	                        name: "first_name",
	                        label: "First Name",
	                        required: true,
	                        onChange: this.updateForm
	                     })
	                  ),
	                  _react2.default.createElement(
	                     Field,
	                     null,
	                     _react2.default.createElement(_input2.default, {
	                        name: "last_name",
	                        label: "Surname",
	                        required: true,
	                        onChange: this.updateForm
	                     })
	                  ),
	                  _react2.default.createElement(
	                     Field,
	                     null,
	                     _react2.default.createElement(_input2.default, {
	                        name: "phone",
	                        label: "Phone Number",
	                        required: true,
	                        onChange: this.updateForm
	                     })
	                  ),
	                  _react2.default.createElement(
	                     Field,
	                     null,
	                     _react2.default.createElement(_input2.default, {
	                        name: "email",
	                        label: "Email address",
	                        required: true,
	                        onChange: this.updateForm
	                     })
	                  ),
	                  _react2.default.createElement("input", { type: "hidden", name: "comment", value: "" }),
	                  _react2.default.createElement("input", { type: "hidden", name: "property", value: property }),
	                  _react2.default.createElement("input", { type: "hidden", name: "interactive", value: "true" }),
	                  _react2.default.createElement("input", { type: "hidden", id: "project_name", name: "project_name", value: project_name }),
	                  _react2.default.createElement("input", { type: "hidden", id: "utm_source", name: "tags_2", value: this.props.utm.utm_source }),
	                  _react2.default.createElement("input", { type: "hidden", id: "utm_medium", name: "tags_3", value: this.props.utm.utm_medium }),
	                  _react2.default.createElement("input", { type: "hidden", id: "utm_campaign", name: "tags_4", value: this.props.utm.utm_campaign }),
	                  _react2.default.createElement("input", { type: "hidden", id: "referrer", name: "referrer", value: this.props.utm.referrer }),
	                  this.props.square ? _react2.default.createElement(
	                     "button",
	                     { id: "submit", className: "btn btn-square" },
	                     _react2.default.createElement(
	                        "span",
	                        null,
	                        "Enquire"
	                     )
	                  ) : _react2.default.createElement(
	                     Submit,
	                     { id: "submit", square: this.props.square },
	                     _react2.default.createElement(
	                        "span",
	                        null,
	                        "Enquire"
	                     )
	                  )
	               )
	            )
	         )
	      );
	   };
	
	   return RegisterFloorplanForm;
	}(_react2.default.Component);
	
	exports.default = RegisterFloorplanForm;
	
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var Close = _styledComponents2.default.div(_templateObject2, _vars.colors.blank, vars.time);
	
	var Form = _styledComponents2.default.form(_templateObject3, vars.padding.inner, _functions.below.tablet(_templateObject4), _functions.below.mobile(_templateObject5));
	
	var Field = _styledComponents2.default.div(_templateObject6, _vars.colors.inactiveColor, _functions.below.mobile(_templateObject7));
	
	var Submit = _styledComponents2.default.button(_templateObject8, _vars.colors.body, _vars.colors.blank, vars.padding.inner / 2);
	
	var Heading = _styledComponents2.default.p(_templateObject9, _vars.colors.brandHighlight);
	
	var ThankYouText = _styledComponents2.default.p(_templateObject10, _vars.colors.white);
	
	var FormNote = _styledComponents2.default.p(_templateObject11, _vars.colors.brandHighlight);
	
	var Logo = _styledComponents2.default.img(_templateObject12);
	
	var FormError = _styledComponents2.default.p(_templateObject13);
	module.exports = exports["default"];

/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\nfloat: right;\nfont-size: 1.3rem;\n\nfont-size: 1.3rem;\nposition: absolute;\nright: 58px;\ntop: 44px;\nwhite-space: nowrap;\n\n", "\n\n", "\n", "\n\n", "\n\n"], ["\nfloat: right;\nfont-size: 1.3rem;\n\nfont-size: 1.3rem;\nposition: absolute;\nright: 58px;\ntop: 44px;\nwhite-space: nowrap;\n\n", "\n\n", "\n", "\n\n", "\n\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\nfont-size: 1.3rem;\n    position: absolute;\n    right: 30px;\n    top: 62px;\n"], ["\nfont-size: 1.3rem;\n    position: absolute;\n    right: 30px;\n    top: 62px;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\nright: 0;\n\n   "], ["\nright: 0;\n\n   "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\ntop: 22px;\nfont-size: 1.1rem;\n"], ["\ntop: 22px;\nfont-size: 1.1rem;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n      display: none;\n   "], ["\n      display: none;\n   "]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n   position: relative;\n   z-index: 100;\n   top: 0;\n   left: 0;\n   right: 0;\n\n   padding-bottom: 19px;\n   ", "\n\n\t .grid .inner{\n\n    }\n\n\n   ", "\n   ", "\n   ", "\n   ", ";\n\n      &.fixed{\n         position: fixed;\n         background: ", ";\n      }\n\n   ", "\n   ", "\n\n   .overlay {\n      position: absolute;\n      background: linear-gradient(to bottom, ", " 0%,", " 42%,rgba(0,0,0,0) 100%);\n      z-index: 99;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      height: 100vh;\n      visibility: hidden;\n      transform: translateY(-100%);\n      ", "\n      ", "\n      transition: ", "s transform ease-in-out, ", "s visibility ease-in-out;\n      ", "\n\n      ", ";\n   }\n\n   ", "\n"], ["\n   position: relative;\n   z-index: 100;\n   top: 0;\n   left: 0;\n   right: 0;\n\n   padding-bottom: 19px;\n   ", "\n\n\t .grid .inner{\n\n    }\n\n\n   ", "\n   ", "\n   ", "\n   ", ";\n\n      &.fixed{\n         position: fixed;\n         background: ", ";\n      }\n\n   ", "\n   ", "\n\n   .overlay {\n      position: absolute;\n      background: linear-gradient(to bottom, ", " 0%,", " 42%,rgba(0,0,0,0) 100%);\n      z-index: 99;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      height: 100vh;\n      visibility: hidden;\n      transform: translateY(-100%);\n      ", "\n      ", "\n      transition: ", "s transform ease-in-out, ", "s visibility ease-in-out;\n      ", "\n\n      ", ";\n   }\n\n   ", "\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n   padding-bottom: 21px;\n   "], ["\n   padding-bottom: 21px;\n   "]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n      background: ", ";\n   "], ["\n      background: ", ";\n   "]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n      position: fixed;\n      padding-top: ", "rem;\n      padding-bottom: ", "rem;\n\n   "], ["\n      position: fixed;\n      padding-top: ", "rem;\n      padding-bottom: ", "rem;\n\n   "]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n      padding-top: ", "rem;\n      padding-bottom: ", "rem;\n   "], ["\n      padding-top: ", "rem;\n      padding-bottom: ", "rem;\n   "]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n         visibility: hidden ;\n         transform: translateY(-100%);\n         opacity: 0 ;\n      "], ["\n         visibility: hidden ;\n         transform: translateY(-100%);\n         opacity: 0 ;\n      "]),
	    _templateObject12 = _taggedTemplateLiteralLoose(["\n     float: right;\n\t \tmargin-top:39px;\n\t\t margin-right:138px;\n\t\t margin-left: 15px;\n\t\t ", "\n\t\t ", "\n\t\t ", "\n      a {\n         margin: 0 0.2rem;\n      }\n\n      img {\n         height: 23px;\n         width: 23px;\n      }\n"], ["\n     float: right;\n\t \tmargin-top:39px;\n\t\t margin-right:138px;\n\t\t margin-left: 15px;\n\t\t ", "\n\t\t ", "\n\t\t ", "\n      a {\n         margin: 0 0.2rem;\n      }\n\n      img {\n         height: 23px;\n         width: 23px;\n      }\n"]),
	    _templateObject13 = _taggedTemplateLiteralLoose(["\n\t \tmargin-top: 59px;\n\t\t "], ["\n\t \tmargin-top: 59px;\n\t\t "]),
	    _templateObject14 = _taggedTemplateLiteralLoose(["\n    margin-right: 0;\n    margin-right: 80px;\n\t margin-left: 0px;\n\n\t\t "], ["\n    margin-right: 0;\n    margin-right: 80px;\n\t margin-left: 0px;\n\n\t\t "]),
	    _templateObject15 = _taggedTemplateLiteralLoose(["\n             margin-top: 14px;\n             display:none;\n\t\t "], ["\n             margin-top: 14px;\n             display:none;\n\t\t "]),
	    _templateObject16 = _taggedTemplateLiteralLoose(["\ndisplay: block;\n   float: left;\n   cursor: pointer;\n   margin-top: 1rem;\n\n\n   ", "\n\n   span {\n      ", ";\n      ", ";\n   }\n   ", " ", ";\n"], ["\ndisplay: block;\n   float: left;\n   cursor: pointer;\n   margin-top: 1rem;\n\n\n   ", "\n\n   span {\n      ", ";\n      ", ";\n   }\n   ", " ", ";\n"]),
	    _templateObject17 = _taggedTemplateLiteralLoose(["\n   margin-top: 0.4rem;\n   "], ["\n   margin-top: 0.4rem;\n   "]),
	    _templateObject18 = _taggedTemplateLiteralLoose(["\n      display: block;\n   "], ["\n      display: block;\n   "]),
	    _templateObject19 = _taggedTemplateLiteralLoose(["\n      margin-top: 0.2rem;\n      div {\n         width: 2.574rem !important;\n         height: 1.452rem !important;\n         span {\n            height: 1px !important;\n         }\n      }\n   "], ["\n      margin-top: 0.2rem;\n      div {\n         width: 2.574rem !important;\n         height: 1.452rem !important;\n         span {\n            height: 1px !important;\n         }\n      }\n   "]),
	    _templateObject20 = _taggedTemplateLiteralLoose(["\n   position:absolute;\n   top:-5rem;\n   right: 3.5rem;\n\n   ", "\n"], ["\n   position:absolute;\n   top:-5rem;\n   right: 3.5rem;\n\n   ", "\n"]),
	    _templateObject21 = _taggedTemplateLiteralLoose(["\n      top:-2rem;\n   "], ["\n      top:-2rem;\n   "]),
	    _templateObject22 = _taggedTemplateLiteralLoose(["\n   ", ";\n\n   .mobileOnly{\n      display:none;\n   }\n\n   ", "\n\n   position: relative;\n   z-index: 100;\n\n\n   overflow-y:scroll;\n   -webkit-overflow-scrolling: touch;\n      visibility: hidden;\n      position: fixed;\n      background: ", ";\n      left:-100vw;\n      width: 100vw;\n      height: 100%;\n      transition: left ", "s ease-in-out, visibility ", "s ease-in-out;\n      margin-top:18px;\n      ", "\n      ", "\n      * { border-left: none !important;}\n      ", "\n\n   ", ";\n   padding-bottom:100px;\n\n   ul {\n      list-style: none;\n      margin-left: 0;\n      max-width: 100%;\n      ", "\n      display: block;\n      padding-bottom:0;\n      display:inline-block;\n\n\n\n         width: 100%;\n         float: none;\n\n\n      &:hover {\n         li {\n            opacity: 0.6;\n\n               opacity: 1;\n\n         }\n      }\n      li {\n         list-style: none;\n         padding-bottom:0;\n         display: block;\n         float: left;\n         opacity: 1;\n         border-left: 2px solid rgba(0,0,0,0);\n         transition: ", "s opacity ease-in-out, ", "s border-left ease-in-out;\n\t\t\t\t &.main i{\n\t\t\t\t\t background: #fff;\n\t\t\t\t\t text-transform: uppercase;\n\t\t\t\t\t padding: 5px 10px;\n\t\t\t\t\t color: #313130;\n\t\t\t\t }\n\n            float: none;\n            position: relative;\n            &:first-of-type {\n               a {\n                  border-top: 1px solid ", " }\n               }\n\n         &.dropdown {\n\n               position: relative;\n\n\n            .icon {\n\n                  transition: transform ", "s ease;\n                  content: '';\n                  display:block;\n                  height: 50px;\n                  width: 50px;\n                  position: absolute;\n                  right: 15px;\n                  top: 50%;\n                  transform: translateY(-50%);\n                  background-image: url('/svg/arrow-right-white.svg');\n\n            }\n            &.dropped .icon{\n               transform: rotate(90deg);\n            }\n         }\n         a {\n            text-decoration:none;\n            text-transform: uppercase;\n            font-weight: normal;\n            font-size: 1.3rem;\n            padding-top: 6rem;\n            // margin-right: 2rem;\n            padding-bottom: 4.5rem;\n            padding-left: 1rem;\n            padding-right: 1rem;\n            display: block;\n            transition:  ", "s border-top ease-in-out, ", "s color ease-in-out, ", "s border-top-color ease-in-out;\n            font-size: 1.8rem;\n            padding-left: 2rem;\n            padding-right: 2rem;\n            padding-top: 2rem;\n            padding-bottom: 2rem;\n            border-bottom: 1px solid ", ";\n\n            ", "\n            ", "\n            ", "\n            ", "\n            &.active {\n               border-top: 0.6rem solid ", ";\n\n               padding-left: 2rem;\n               padding-right: 2rem;\n               padding-top: 1.6rem;\n               padding-bottom: 1.6rem;\n\n                  border-top: none;\n                  background:  ", ";\n\n               .theme-dark &, .theme-trans & {\n                  border-top-color: ", ";\n               }\n            }\n         }\n\n         &:hover{\n            opacity: 1;\n         }\n\n         ul {\n            display: block;\n            text-align: left;\n            visibility: hidden;\n            opacity: 0;\n            transition: ", "s visibility ease-in-out, ", "s opacity ease-in-out;\n            position: absolute;\n            color: ", ";\n            z-index: 101;\n            margin-left: -2px;\n            border-left-width: 2px;\n            border-left-style: solid;\n            border-image: linear-gradient(to bottom, ", ", rgba(0, 0, 0, 0)) 1 100%;\n\n            .theme-dark &, .theme-trans & {\n               border-image: linear-gradient(to bottom, ", ", rgba(0, 0, 0, 0)) 1 100%;\n               color: ", ";\n            }\n\n               visibility: visible;\n               opacity: 1;\n               position: relative;\n               border: none;\n               background:  ", ";\n               overflow: hidden;\n               max-height: 0;\n               transition-property: all;\n               transition-duration: ", "s;\n               transition-timing-function: cubic-bezier(0, 1, 2, 1);\n\n\n            li {\n               float: none;\n\n                  border: none;\n\n               a {\n                  font-family: ", ";\n                  font-weight: normal;\n                  font-size:3.2rem;\n                  text-transform: none;\n                  padding-bottom:2rem;\n                  padding-top: 0;\n                  transition: ", "s opacity ease-in-out;\n                  opacity: 1;\n                  &:hover {\n                     opacity: 0.4;\n                  }\n\t\t\t\t\t\t\t\t\t&.active{\n\n\t\t\t\t\t\t\t\t\t\tborder-top: none;\n\t\t\t\t\t\t\t\t\t\topacity: 0.7;\n\t\t\t\t\t\t\t\t\t}\n                  // ", "\n\n                     font-size: 1.6rem;\n                     padding-left: ", "rem;\n                     padding-right: 2rem;\n                     padding-top: 1.6rem;\n                     padding-bottom: 1.6rem;\n                     border-bottom: 1px solid ", ";\n                     font-family: ", ";\n                     text-transform: uppercase;\n                     color: ", ";\n\n\n               }\n            }\n         }\n         &:hover {\n            opacity: 1;\n\n            &.dropdown {\n               border-left: 2px solid ", ";\n\n               .theme-dark &, .theme-trans & {\n                  border-left: 2px solid ", ";\n               }\n            }\n\n            ul {\n               visibility:visible;\n               opacity: 1;\xA0\n\n               li {\n                  opacity: 1;\n                  border-left: 0;\n\n                     border-left: 2px solid rgba(0,0,0,0);\n\n               }\n            }\n         }\n\n         &.dropped ul {\n            max-height: 360px;\n         }\n\n         &:last-of-type a {\n            margin-right: 0;\n         }\n\n      }\n   }\n"], ["\n   ", ";\n\n   .mobileOnly{\n      display:none;\n   }\n\n   ", "\n\n   position: relative;\n   z-index: 100;\n\n\n   overflow-y:scroll;\n   -webkit-overflow-scrolling: touch;\n      visibility: hidden;\n      position: fixed;\n      background: ", ";\n      left:-100vw;\n      width: 100vw;\n      height: 100%;\n      transition: left ", "s ease-in-out, visibility ", "s ease-in-out;\n      margin-top:18px;\n      ", "\n      ", "\n      * { border-left: none !important;}\n      ", "\n\n   ", ";\n   padding-bottom:100px;\n\n   ul {\n      list-style: none;\n      margin-left: 0;\n      max-width: 100%;\n      ", "\n      display: block;\n      padding-bottom:0;\n      display:inline-block;\n\n\n\n         width: 100%;\n         float: none;\n\n\n      &:hover {\n         li {\n            opacity: 0.6;\n\n               opacity: 1;\n\n         }\n      }\n      li {\n         list-style: none;\n         padding-bottom:0;\n         display: block;\n         float: left;\n         opacity: 1;\n         border-left: 2px solid rgba(0,0,0,0);\n         transition: ", "s opacity ease-in-out, ", "s border-left ease-in-out;\n\t\t\t\t &.main i{\n\t\t\t\t\t background: #fff;\n\t\t\t\t\t text-transform: uppercase;\n\t\t\t\t\t padding: 5px 10px;\n\t\t\t\t\t color: #313130;\n\t\t\t\t }\n\n            float: none;\n            position: relative;\n            &:first-of-type {\n               a {\n                  border-top: 1px solid ", " }\n               }\n\n         &.dropdown {\n\n               position: relative;\n\n\n            .icon {\n\n                  transition: transform ", "s ease;\n                  content: '';\n                  display:block;\n                  height: 50px;\n                  width: 50px;\n                  position: absolute;\n                  right: 15px;\n                  top: 50%;\n                  transform: translateY(-50%);\n                  background-image: url('/svg/arrow-right-white.svg');\n\n            }\n            &.dropped .icon{\n               transform: rotate(90deg);\n            }\n         }\n         a {\n            text-decoration:none;\n            text-transform: uppercase;\n            font-weight: normal;\n            font-size: 1.3rem;\n            padding-top: 6rem;\n            // margin-right: 2rem;\n            padding-bottom: 4.5rem;\n            padding-left: 1rem;\n            padding-right: 1rem;\n            display: block;\n            transition:  ", "s border-top ease-in-out, ", "s color ease-in-out, ", "s border-top-color ease-in-out;\n            font-size: 1.8rem;\n            padding-left: 2rem;\n            padding-right: 2rem;\n            padding-top: 2rem;\n            padding-bottom: 2rem;\n            border-bottom: 1px solid ", ";\n\n            ", "\n            ", "\n            ", "\n            ", "\n            &.active {\n               border-top: 0.6rem solid ", ";\n\n               padding-left: 2rem;\n               padding-right: 2rem;\n               padding-top: 1.6rem;\n               padding-bottom: 1.6rem;\n\n                  border-top: none;\n                  background:  ", ";\n\n               .theme-dark &, .theme-trans & {\n                  border-top-color: ", ";\n               }\n            }\n         }\n\n         &:hover{\n            opacity: 1;\n         }\n\n         ul {\n            display: block;\n            text-align: left;\n            visibility: hidden;\n            opacity: 0;\n            transition: ", "s visibility ease-in-out, ", "s opacity ease-in-out;\n            position: absolute;\n            color: ", ";\n            z-index: 101;\n            margin-left: -2px;\n            border-left-width: 2px;\n            border-left-style: solid;\n            border-image: linear-gradient(to bottom, ", ", rgba(0, 0, 0, 0)) 1 100%;\n\n            .theme-dark &, .theme-trans & {\n               border-image: linear-gradient(to bottom, ", ", rgba(0, 0, 0, 0)) 1 100%;\n               color: ", ";\n            }\n\n               visibility: visible;\n               opacity: 1;\n               position: relative;\n               border: none;\n               background:  ", ";\n               overflow: hidden;\n               max-height: 0;\n               transition-property: all;\n               transition-duration: ", "s;\n               transition-timing-function: cubic-bezier(0, 1, 2, 1);\n\n\n            li {\n               float: none;\n\n                  border: none;\n\n               a {\n                  font-family: ", ";\n                  font-weight: normal;\n                  font-size:3.2rem;\n                  text-transform: none;\n                  padding-bottom:2rem;\n                  padding-top: 0;\n                  transition: ", "s opacity ease-in-out;\n                  opacity: 1;\n                  &:hover {\n                     opacity: 0.4;\n                  }\n\t\t\t\t\t\t\t\t\t&.active{\n\n\t\t\t\t\t\t\t\t\t\tborder-top: none;\n\t\t\t\t\t\t\t\t\t\topacity: 0.7;\n\t\t\t\t\t\t\t\t\t}\n                  // ", "\n\n                     font-size: 1.6rem;\n                     padding-left: ", "rem;\n                     padding-right: 2rem;\n                     padding-top: 1.6rem;\n                     padding-bottom: 1.6rem;\n                     border-bottom: 1px solid ", ";\n                     font-family: ", ";\n                     text-transform: uppercase;\n                     color: ", ";\n\n\n               }\n            }\n         }\n         &:hover {\n            opacity: 1;\n\n            &.dropdown {\n               border-left: 2px solid ", ";\n\n               .theme-dark &, .theme-trans & {\n                  border-left: 2px solid ", ";\n               }\n            }\n\n            ul {\n               visibility:visible;\n               opacity: 1;\xA0\n\n               li {\n                  opacity: 1;\n                  border-left: 0;\n\n                     border-left: 2px solid rgba(0,0,0,0);\n\n               }\n            }\n         }\n\n         &.dropped ul {\n            max-height: 360px;\n         }\n\n         &:last-of-type a {\n            margin-right: 0;\n         }\n\n      }\n   }\n"]),
	    _templateObject23 = _taggedTemplateLiteralLoose(["\n\n   .mobileOnly{\n      display:block;\n   }\n   "], ["\n\n   .mobileOnly{\n      display:block;\n   }\n   "]),
	    _templateObject24 = _taggedTemplateLiteralLoose(["\n      margin-top:9px;\n\n   "], ["\n      margin-top:9px;\n\n   "]),
	    _templateObject25 = _taggedTemplateLiteralLoose(["\n            font-size: 1.8rem;\n            padding-left: 2rem;\n            padding-right: 2rem;\n            padding-top: 2rem;\n            padding-bottom: 2rem;\n            border-bottom: 1px solid ", ";\n            "], ["\n            font-size: 1.8rem;\n            padding-left: 2rem;\n            padding-right: 2rem;\n            padding-top: 2rem;\n            padding-bottom: 2rem;\n            border-bottom: 1px solid ", ";\n            "]),
	    _templateObject26 = _taggedTemplateLiteralLoose(["\n               font-size: 1.8rem;\n               padding-left: 2rem;\n               padding-right: 2rem;\n               padding-top: 2rem;\n               padding-bottom: 2rem;\n               border-bottom: 1px solid ", ";\n               "], ["\n               font-size: 1.8rem;\n               padding-left: 2rem;\n               padding-right: 2rem;\n               padding-top: 2rem;\n               padding-bottom: 2rem;\n               border-bottom: 1px solid ", ";\n               "]),
	    _templateObject27 = _taggedTemplateLiteralLoose(["\n                  //    font-size:2.8rem;\n                  // "], ["\n                  //    font-size:2.8rem;\n                  // "]),
	    _templateObject28 = _taggedTemplateLiteralLoose(["\n   width: 20rem;\n   margin-top: 5rem;\n   display:block;\n   position: relative;\n   z-index: 200;\n   // float: left;\n    margin-right: 3.3rem;\n    margin-left: auto;\n    margin-right: auto;\n\n   ", "\n   ", "\n\n   ", "\n   ", "\n"], ["\n   width: 20rem;\n   margin-top: 5rem;\n   display:block;\n   position: relative;\n   z-index: 200;\n   // float: left;\n    margin-right: 3.3rem;\n    margin-left: auto;\n    margin-right: auto;\n\n   ", "\n   ", "\n\n   ", "\n   ", "\n"]),
	    _templateObject29 = _taggedTemplateLiteralLoose(["\n      width: 18rem;\n      margin-top: 4.5rem;\n   "], ["\n      width: 18rem;\n      margin-top: 4.5rem;\n   "]),
	    _templateObject30 = _taggedTemplateLiteralLoose(["\n      width: 15rem;\n      margin-top: 2rem;\n   "], ["\n      width: 15rem;\n      margin-top: 2rem;\n   "]),
	    _templateObject31 = _taggedTemplateLiteralLoose(["\n\n      float: none;\n      margin: auto;\n      width: 25rem;\n"], ["\n\n      float: none;\n      margin: auto;\n      width: 25rem;\n"]),
	    _templateObject32 = _taggedTemplateLiteralLoose(["\n      width: 16.6rem;\n   "], ["\n      width: 16.6rem;\n   "]),
	    _templateObject33 = _taggedTemplateLiteralLoose([""], [""]),
	    _templateObject34 = _taggedTemplateLiteralLoose(["\ncursor:pointer;\n   width: 8.8rem;\n   height: 8.8rem;\n   background: ", ";\n   color: ", ";\n   text-decoration: none;\n   display: block;\n   border-radius: 100%;\n   text-transform: uppercase;\n   font-size: 1.4rem;\n   font-weight: normal;\n   margin-top: 1.3rem;\n   transition: ", "s background ease-in-out;\n\t position: relative;\n\t text-align:center;\n   span {\n      position: absolute;\n      transform: translate(-50%, -50%);\n      top: 53%;\n      left:50%;\n   }\n\n   ", "\n\n   ", "\n\t ", "\n   ", "\n//    \xA0", "\n\xA0\xA0", "\n   .theme-dark &, .theme-trans & {\n      background: ", ";\n      color: ", ";\n   }\n   .down {\n      display: block;\n      width: 1.8rem;\n      height: 1.1rem;\n      margin: auto;\n      margin-top: 3px;\n      ", ";\n   }\n\n   // &:hover {\n   //    background: ", ";\n   //    .theme-dark &,\n   //    .theme-trans & {\n   //       background: ", ";\n   //    }\n   // }\n"], ["\ncursor:pointer;\n   width: 8.8rem;\n   height: 8.8rem;\n   background: ", ";\n   color: ", ";\n   text-decoration: none;\n   display: block;\n   border-radius: 100%;\n   text-transform: uppercase;\n   font-size: 1.4rem;\n   font-weight: normal;\n   margin-top: 1.3rem;\n   transition: ", "s background ease-in-out;\n\t position: relative;\n\t text-align:center;\n   span {\n      position: absolute;\n      transform: translate(-50%, -50%);\n      top: 53%;\n      left:50%;\n   }\n\n   ", "\n\n   ", "\n\t ", "\n   ", "\n//    \xA0", "\n\xA0\xA0", "\n   .theme-dark &, .theme-trans & {\n      background: ", ";\n      color: ", ";\n   }\n   .down {\n      display: block;\n      width: 1.8rem;\n      height: 1.1rem;\n      margin: auto;\n      margin-top: 3px;\n      ", ";\n   }\n\n   // &:hover {\n   //    background: ", ";\n   //    .theme-dark &,\n   //    .theme-trans & {\n   //       background: ", ";\n   //    }\n   // }\n"]),
	    _templateObject35 = _taggedTemplateLiteralLoose(["\n      width: 6.5rem;\n      height: 6.5rem;\n      margin-top: 20px;\n      // margin-right:13px;\n      font-size: 1.2rem;\n         span {\n            top: 52%;\n            left:50%;\n         }\n   "], ["\n      width: 6.5rem;\n      height: 6.5rem;\n      margin-top: 20px;\n      // margin-right:13px;\n      font-size: 1.2rem;\n         span {\n            top: 52%;\n            left:50%;\n         }\n   "]),
	    _templateObject36 = _taggedTemplateLiteralLoose(["\n      margin-right:13px;\n   "], ["\n      margin-right:13px;\n   "]),
	    _templateObject37 = _taggedTemplateLiteralLoose(["\n\t\t\t\t margin-top: 5px;\n             font-size: 8px;\n             margin-right:13px;\n\t\t\t\t width: 5rem;\n             height: 5rem;\n             display: none;\n\n\t "], ["\n\t\t\t\t margin-top: 5px;\n             font-size: 8px;\n             margin-right:13px;\n\t\t\t\t width: 5rem;\n             height: 5rem;\n             display: none;\n\n\t "]),
	    _templateObject38 = _taggedTemplateLiteralLoose(["\n//       display: block;\n//       position: fixed;\n//       top: 2px;\n//       right: 2px;\n//       visibility: visible;\n// \xA0\xA0"], ["\n//       display: block;\n//       position: fixed;\n//       top: 2px;\n//       right: 2px;\n//       visibility: visible;\n// \xA0\xA0"]),
	    _templateObject39 = _taggedTemplateLiteralLoose(["\n      border-radius: 10%;\n      width: 6rem;\n      height: 3.5rem;\n      top: 1px;\n      right: 3px;\n      font-size: 1rem;\n      margin-right:9px;\n\xA0\xA0"], ["\n      border-radius: 10%;\n      width: 6rem;\n      height: 3.5rem;\n      top: 1px;\n      right: 3px;\n      font-size: 1rem;\n      margin-right:9px;\n\xA0\xA0"]),
	    _templateObject40 = _taggedTemplateLiteralLoose(["\n         display:none;\n      "], ["\n         display:none;\n      "]),
	    _templateObject41 = _taggedTemplateLiteralLoose(["\n   0%, 20%, 50%, 80%, 100% {\n      transform: translateX(0) rotate(-90deg);\n   }\n   40% {\n      transform: translateX(15px) rotate(-90deg);\n   }\n   60% {\n      transform: translateX(7px) rotate(-90deg);\n   }\n"], ["\n   0%, 20%, 50%, 80%, 100% {\n      transform: translateX(0) rotate(-90deg);\n   }\n   40% {\n      transform: translateX(15px) rotate(-90deg);\n   }\n   60% {\n      transform: translateX(7px) rotate(-90deg);\n   }\n"]),
	    _templateObject42 = _taggedTemplateLiteralLoose(["\n   position: fixed;\n   display: flex;\n   justify-content: space-around;\n   top: 0;\n   left: 0;\n   right: 0;\n   background: ", ";\n   color: ", ";\n   text-decoration: none;\n   text-align: center;\n   background: ", ";\n   color: ", ";\n   z-index: 1000;\n   transform: translateY(-200%);\n   font-weight: normal;\n   font-size: 1.8rem;\n   letter-spacing: 0.1rem;\n   transition: ", "s background ease-in-out, ", "s transform ease-in-out;\n   box-shadow: 0px 10px 69px -2px rgba(0, 0, 0, 0.75);\n   ", ";\n\n   ", "\n   // &:hover {\n   //    background: ", ";\n   // }\n\n   .icon {\n      text-decoration: none;\n      padding: 1.2rem 0 0 0;\n      svg {\n         width: 1.5rem;\n         height: 1rem;\n         margin-left: 1rem;\n         top: -2px;\n         position: relative;\n         right: 0;\n         display: inline-block;\n         animation: ", " 2s infinite;\n         /* ", " */\n      }\n   }\n\n\n   .yarrabend-logo svg {\n      /* float: left; */\n      width: auto;\n      height: 24px;\n      margin: .7rem;\n   }\n"], ["\n   position: fixed;\n   display: flex;\n   justify-content: space-around;\n   top: 0;\n   left: 0;\n   right: 0;\n   background: ", ";\n   color: ", ";\n   text-decoration: none;\n   text-align: center;\n   background: ", ";\n   color: ", ";\n   z-index: 1000;\n   transform: translateY(-200%);\n   font-weight: normal;\n   font-size: 1.8rem;\n   letter-spacing: 0.1rem;\n   transition: ", "s background ease-in-out, ", "s transform ease-in-out;\n   box-shadow: 0px 10px 69px -2px rgba(0, 0, 0, 0.75);\n   ", ";\n\n   ", "\n   // &:hover {\n   //    background: ", ";\n   // }\n\n   .icon {\n      text-decoration: none;\n      padding: 1.2rem 0 0 0;\n      svg {\n         width: 1.5rem;\n         height: 1rem;\n         margin-left: 1rem;\n         top: -2px;\n         position: relative;\n         right: 0;\n         display: inline-block;\n         animation: ", " 2s infinite;\n         /* ", " */\n      }\n   }\n\n\n   .yarrabend-logo svg {\n      /* float: left; */\n      width: auto;\n      height: 24px;\n      margin: .7rem;\n   }\n"]),
	    _templateObject43 = _taggedTemplateLiteralLoose(["\n      // padding: ", "rem;\n      display: none;\n      "], ["\n      // padding: ", "rem;\n      display: none;\n      "]),
	    _templateObject44 = _taggedTemplateLiteralLoose(["\n            width: 1.6rem;\n            height: 1rem;\n            top: -1px;\n         "], ["\n            width: 1.6rem;\n            height: 1rem;\n            top: -1px;\n         "]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _vars = __webpack_require__(7);
	
	var vars = _interopRequireWildcard(_vars);
	
	var _functions = __webpack_require__(6);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _logo = __webpack_require__(92);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _downArrow = __webpack_require__(110);
	
	var _downArrow2 = _interopRequireDefault(_downArrow);
	
	var _shader = __webpack_require__(50);
	
	var _shader2 = _interopRequireDefault(_shader);
	
	var _reactHamburgerMenu = __webpack_require__(135);
	
	var _reactHamburgerMenu2 = _interopRequireDefault(_reactHamburgerMenu);
	
	var _facebook = __webpack_require__(104);
	
	var _facebook2 = _interopRequireDefault(_facebook);
	
	var _menuChild = __webpack_require__(109);
	
	var _menuChild2 = _interopRequireDefault(_menuChild);
	
	var _instagram = __webpack_require__(106);
	
	var _instagram2 = _interopRequireDefault(_instagram);
	
	var _icoYarrabendResidentsApp = __webpack_require__(105);
	
	var _icoYarrabendResidentsApp2 = _interopRequireDefault(_icoYarrabendResidentsApp);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeaderMobileNav = function (_React$Component) {
	   _inherits(HeaderMobileNav, _React$Component);
	
	   function HeaderMobileNav(props) {
	      _classCallCheck(this, HeaderMobileNav);
	
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	      _this.state = {
	         dropped: false,
	         theme: "dark",
	         mobShown: false,
	         isIE: null,
	         enquiry: false,
	         menu: null,
	         nowSellingStatus: 'false'
	      };
	      return _this;
	   }
	
	   HeaderMobileNav.prototype.componentDidMount = function componentDidMount() {
	      if (typeof window !== "undefined") {
	         var dropdowns = document.querySelectorAll(".dropdown .icon");
	         dropdowns.forEach(function (elem) {
	            elem.addEventListener("click", function (event) {
	               event.preventDefault();
	               // console.log(elem.parentElement)
	               elem.parentElement.classList.toggle("dropped");
	            });
	         });
	         var links = document.querySelectorAll("header a");
	         links.forEach(function (elem) {
	            elem.addEventListener("click", function () {
	               // console.log(this.state.mobShown)
	               document.querySelector("body").classList.remove("fixed");
	
	               if (elem.getAttribute("href") == "/enquire") {
	                  document.getElementById('wrapper').className = "enquire";
	               } else {
	                  document.getElementById('wrapper').className = "";
	               }
	
	               this.setState({ mobShown: false });
	            }.bind(this));
	         }.bind(this));
	         this.setState({ isIE: /*@cc_on!@*/false || !!document.documentMode });
	
	         if (this.props.custom) {
	            this.setState({ theme: "dark" });
	         } else {
	            this.setState({ theme: this.props.theme });
	         }
	         if (this.props.menu) {
	            this.setState({ menu: this.props.menu.nav });
	         }
	
	         if (typeof window !== "undefined") {
	            if (window.location.pathname == '/artisan/artisan-residences' || window.location.pathname == '/artisan/artisan--culinary-house' || window.location.pathname == '/parkview/parkview-apartments' || window.location.pathname == '/parkview/parkview-houses' || window.location.pathname == '/the-mills/the-mills-townhouses') {
	               this.setState({ nowSellingStatus: 'active' });
	            }
	            window.addEventListener("scroll", function () {
	               if (window.scrollY > window.innerHeight) {
	                  this.setState({ enquiry: true });
	               } else {
	                  this.setState({ enquiry: false });
	               }
	            }.bind(this));
	         }
	      }
	   };
	
	   HeaderMobileNav.prototype.toggleMob = function toggleMob() {
	
	      document.querySelector("body").classList.toggle("fixed");
	      document.querySelector("header").classList.toggle("fixed");
	      var mobShown = !this.state.mobShown;
	
	      if (mobShown) {
	         document.body.style.overflow = 'hidden';
	         window.scrollTo({
	            top: 0,
	            behavior: "smooth"
	         });
	      } else {
	         document.body.style.overflow = 'unset';
	      }
	
	      this.setState({ mobShown: mobShown });
	   };
	
	   HeaderMobileNav.prototype.render = function render() {
	      var _this2 = this;
	
	      var menu = this.props.menu.nav;
	      var allMenu = [];
	
	      menu.map(function (menu_item, i) {
	         var label = menu_item.primary.label.text;
	         var link = menu_item.primary.link.text;
	         var children = [];
	
	         menu_item.items.map(function (child_menu_item, i) {
	            var label = child_menu_item.sub_nav_link_label.text;
	            var link = child_menu_item.sub_nav_link.text;
	            if (link != null) {
	               children.push({ id: i, label: label, link: link });
	            }
	         });
	
	         var dropdown_class = "";
	         var main_class = "";
	
	         if (children.length > 0) {
	            dropdown_class = ' dropdown ';
	         }
	
	         if (i == 0) {
	            main_class = ' main ';
	         }
	
	         allMenu.push({ id: i, label: label, link: link, children: children, dropdown_class: dropdown_class, main_class: main_class });
	
	         return allMenu;
	      });
	
	      // console.log(allMenu);
	
	      return _react2.default.createElement(
	         "div",
	         null,
	         _react2.default.createElement(
	            Container,
	            {
	               theme: this.state.theme,
	               dropped: this.state.dropped,
	               custom: this.props.custom,
	               className: "theme-" + this.state.theme },
	            _react2.default.createElement(
	               "div",
	               { className: "grid" },
	               _react2.default.createElement(
	                  "div",
	                  { className: "inner" },
	                  this.state.isIE === false ? _react2.default.createElement(
	                     Hamburger,
	                     { theme: this.state.theme },
	                     _react2.default.createElement(_reactHamburgerMenu2.default, {
	                        isOpen: this.state.mobShown,
	                        menuClicked: this.toggleMob.bind(this),
	                        width: 39,
	                        height: 22,
	                        strokeWidth: 2,
	                        color: vars.colors.blank,
	                        animationDuration: vars.time
	                     })
	                  ) : "",
	                  _react2.default.createElement(
	                     Logo,
	                     { to: "/", title: "YarraBend" },
	                     _react2.default.createElement(_logo2.default, null)
	                  ),
	                  _react2.default.createElement(
	                     Nav,
	                     { theme: this.state.theme, isOpen: this.state.mobShown },
	                     _react2.default.createElement(
	                        "ul",
	                        null,
	                        allMenu.map(function (item, i) {
	                           if (item.dropdown_class != '' && i == 0) {
	
	                              return _react2.default.createElement(
	                                 "li",
	                                 { className: item.dropdown_class + '' + item.main_class
	                                 },
	
	                                 //if internal check
	                                 /^\/(?!\/)/.test(item.link) === true ? _react2.default.createElement(
	                                    A,
	                                    { activeClassName: "active", className: _this2.state.nowSellingStatus, to: item.link, title: "" },
	                                    _react2.default.createElement(
	                                       "i",
	                                       null,
	                                       item.label
	                                    )
	                                 ) : _react2.default.createElement(
	                                    "a",
	                                    { activeClassName: "active", href: item.link, target: "_blank" },
	                                    _react2.default.createElement(
	                                       "i",
	                                       null,
	                                       item.label
	                                    )
	                                 ),
	                                 _react2.default.createElement("span", { className: "icon" }),
	                                 _react2.default.createElement(_menuChild2.default, { data: item.children })
	                              );
	                           } else if (item.dropdown_class != '') {
	
	                              return _react2.default.createElement(
	                                 "li",
	                                 { className: item.dropdown_class + '' + item.main_class
	                                 },
	
	                                 //if internal check
	                                 /^\/(?!\/)/.test(item.link) === true ? _react2.default.createElement(
	                                    A,
	                                    { activeClassName: "active", to: item.link, title: "" },
	                                    _react2.default.createElement(
	                                       "i",
	                                       null,
	                                       item.label
	                                    )
	                                 ) : _react2.default.createElement(
	                                    "a",
	                                    { activeClassName: "active", href: item.link, target: "_blank" },
	                                    _react2.default.createElement(
	                                       "i",
	                                       null,
	                                       item.label
	                                    )
	                                 ),
	                                 _react2.default.createElement("span", { className: "icon" }),
	                                 _react2.default.createElement(_menuChild2.default, { data: item.children })
	                              );
	                           } else {
	                              return _react2.default.createElement(
	                                 "li",
	                                 null,
	
	                                 //if internal check
	                                 /^\/(?!\/)/.test(item.link) === true ? _react2.default.createElement(
	                                    A,
	                                    { activeClassName: "active", to: item.link, title: "" },
	                                    _react2.default.createElement(
	                                       "i",
	                                       null,
	                                       item.label
	                                    )
	                                 ) : _react2.default.createElement(
	                                    "a",
	                                    { activeClassName: "active", href: item.link, target: "_blank" },
	                                    _react2.default.createElement(
	                                       "i",
	                                       null,
	                                       item.label
	                                    )
	                                 )
	                              );
	                           }
	                        }),
	                        _react2.default.createElement(
	                           "li",
	                           { className: "mobileOnly" },
	                           _react2.default.createElement(
	                              "a",
	                              { href: "https://app.propertyshell.com/auth/default/login", target: "_blank" },
	                              _react2.default.createElement(
	                                 "i",
	                                 null,
	                                 "Agent Login"
	                              )
	                           )
	                        )
	                     )
	                  ),
	                  _react2.default.createElement(
	                     ActionWrapper,
	                     null,
	                     _react2.default.createElement(
	                        AgentLink,
	                        null,
	                        _react2.default.createElement(
	                           "a",
	                           { href: "https://app.propertyshell.com/auth/default/login", target: "_blank" },
	                           "Agent Login"
	                        )
	                     ),
	                     _react2.default.createElement(
	                        Social,
	                        null,
	                        _react2.default.createElement(
	                           "a",
	                           { href: "https://www.facebook.com/yarrabend", target: "_blank" },
	                           _react2.default.createElement("img", { src: _facebook2.default, alt: "Glenvill logo" })
	                        ),
	                        _react2.default.createElement(
	                           "a",
	                           { href: "https://www.instagram.com/yarrabend_/", target: "_blank" },
	                           _react2.default.createElement("img", { src: _instagram2.default, alt: "Glenvill logo" })
	                        ),
	                        _react2.default.createElement(
	                           "a",
	                           { href: "/yarrabend-residents-app/" },
	                           _react2.default.createElement("img", { src: _icoYarrabendResidentsApp2.default, alt: "YarraBend Residents App icon" })
	                        )
	                     ),
	                     this.props.hideEnquire ? '' : _react2.default.createElement(
	                        EnquireBadge,
	                        { className: "pull-right", onClick: function onClick(e) {
	                              _this2.props.togglePopup();
	                           } },
	                        _react2.default.createElement(
	                           "span",
	                           null,
	                           "Enquire Now"
	                        )
	                     )
	                  )
	               )
	            ),
	            _react2.default.createElement("div", { className: "overlay" })
	         ),
	         _react2.default.createElement(
	            EnquireBanner,
	            { visi: this.state.enquiry },
	            _react2.default.createElement(
	               _gatsbyLink2.default,
	               { to: "/", className: "yarrabend-logo" },
	               _react2.default.createElement(_logo2.default, null)
	            ),
	            this.props.hideEnquire ? '' : _react2.default.createElement(
	               "span",
	               { onClick: function onClick(e) {
	                     _this2.props.togglePopup();
	                  }, className: "icon" },
	               _react2.default.createElement(
	                  "span",
	                  null,
	                  "Enquire now",
	                  _react2.default.createElement(_downArrow2.default, null)
	               )
	            )
	         )
	      );
	   };
	
	   return HeaderMobileNav;
	}(_react2.default.Component);
	
	var AgentLink = _styledComponents2.default.div(_templateObject, _functions.above.giant(_templateObject2), _functions.below.mid(_templateObject3), _functions.below.desktop(_templateObject4), _functions.below.tablet(_templateObject5));
	
	var Container = _styledComponents2.default.header(_templateObject6, _functions.above.l(_templateObject7), function (props) {
	   return props.theme == "light" && "\n      background: " + vars.colors.offColor + ";\n   ";
	}, function (props) {
	   return props.theme == "dark" && "\n      background: " + vars.colors.body + ";\n      color: " + vars.colors.blank + ";\n   ";
	}, function (props) {
	   return props.theme == "trans" && "\n      background: none;\n      position: absolute;\n      left: 0;\n      right: 0;\n      color: " + vars.colors.blank + ";\n   ";
	}, function (props) {
	   return props.theme == "trans" && _functions.below.tablet(_templateObject8, vars.colors.body);
	}, vars.colors.body, _functions.below.tablet(_templateObject9, vars.padding.tabInner, vars.padding.tabInner), _functions.below.mobile(_templateObject10, vars.padding.mobInner, vars.padding.mobInner), vars.colors.offColor, vars.colors.offColor, function (props) {
	   return props.theme == "dark" && "\n         background: linear-gradient(to bottom, " + vars.colors.body + " 0%," + vars.colors.body + " 20%,rgba(0,0,0,0) 100%);\n      ";
	}, function (props) {
	   return props.theme == "trans" && "\n         background: linear-gradient(to bottom, " + vars.colors.body + " 0%," + vars.colors.body + " 10%,rgba(0,0,0,0) 100%);\n      ";
	}, vars.time * 1.5, vars.time * 1.5, function (props) {
	   return props.dropped && "\n         transform: translateY(0%);\n         visibility: visible;\n         opacity: 1;\n      ";
	}, _functions.below.tablet(_templateObject11), function (props) {
	   return props.custom && "\n      background: " + props.custom + ";\n   .overlay {\n      background: linear-gradient(to bottom, " + props.custom + " 0%," + props.custom + " 10%,rgba(0, 0, 0, 0) 100%);\n   }\n\n   ";
	});
	
	var Social = _styledComponents2.default.div(_templateObject12, _functions.above.giant(_templateObject13), _functions.below.mid(_templateObject14), _functions.below.desktop(_templateObject15));
	
	var Hamburger = _styledComponents2.default.div(_templateObject16, _functions.above.desktop(_templateObject17), function (props) {
	   return props.theme == "light" && "\n         background: " + vars.colors.body + " !important;\n      ";
	}, function (props) {
	   return props.theme == "white" && "\n         background: " + vars.colors.body + " !important;\n      ";
	}, _functions.below.tablet(_templateObject18), _functions.below.mobile(_templateObject19));
	var ActionWrapper = _styledComponents2.default.div(_templateObject20, _functions.below.desktop(_templateObject21));
	var Nav = _styledComponents2.default.nav(_templateObject22, (0, _functions.clearFix)(), _functions.below.tablet(_templateObject23), vars.colors.body, vars.time, vars.time, function (props) {
	   return props.theme == "light" && "\n         background: " + vars.colors.offColor + ";\n      ";
	}, function (props) {
	   return props.theme == "white" && "\n         background: " + vars.colors.blank + ";\n      ";
	}, function (props) {
	   return props.isOpen && "\n         visibility: visible;\n         left: 0;\n      ";
	}, _functions.below.mobile(_templateObject24), _functions.clearFix, vars.time, vars.time * 1.5, (0, _shader2.default)(vars.colors.body, +0.2), vars.time, vars.time, vars.time, vars.time, (0, _shader2.default)(vars.colors.body, +0.2), _functions.below.giant(_templateObject25, (0, _shader2.default)(vars.colors.body, +0.2)), _functions.below.l(_templateObject25, (0, _shader2.default)(vars.colors.body, +0.2)), _functions.below.desktop(_templateObject25, (0, _shader2.default)(vars.colors.body, +0.2)), _functions.below.tablet(_templateObject26, (0, _shader2.default)(vars.colors.body, +0.2)), vars.colors.body, (0, _shader2.default)(vars.colors.body, +0.2), vars.colors.blank, vars.time * 1.5, vars.time * 1.5, vars.colors.body, vars.colors.body, vars.colors.blank, vars.colors.blank, (0, _shader2.default)(vars.colors.body, +0.1), vars.time, vars.fonts.feature, vars.time, _functions.below.l(_templateObject27), vars.padding.mobInner * 2, vars.colors.blank, vars.fonts.main, vars.colors.blank, vars.colors.body, vars.colors.blank);
	
	var Logo = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject28, _functions.below.l(_templateObject29), _functions.below.desktop(_templateObject30), _functions.below.tablet(_templateObject31), _functions.below.mobile(_templateObject32));
	
	var A = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject33);
	
	var EnquireBadge = _styledComponents2.default.button(_templateObject34, vars.colors.body, vars.colors.blank, vars.time * 2, _functions.below.l(_templateObject35), _functions.below.mid(_templateObject36), _functions.below.desktop(_templateObject37), _functions.below.tablet(_templateObject5), _functions.below.tablet(_templateObject38), _functions.below.mobile(_templateObject39), vars.colors.blank, vars.colors.body, _functions.below.l(_templateObject40), (0, _shader2.default)(vars.colors.body, +0.2), (0, _shader2.default)(vars.colors.blank, -0.2));
	
	var nudge = (0, _styledComponents.keyframes)(_templateObject41);
	
	var EnquireBanner = _styledComponents2.default.div(_templateObject42, vars.colors.blank, vars.colors.body, vars.colors.body, vars.colors.blank, vars.time, vars.time, function (props) {
	   return props.visi && "\n      transform:translateY(0);\n      ";
	}, _functions.below.tablet(_templateObject43, vars.padding.inner / 3), (0, _shader2.default)(vars.colors.body, +0.2), nudge, _functions.below.tablet(_templateObject44));
	
	exports.default = HeaderMobileNav;
	
	// export const pageQuery = graphql`
	// query {
	//    prismicMainNavigation {
	//      id
	//      dataString
	//      data {
	//        display_name {
	//          html
	//          text
	//        }
	//        nav {
	//          slice_type
	//          primary {
	//            label {
	//              text
	//            }
	//            link {
	//              text
	//            }
	//          }
	//          items {
	//            sub_nav_link_label {
	//              text
	//            }
	//            sub_nav_link {
	//              text
	//            }
	//          }
	//        }
	//      }
	//    }
	//  }
	// `
	
	module.exports = exports["default"];

/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n\n"], ["\n\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n   align-items: center;\n   color: ", ";\n   background: ", ";\n   display: flex;\n   height: 84vmin;\n\t min-height: 76rem;\n   max-height: 125rem;\n\n\t", "\n   h1 {\n      max-width: 120rem;\n\t\t\t", ";\n   }\n   p {\n      padding-bottom: ", "rem;\n   }\n   .copy {\n      padding-top: 12%;\n      position: relative;\n      z-index: 12;\n      ", ";\n\t\t", ";\n   }\n\n   .img {\n      position: absolute;\n      width: 100%;\n      overflow: hidden;\n      top: 0%;\n      max-height: 150rem;\n       img, .gradient, video {\n         width: 100%;\n         min-height: 145vh;\n         object-fit: cover;\n         max-width: none;\n\n      }\n\t\t\t", ";\n      .gradient {\n\t\t\t\tposition: absolute; \n\t\t\t\tz-index: 10;\n\t\t\t\ttop:0;\n         background: radial-gradient(\n            rgba(255, 255, 255, 0) 40%,\n            rgba(63, 62, 62, 0.3) 60%\n         );\n         height: 120%;\n\t\t\t\t ", "\n      }\n   }\n\n   .down {\n      width: 3rem;\n      height: 3rem;\n      display: block;\n      background-image: url(\"/svg/down-white.svg\");\n      background-repeat: no-repeat;\n      background-size: 100%;\n   }\n"], ["\n   align-items: center;\n   color: ", ";\n   background: ", ";\n   display: flex;\n   height: 84vmin;\n\t min-height: 76rem;\n   max-height: 125rem;\n\n\t", "\n   h1 {\n      max-width: 120rem;\n\t\t\t", ";\n   }\n   p {\n      padding-bottom: ", "rem;\n   }\n   .copy {\n      padding-top: 12%;\n      position: relative;\n      z-index: 12;\n      ", ";\n\t\t", ";\n   }\n\n   .img {\n      position: absolute;\n      width: 100%;\n      overflow: hidden;\n      top: 0%;\n      max-height: 150rem;\n       img, .gradient, video {\n         width: 100%;\n         min-height: 145vh;\n         object-fit: cover;\n         max-width: none;\n\n      }\n\t\t\t", ";\n      .gradient {\n\t\t\t\tposition: absolute; \n\t\t\t\tz-index: 10;\n\t\t\t\ttop:0;\n         background: radial-gradient(\n            rgba(255, 255, 255, 0) 40%,\n            rgba(63, 62, 62, 0.3) 60%\n         );\n         height: 120%;\n\t\t\t\t ", "\n      }\n   }\n\n   .down {\n      width: 3rem;\n      height: 3rem;\n      display: block;\n      background-image: url(\"/svg/down-white.svg\");\n      background-repeat: no-repeat;\n      background-size: 100%;\n   }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n\t\tmin-height: 59rem;\n\t"], ["\n\t\tmin-height: 59rem;\n\t"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n         max-width: 110rem;\n\t\t\tbr { display: none; }\n\t\t"], ["\n         max-width: 110rem;\n\t\t\tbr { display: none; }\n\t\t"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n\t\tpadding-top: 6%;\n\t\t"], ["\n\t\tpadding-top: 6%;\n\t\t"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n\t\tz-index: 12;\n\t\t"], ["\n\t\tz-index: 12;\n\t\t"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n\t\t\t\timg{\n\t\t\t\tdisplay:none;\n\t\t\t\t}\n\t\t\t"], ["\n\t\t\t\timg{\n\t\t\t\tdisplay:none;\n\t\t\t\t}\n\t\t\t"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n\t\t\t\t background: radial-gradient(\n            rgba(255, 255, 255, 0) 40%,\n            rgba(63, 62, 62, 0.1) 60%\n         );\n\t\t\t\t \t"], ["\n\t\t\t\t background: radial-gradient(\n            rgba(255, 255, 255, 0) 40%,\n            rgba(63, 62, 62, 0.1) 60%\n         );\n\t\t\t\t \t"]),
	    _templateObject9 = _taggedTemplateLiteralLoose([""], [""]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _vars = __webpack_require__(7);
	
	var vars = _interopRequireWildcard(_vars);
	
	var _functions = __webpack_require__(6);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _shader = __webpack_require__(50);
	
	var _shader2 = _interopRequireDefault(_shader);
	
	var _reactHtmlParser = __webpack_require__(1110);
	
	var _reactHtmlParser2 = _interopRequireDefault(_reactHtmlParser);
	
	var _video = __webpack_require__(46);
	
	var _video2 = _interopRequireDefault(_video);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Parra = function (_React$Component) {
	   _inherits(Parra, _React$Component);
	
	   function Parra() {
	      _classCallCheck(this, Parra);
	
	      return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	   }
	
	   Parra.prototype.render = function render() {
	      function scroll(e) {
	         if (typeof window !== "undefined") {
	            var scrollDistance = window.pageYOffset;
	            window.scrollTo({
	               top: scrollDistance + window.innerHeight,
	               behavior: "smooth"
	            });
	         }
	      }
	      return _react2.default.createElement(
	         Container,
	         { className: "parra-container" },
	         _react2.default.createElement(
	            "div",
	            { className: "copy grid" },
	            _react2.default.createElement(
	               "div",
	               { className: "inner" },
	               _react2.default.createElement(
	                  "h1",
	                  null,
	                  (0, _reactHtmlParser2.default)(this.props.title)
	               ),
	               this.props.videoUrl ? _react2.default.createElement(_video2.default, { url: this.props.videoUrl, poster: "Watch the video \u2192", popup: true }) : "",
	               _react2.default.createElement("div", { className: "down", onClick: scroll })
	            )
	         ),
	         _react2.default.createElement(
	            "div",
	            { className: "img", id: "scene" },
	            _react2.default.createElement(
	               InlineVideo,
	               { autoPlay: true, loop: true, muted: true, playsInline: true },
	               _react2.default.createElement("source", { src: "https://s3-ap-southeast-2.amazonaws.com/cornwell-misc/yarra-bend/video-v2.mp4", type: "video/mp4" }),
	               _react2.default.createElement("source", { src: "https://s3-ap-southeast-2.amazonaws.com/cornwell-misc/yarra-bend/video-v2.webm", type: "video/webm" })
	            ),
	            _react2.default.createElement("div", { "data-depth": "1", className: "gradient" })
	         )
	      );
	   };
	
	   return Parra;
	}(_react2.default.Component);
	
	var InlineVideo = _styledComponents2.default.video(_templateObject);
	var Container = _styledComponents2.default.div(_templateObject2, vars.colors.blank, vars.colors.body, _functions.below.mobile(_templateObject3), _functions.below.giant(_templateObject4), vars.padding.inner, _functions.below.xl(_templateObject5), _functions.below.mobile(_templateObject6), _functions.above.mobile(_templateObject7), _functions.below.mobile(_templateObject8));
	var DownArrow = _styledComponents2.default.div(_templateObject9);
	
	exports.default = Parra;
	module.exports = exports["default"];

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n   ", "\n   ", "\n"], ["\n   ", "\n   ", "\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n   padding: 0;\n   position: relative;\n   width: ", ";\n   margin: auto;\n   padding-bottom: ", "rem;\n\t ", "\n\t ", ";\n\t ", ";\n   .slick-arrow {\n      width: auto;\n      height: auto;\n      /* top: 80vmin; */\n      /* bottom: auto; */\n      /* left: auto; */\n      right: auto;\n      margin: 0 4vw;\n      z-index: 3;\n\n      &:hover {\n         opacity: 1;\n      }\n      &:before {\n         content: '';\n         display: block;\n         width: 8vw;\n         max-width: 3.5rem;\n         height: 8vw;\n         max-height: 3.5rem;\n         background: url(", ") no-repeat;\n      }\n\n      ", ";\n   }\n\n   .slick-prev {\n      right: 5rem;\n      &:before {\n         transform: scaleX(-1);\n      }\n      ", ";\n   }\n\n   .slick-next {\n      right: 0;\n      ", ";\n   }\n\t .slick-dots {\n      margin-left: 17rem;\n      bottom: 9%;\n      width: auto;\n      list-style: none;\n      text-align: center;\n      li {\n\n\t\t\t button {\n         background: transparent;\n         border: 1px solid white;\n         border-radius: 50%;\n\t\t\t\t width:20px;\n\t\t\t\t height:20px;\n\t\t\t\t &:before, &:after{\n\t\t\t\t\twidth:20px;\n\t\t\t\t height:20px;\n\t\t\t\t }\n         :hover:before {\n            background: white;\n            opacity: 1;\n         }\n         :before {\n            content: '';\n            background-color: white;\n            border-radius: 50%;\n            opacity: 0;\n            transition: opacity .5s;\n         }\n      }\n\t\t\t&.slick-active button:before{\n\t\t\t\tbackground: white;\n            opacity: 1;\n\t\t\t}\n\t }\n\n      ", "\n   }\n\n   h3 {\n\t\tfont-family: ", ";\n\t\tfont-weight:normal;\n\n\t\tfont-size:2.3rem;\n\t\tfont-weight: normal;\n\t\t", "\n\t\t", "\n      padding-bottom: ", "rem;\n   }\n\t .grid .col{\n\t\t min-height: 30rem;\n\t\t ", "\n\t }\n   .grid .col:first-of-type {\n      border-left: 1px solid ", ";\n\t\t\tpadding-left: ", "rem;\n\t\t\t", "\n   }\n\n   .border-left {\n      border-left: 1px solid ", ";\n\t\t\tpadding-left: ", "rem;\n   }\n   .mob-border-left {\n      border-left-width: 0;\n\t\t\tpadding-left: ", "rem;\n\n      ", "\n   }\n\n   ", "\n"], ["\n   padding: 0;\n   position: relative;\n   width: ", ";\n   margin: auto;\n   padding-bottom: ", "rem;\n\t ", "\n\t ", ";\n\t ", ";\n   .slick-arrow {\n      width: auto;\n      height: auto;\n      /* top: 80vmin; */\n      /* bottom: auto; */\n      /* left: auto; */\n      right: auto;\n      margin: 0 4vw;\n      z-index: 3;\n\n      &:hover {\n         opacity: 1;\n      }\n      &:before {\n         content: '';\n         display: block;\n         width: 8vw;\n         max-width: 3.5rem;\n         height: 8vw;\n         max-height: 3.5rem;\n         background: url(", ") no-repeat;\n      }\n\n      ", ";\n   }\n\n   .slick-prev {\n      right: 5rem;\n      &:before {\n         transform: scaleX(-1);\n      }\n      ", ";\n   }\n\n   .slick-next {\n      right: 0;\n      ", ";\n   }\n\t .slick-dots {\n      margin-left: 17rem;\n      bottom: 9%;\n      width: auto;\n      list-style: none;\n      text-align: center;\n      li {\n\n\t\t\t button {\n         background: transparent;\n         border: 1px solid white;\n         border-radius: 50%;\n\t\t\t\t width:20px;\n\t\t\t\t height:20px;\n\t\t\t\t &:before, &:after{\n\t\t\t\t\twidth:20px;\n\t\t\t\t height:20px;\n\t\t\t\t }\n         :hover:before {\n            background: white;\n            opacity: 1;\n         }\n         :before {\n            content: '';\n            background-color: white;\n            border-radius: 50%;\n            opacity: 0;\n            transition: opacity .5s;\n         }\n      }\n\t\t\t&.slick-active button:before{\n\t\t\t\tbackground: white;\n            opacity: 1;\n\t\t\t}\n\t }\n\n      ", "\n   }\n\n   h3 {\n\t\tfont-family: ", ";\n\t\tfont-weight:normal;\n\n\t\tfont-size:2.3rem;\n\t\tfont-weight: normal;\n\t\t", "\n\t\t", "\n      padding-bottom: ", "rem;\n   }\n\t .grid .col{\n\t\t min-height: 30rem;\n\t\t ", "\n\t }\n   .grid .col:first-of-type {\n      border-left: 1px solid ", ";\n\t\t\tpadding-left: ", "rem;\n\t\t\t", "\n   }\n\n   .border-left {\n      border-left: 1px solid ", ";\n\t\t\tpadding-left: ", "rem;\n   }\n   .mob-border-left {\n      border-left-width: 0;\n\t\t\tpadding-left: ", "rem;\n\n      ", "\n   }\n\n   ", "\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n\t \tpadding-bottom: 0;\n\t "], ["\n\t \tpadding-bottom: 0;\n\t "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n\t \t.grid{\n\t\t\t padding-left: 0;\n\t\t\t padding-right: 0;\n\t\t }\n\t "], ["\n\t \t.grid{\n\t\t\t padding-left: 0;\n\t\t\t padding-right: 0;\n\t\t }\n\t "]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n\t\t img, source{\n\t\t\t height: auto !important;\n\t\t\t min-height: none !important;\n\t\t }\n\t\t//  .slick-arrow{\n\t\t// \t display: none !important;\n\t\t//  }\n\t\t//  .slick-dots{\n\t\t// \t left: 0 !important;\n\t\t// \t transform: none !important;\n\t\t//  }\n\t\t .slick-dots li{\n\t\t\t margin: 0;\n\t\t\t &.slick-active button:before{\n\t\t\t\tbackground: #3f3e3e !important;\n            opacity: 1;\n\t\t\t}\n\t\t }\n\t\t .slick-dots li button{\n\t\t\t border: 1px solid #3f3e3e !important;\n\n\t\t }\n\t\t .slick-dots li button, .slick-dots li button:after, .slick-dots li button:before {\n\t\t\t width: 12px !important;\n\t\t\t height: 12px !important;\n\t\t }\n\t "], ["\n\t\t img, source{\n\t\t\t height: auto !important;\n\t\t\t min-height: none !important;\n\t\t }\n\t\t//  .slick-arrow{\n\t\t// \t display: none !important;\n\t\t//  }\n\t\t//  .slick-dots{\n\t\t// \t left: 0 !important;\n\t\t// \t transform: none !important;\n\t\t//  }\n\t\t .slick-dots li{\n\t\t\t margin: 0;\n\t\t\t &.slick-active button:before{\n\t\t\t\tbackground: #3f3e3e !important;\n            opacity: 1;\n\t\t\t}\n\t\t }\n\t\t .slick-dots li button{\n\t\t\t border: 1px solid #3f3e3e !important;\n\n\t\t }\n\t\t .slick-dots li button, .slick-dots li button:after, .slick-dots li button:before {\n\t\t\t width: 12px !important;\n\t\t\t height: 12px !important;\n\t\t }\n\t "]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n         // top: 80vmin;\n         // margin: 0 1vw;\n         top:auto;\n         bottom:20px;\n         transform:none;\n         margin:0;\n      "], ["\n         // top: 80vmin;\n         // margin: 0 1vw;\n         top:auto;\n         bottom:20px;\n         transform:none;\n         margin:0;\n      "]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n         left: 20px;\n      "], ["\n         left: 20px;\n      "]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n         left: 50px;\n      "], ["\n         left: 50px;\n      "]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n         margin: 0;\n         left: 50%;\n         bottom: 3%;\n         bottom: 20px;\n         transform: translateX(-50%);\n      "], ["\n         margin: 0;\n         left: 50%;\n         bottom: 3%;\n         bottom: 20px;\n         transform: translateX(-50%);\n      "]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n\t\t\tfont-size:2.3rem;\n\t\t"], ["\n\t\t\tfont-size:2.3rem;\n\t\t"]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n\t\t\tfont-size:2rem;\n\t\t"], ["\n\t\t\tfont-size:2rem;\n\t\t"]),
	    _templateObject12 = _taggedTemplateLiteralLoose(["\n\t\t \tmin-height: 0;\n\t\t\t padding-left: ", "rem;\n\t\t\t border-left: 1px solid ", ";\n\n\t\t "], ["\n\t\t \tmin-height: 0;\n\t\t\t padding-left: ", "rem;\n\t\t\t border-left: 1px solid ", ";\n\n\t\t "]),
	    _templateObject13 = _taggedTemplateLiteralLoose(["\n\t\t\t\tpadding-left: ", "rem;\n\t\t\t"], ["\n\t\t\t\tpadding-left: ", "rem;\n\t\t\t"]),
	    _templateObject14 = _taggedTemplateLiteralLoose(["\n         border-left-width: 0.2rem;\n      "], ["\n         border-left-width: 0.2rem;\n      "]),
	    _templateObject15 = _taggedTemplateLiteralLoose(["\n      margin-bottom: ", "vmin;\n   "], ["\n      margin-bottom: ", "vmin;\n   "]),
	    _templateObject16 = _taggedTemplateLiteralLoose(["\n   // margin-bottom: ", "rem;\n   img, source {\n      width: 100%;\n      height: 70vh;\n\t\t\tmin-height: 35rem;\n      object-fit: cover;\n   }\n\t .anchor-Bottom {\n      img, source {\n         object-position: bottom;\n      }\n\t }\n   .anchor-Top {\n      img, source {\n         object-position: top;\n      }\n   }\n   .anchor-Center {\n      img, source {\n         object-position: center;\n      }\n   }\n   .slideCaption{\n      position:absolute;\n      bottom:0;\n      left:0;\n      bottom: 47px;\n    left: 83px;\n      ", ";\n\n   }\n\n   .slideTitle {\n      letter-spacing: .03rem;\n      font-family: 'CaslonGraD',Times,serif;\n      font-weight: normal;\n      font-size: 5.7rem;\n      line-height: 1;\n      color:#fff;\n      white-space: pre-line;\n      padding-bottom:.28em;\n      ", ";\n      ", ";\n\n  }\n   .slideSubTitle{\n      font-size: 2.1rem;\n      line-height: 1.4;\n      letter-spacing: 0.05em;\n      color:#fff;\n      white-space: pre-line;\n\n      ", ";\n      ", ";\n   }\n   // ", "\n"], ["\n   // margin-bottom: ", "rem;\n   img, source {\n      width: 100%;\n      height: 70vh;\n\t\t\tmin-height: 35rem;\n      object-fit: cover;\n   }\n\t .anchor-Bottom {\n      img, source {\n         object-position: bottom;\n      }\n\t }\n   .anchor-Top {\n      img, source {\n         object-position: top;\n      }\n   }\n   .anchor-Center {\n      img, source {\n         object-position: center;\n      }\n   }\n   .slideCaption{\n      position:absolute;\n      bottom:0;\n      left:0;\n      bottom: 47px;\n    left: 83px;\n      ", ";\n\n   }\n\n   .slideTitle {\n      letter-spacing: .03rem;\n      font-family: 'CaslonGraD',Times,serif;\n      font-weight: normal;\n      font-size: 5.7rem;\n      line-height: 1;\n      color:#fff;\n      white-space: pre-line;\n      padding-bottom:.28em;\n      ", ";\n      ", ";\n\n  }\n   .slideSubTitle{\n      font-size: 2.1rem;\n      line-height: 1.4;\n      letter-spacing: 0.05em;\n      color:#fff;\n      white-space: pre-line;\n\n      ", ";\n      ", ";\n   }\n   // ", "\n"]),
	    _templateObject17 = _taggedTemplateLiteralLoose(["\n         bottom: 20%;\n         left: 20px;\n         right:20px;\n      "], ["\n         bottom: 20%;\n         left: 20px;\n         right:20px;\n      "]),
	    _templateObject18 = _taggedTemplateLiteralLoose(["\n      font-size: 4rem;\n      "], ["\n      font-size: 4rem;\n      "]),
	    _templateObject19 = _taggedTemplateLiteralLoose(["\n      font-size: 2.6rem;\n      "], ["\n      font-size: 2.6rem;\n      "]),
	    _templateObject20 = _taggedTemplateLiteralLoose(["\n      font-size: 1.9rem;\n      "], ["\n      font-size: 1.9rem;\n      "]),
	    _templateObject21 = _taggedTemplateLiteralLoose(["\n      font-size: 1.6rem;\n      white-space: normal;\n      "], ["\n      font-size: 1.6rem;\n      white-space: normal;\n      "]),
	    _templateObject22 = _taggedTemplateLiteralLoose(["\n   //    margin-bottom: ", "vmin;\n   // "], ["\n   //    margin-bottom: ", "vmin;\n   // "]),
	    _templateObject23 = _taggedTemplateLiteralLoose(["\n   padding-bottom: ", "rem;\n   padding-right: ", "rem;\n   border-right: ", "px solid ", ";\n\timg{\n\t\twidth: 200px;\n\t}\n   ", ";\n\n"], ["\n   padding-bottom: ", "rem;\n   padding-right: ", "rem;\n   border-right: ", "px solid ", ";\n\timg{\n\t\twidth: 200px;\n\t}\n   ", ";\n\n"]),
	    _templateObject24 = _taggedTemplateLiteralLoose(["\n      padding-bottom: 0;\n      border-right: none;\n   "], ["\n      padding-bottom: 0;\n      border-right: none;\n   "]),
	    _templateObject25 = _taggedTemplateLiteralLoose(["\n   padding-left: ", "rem;\n\n   ", ";\n\n   h4 {\n      padding-bottom: 3rem;\n   }\n   h5 {\n      font-size: ", "rem;\n      padding-bottom: ", "rem;\n\n   }\n"], ["\n   padding-left: ", "rem;\n\n   ", ";\n\n   h4 {\n      padding-bottom: 3rem;\n   }\n   h5 {\n      font-size: ", "rem;\n      padding-bottom: ", "rem;\n\n   }\n"]),
	    _templateObject26 = _taggedTemplateLiteralLoose(["\n      border-left: none;\n      padding-left: 0;\n   "], ["\n      border-left: none;\n      padding-left: 0;\n   "]),
	    _templateObject27 = _taggedTemplateLiteralLoose(["\n   white-space: nowrap;\n   background: white;\n   padding: 1.2rem 1.75rem;\n   border-radius: 4px;\n   text-decoration: none;\n   border-radius: 4px;\n   border: ", ";\n\n   &.btn-square {\n      display: inline-block;\n      width: auto;\n      font-size: 2.2rem;\n\n      &:hover {\n         margin: 0;\n         &:after {\n            margin-left: 1rem;\n         }\n      }\n\n      &:after {\n         content: '\u2192';\n         margin-left: .6rem;\n         transition: margin-left .3s;\n      }\n\n      ", ";\n   }\n"], ["\n   white-space: nowrap;\n   background: white;\n   padding: 1.2rem 1.75rem;\n   border-radius: 4px;\n   text-decoration: none;\n   border-radius: 4px;\n   border: ", ";\n\n   &.btn-square {\n      display: inline-block;\n      width: auto;\n      font-size: 2.2rem;\n\n      &:hover {\n         margin: 0;\n         &:after {\n            margin-left: 1rem;\n         }\n      }\n\n      &:after {\n         content: '\u2192';\n         margin-left: .6rem;\n         transition: margin-left .3s;\n      }\n\n      ", ";\n   }\n"]),
	    _templateObject28 = _taggedTemplateLiteralLoose(["\n         font-size: 1.4rem;\n      "], ["\n         font-size: 1.4rem;\n      "]),
	    _templateObject29 = _taggedTemplateLiteralLoose(["\n   display: ", ";\n   position: absolute;\n   top: 60vmin;\n   width: 3rem;\n   height: 3rem;\n\n   &:after {\n      position: absolute;\n      display: inline-block;\n      content: \"\";\n      width: 4rem;\n      height: 4rem;\n      background: url(", ");\n      transform: rotate(90deg);\n      vertical-align: middle;\n      cursor: pointer;\n   }\n\n   ", ";\n\n"], ["\n   display: ", ";\n   position: absolute;\n   top: 60vmin;\n   width: 3rem;\n   height: 3rem;\n\n   &:after {\n      position: absolute;\n      display: inline-block;\n      content: \"\";\n      width: 4rem;\n      height: 4rem;\n      background: url(", ");\n      transform: rotate(90deg);\n      vertical-align: middle;\n      cursor: pointer;\n   }\n\n   ", ";\n\n"]),
	    _templateObject30 = _taggedTemplateLiteralLoose(["\n      visibility: hidden;\n   "], ["\n      visibility: hidden;\n   "]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactSlick = __webpack_require__(44);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _slick = __webpack_require__(101);
	
	var _slick2 = _interopRequireDefault(_slick);
	
	var _slickTheme = __webpack_require__(100);
	
	var _slickTheme2 = _interopRequireDefault(_slickTheme);
	
	var _rightCircle = __webpack_require__(51);
	
	var _rightCircle2 = _interopRequireDefault(_rightCircle);
	
	var _rightCircleWhite = __webpack_require__(20);
	
	var _rightCircleWhite2 = _interopRequireDefault(_rightCircleWhite);
	
	var _vars = __webpack_require__(7);
	
	var vars = _interopRequireWildcard(_vars);
	
	var _functions = __webpack_require__(6);
	
	var _prismicReactjs = __webpack_require__(19);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Photo = function Photo(_ref) {
	   var slides = _ref.slides,
	       _ref$pauseOnHover = _ref.pauseOnHover,
	       pauseOnHover = _ref$pauseOnHover === undefined ? false : _ref$pauseOnHover,
	       autoplay = _ref.autoplay,
	       fixText = _ref.fixText,
	       hero = _ref.hero,
	       _ref$dots = _ref.dots,
	       dots = _ref$dots === undefined ? true : _ref$dots,
	       theme = _ref.theme,
	       _ref$mini = _ref.mini,
	       mini = _ref$mini === undefined ? false : _ref$mini;
	
	   var _useState = (0, _react.useState)(autoplay),
	       autoplaying = _useState[0],
	       setAutoplaying = _useState[1];
	
	   var pause = function pause() {
	      setAutoplaying(false);
	   };
	
	   var settings = {
	      fade: true,
	      infinite: true,
	      speed: 2000,
	      slidesToShow: 1,
	      slidesToScroll: 1,
	      // autoplay: autoplay,
	      autoplaySpeed: 4000,
	      pauseOnHover: pauseOnHover,
	      dots: dots,
	      waitForAnimate: false
	   };
	
	   var onClickScroll = function onClickScroll() {
	      if (typeof window !== "undefined") {
	         var scrollDistance = window.pageYOffset;
	         window.scrollTo({
	            top: scrollDistance + window.innerHeight,
	            behavior: "smooth"
	         });
	      }
	   };
	
	   return _react2.default.createElement(
	      Container,
	      { isHero: hero, mini: mini, onClick: pause },
	      _react2.default.createElement(
	         _reactSlick2.default,
	         _extends({ autoplay: autoplaying }, settings, { className: "slider" }),
	         slides.map(function (slide, index) {
	            return _react2.default.createElement(
	               Slide,
	               { key: index, className: "theSlide" },
	               _react2.default.createElement(
	                  "div",
	                  { className: "slideCaption" },
	                  slide['header'] ? _react2.default.createElement(
	                     "div",
	                     { className: "slideTitle" },
	                     slide['header'][0].text
	                  ) : '',
	                  slide['subheader'] ? _react2.default.createElement(
	                     "div",
	                     { className: "slideSubTitle" },
	                     slide['subheader'][0].text
	                  ) : ''
	               ),
	               _react2.default.createElement(
	                  "picture",
	                  { className: "anchor-" + slide.image_anchor },
	                  _react2.default.createElement("source", { srcSet: slide['img'][0]['mobile'][0]['url'],
	                     media: "(max-width: 840px)" }),
	                  _react2.default.createElement("img", { src: slide['img'][0]['url'], alt: slide['img'][0]['alt'], draggable: false })
	               )
	            );
	         })
	      )
	   );
	};
	
	(0, _styledComponents.injectGlobal)(_templateObject, _slick2.default, _slickTheme2.default);
	
	var Container = _styledComponents2.default.div(_templateObject2, function (props) {
	   return props.isHero ? '100%' : '94%';
	}, vars.padding.inner * 2, _functions.below.tablet(_templateObject3), function (props) {
	   return !props.isHero && _functions.below.tablet(_templateObject4);
	}, function (props) {
	   return props.mini && _functions.below.mobile(_templateObject5);
	}, _rightCircleWhite2.default, _functions.below.tablet(_templateObject6), _functions.below.tablet(_templateObject7), _functions.below.tablet(_templateObject8), _functions.below.tablet(_templateObject9), vars.fonts.main, _functions.below.tablet(_templateObject10), _functions.below.mobile(_templateObject11), vars.padding.mobInner, _functions.below.tablet(_templateObject12, vars.padding.mobInner, vars.colors.body), vars.colors.body, vars.padding.inner, _functions.below.tablet(_templateObject13, vars.padding.mobInner), vars.colors.body, vars.padding.inner, vars.padding.inner, _functions.below.tablet(_templateObject14), _functions.below.tablet(_templateObject15, vars.padding.inner * 3));
	
	var Slide = _styledComponents2.default.div(_templateObject16, vars.padding.inner, _functions.below.tablet(_templateObject17), _functions.below.tablet(_templateObject18), _functions.below.mobile(_templateObject19), _functions.below.tablet(_templateObject20), _functions.below.mobile(_templateObject21), _functions.below.tablet(_templateObject22, vars.padding.inner * 3));
	
	var MainCopy = _styledComponents2.default.div(_templateObject23, vars.padding.inner, vars.padding.inner, function (props) {
	   return props.isHero ? '1' : '1';
	}, vars.colors.body, _functions.below.tablet(_templateObject24));
	
	var Text = _styledComponents2.default.div(_templateObject25, vars.padding.inner, _functions.below.tablet(_templateObject26), vars.padding.inner / 2, vars.padding.inner / 5);
	
	var BookNow = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject27, function (props) {
	   return props.theme !== 'white' ? 'inherit' : "1px solid #e0e0e0";
	}, _functions.below.tablet(_templateObject28));
	
	var DownArrow = _styledComponents2.default.div(_templateObject29, function (props) {
	   return props.isHero ? 'block' : 'none';
	}, _rightCircleWhite2.default, _functions.below.tablet(_templateObject30));
	
	exports.default = Photo;
	module.exports = exports["default"];

/***/ }),

/***/ 198:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMzZjNlM2U7fS5jbHMtMntmaWxsOm5vbmU7c3Ryb2tlOiNmZmY7c3Ryb2tlLW1pdGVybGltaXQ6MTA7c3Ryb2tlLXdpZHRoOjJweDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkdMRTEyNDg3X1dlYnNpdGVfSWNvbnM8L3RpdGxlPjxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iMjYiIGN5PSIyNSIgcj0iMTgiLz48cG9seWxpbmUgY2xhc3M9ImNscy0yIiBwb2ludHM9IjMzLjk4OCAxNy4wMTIgMjYgMjUgMTguMDEyIDE3LjAxMiIvPjxwb2x5bGluZSBjbGFzcz0iY2xzLTIiIHBvaW50cz0iMTguMDEyIDMyLjk4OCAyNiAyNSAzMy45ODggMzIuOTg4Ii8+PC9zdmc+"

/***/ }),

/***/ 199:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7c3Ryb2tlOiMzMTMxMzA7c3Ryb2tlLW1pdGVybGltaXQ6MTA7c3Ryb2tlLXdpZHRoOjJweDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkdMRTEyNDg3X1dlYnNpdGVfSWNvbnM8L3RpdGxlPjxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iMjUiIGN5PSIyNSIgcj0iMTgiLz48cG9seWxpbmUgY2xhc3M9ImNscy0xIiBwb2ludHM9IjMyLjk4OCAyMS4wMDYgMjUgMjguOTk0IDE3LjAxMiAyMS4wMDYiLz48L3N2Zz4="

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n\nposition: relative;\n\n   .slick-track {\n      background-color: #3f3e3e;\n   }\n\n   .slick-list, .slick-track {\n      transform: none !important;\n   }\n\n   .arrow {\n      position: absolute;\n      display: block;\n      height: 50px;\n      width: 50px;\n      z-index: 1;\n      top: 60%;\n      transform: translateY(-50%);\n      margin: 0 2vw;\n      cursor: pointer;\n      ", "\n   }\n\n   .next-arrow {\n      right: 0;\n      background-image: url(", ");\n   }\n   .prev-arrow {\n      transform: rotate(180deg);\n      transform-origin: 50% 24%;\n      background-image: url(", ");\n   }\n\n   .slick-dots {\n      margin-left: 17rem;\n      bottom: 9%;\n      width: auto;\n      list-style: none;\n      text-align: center;\n      li button {\n         background: transparent;\n         border: 1px solid white;\n         border-radius: 50%;\n\t\t\t\t width:20px;\n\t\t\t\t height:20px;\n\t\t\t\t &:before, &:after{\n\t\t\t\t\twidth:20px;\n\t\t\t\t height:20px;\n\t\t\t\t }\n         :hover:before {\n            background: white;\n            opacity: 1;\n         }\n         :before {\n            content: '';\n            background-color: white;\n            border-radius: 50%;\n            opacity: 0;\n            transition: opacity .5s;\n         }\n      }\n\n      ", "\n   }\n"], ["\n\nposition: relative;\n\n   .slick-track {\n      background-color: #3f3e3e;\n   }\n\n   .slick-list, .slick-track {\n      transform: none !important;\n   }\n\n   .arrow {\n      position: absolute;\n      display: block;\n      height: 50px;\n      width: 50px;\n      z-index: 1;\n      top: 60%;\n      transform: translateY(-50%);\n      margin: 0 2vw;\n      cursor: pointer;\n      ", "\n   }\n\n   .next-arrow {\n      right: 0;\n      background-image: url(", ");\n   }\n   .prev-arrow {\n      transform: rotate(180deg);\n      transform-origin: 50% 24%;\n      background-image: url(", ");\n   }\n\n   .slick-dots {\n      margin-left: 17rem;\n      bottom: 9%;\n      width: auto;\n      list-style: none;\n      text-align: center;\n      li button {\n         background: transparent;\n         border: 1px solid white;\n         border-radius: 50%;\n\t\t\t\t width:20px;\n\t\t\t\t height:20px;\n\t\t\t\t &:before, &:after{\n\t\t\t\t\twidth:20px;\n\t\t\t\t height:20px;\n\t\t\t\t }\n         :hover:before {\n            background: white;\n            opacity: 1;\n         }\n         :before {\n            content: '';\n            background-color: white;\n            border-radius: 50%;\n            opacity: 0;\n            transition: opacity .5s;\n         }\n      }\n\n      ", "\n   }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n         display: none;\n      "], ["\n         display: none;\n      "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n         margin: 0;\n         left: 50%;\n         bottom: 3%;\n         transform: translateX(-50%);\n      "], ["\n         margin: 0;\n         left: 50%;\n         bottom: 3%;\n         transform: translateX(-50%);\n      "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n   height: 100vh;\n\t ", "\n   img {\n      width: 100%;\n      height: 100vh;\n      object-fit: cover;\n\t\t\t", "\n\n   }\n\t .img{\n\t\t position: relative;\n\t\t &:before{\n\t\t\t content: '';\n\t\t\t position: absolute;\n\t\t\t top: 0;\n\t\t\t right: 0;\n\t\t\t bottom: 0;\n\t\t\t left: 0;\n\t\t\t background: linear-gradient(to bottom, rgba(63, 62, 62, 0.4) 0%, rgba(63, 62, 62, 0.2) 20%,rgba(0,0,0,0) 100%);\n\t\t }\n\t }\n"], ["\n   height: 100vh;\n\t ", "\n   img {\n      width: 100%;\n      height: 100vh;\n      object-fit: cover;\n\t\t\t", "\n\n   }\n\t .img{\n\t\t position: relative;\n\t\t &:before{\n\t\t\t content: '';\n\t\t\t position: absolute;\n\t\t\t top: 0;\n\t\t\t right: 0;\n\t\t\t bottom: 0;\n\t\t\t left: 0;\n\t\t\t background: linear-gradient(to bottom, rgba(63, 62, 62, 0.4) 0%, rgba(63, 62, 62, 0.2) 20%,rgba(0,0,0,0) 100%);\n\t\t }\n\t }\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n\t\t\theight: 50vh;\n\t\t\t"], ["\n\t\t\theight: 50vh;\n\t\t\t"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\tbottom: 10%;\n\tleft: 0;\n\tright: 0;\n\tz-index: 10;\n\t", "\n"], ["\n\tposition: absolute;\n\tbottom: 10%;\n\tleft: 0;\n\tright: 0;\n\tz-index: 10;\n\t", "\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n\t\timg{\n\t\t\tmax-width: 200px;\n\t\t}\n\t"], ["\n\t\timg{\n\t\t\tmax-width: 200px;\n\t\t}\n\t"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n   border-top: 1px solid;\n\t border-bottom: none;\n\n   background-image: linear-gradient(", " 60%, white 30%);\n   ", "\n\n   .grid {\n      margin: 7rem auto;\n\t\t\t", "\n   }\n"], ["\n   border-top: 1px solid;\n\t border-bottom: none;\n\n   background-image: linear-gradient(", " 60%, white 30%);\n   ", "\n\n   .grid {\n      margin: 7rem auto;\n\t\t\t", "\n   }\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n   .inner_wrapper{\ndisplay:flex\n   }\n   "], ["\n   .inner_wrapper{\ndisplay:flex\n   }\n   "]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n\t\t\t\tmargin-top: 2rem;\n\t\t\t"], ["\n\t\t\t\tmargin-top: 2rem;\n\t\t\t"]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n   padding-bottom: ", "rem;\n   padding-right: ", "rem;\n   border-left: ", "px solid #fff;\n\t padding-left: 3.5rem;\n   border-right: ", "px solid #fff;\n\t color: #fff;\n\n\t ", "\n\t div{\n\t\t border-color: #fff;\n\t }\n\timg{\n\t\twidth: 200px;\n\t}\n\t&.black {\n\t\tborder-color: #3f3e3e;\n\t\tcolor: #3f3e3e;\n\t\tdiv{\n\t\t\tborder-color: #3f3e3e;\n\t\t}\n      &.no-rhs-border{\n         border-right:none!important;\n         padding-bottom:0!important;\n         p{\n            padding-bottom: 0!important;\n         }\n      }\n\t}\n   ", ";\n\n"], ["\n   padding-bottom: ", "rem;\n   padding-right: ", "rem;\n   border-left: ", "px solid #fff;\n\t padding-left: 3.5rem;\n   border-right: ", "px solid #fff;\n\t color: #fff;\n\n\t ", "\n\t div{\n\t\t border-color: #fff;\n\t }\n\timg{\n\t\twidth: 200px;\n\t}\n\t&.black {\n\t\tborder-color: #3f3e3e;\n\t\tcolor: #3f3e3e;\n\t\tdiv{\n\t\t\tborder-color: #3f3e3e;\n\t\t}\n      &.no-rhs-border{\n         border-right:none!important;\n         padding-bottom:0!important;\n         p{\n            padding-bottom: 0!important;\n         }\n      }\n\t}\n   ", ";\n\n"]),
	    _templateObject12 = _taggedTemplateLiteralLoose(["\n\t\tborder: none;\n\t\tpadding-left: 0;\n\t\tpadding-bottom: 25px;\n\t "], ["\n\t\tborder: none;\n\t\tpadding-left: 0;\n\t\tpadding-bottom: 25px;\n\t "]),
	    _templateObject13 = _taggedTemplateLiteralLoose(["\n      padding-bottom: 0;\n      border-right: none;\n   "], ["\n      padding-bottom: 0;\n      border-right: none;\n   "]),
	    _templateObject14 = _taggedTemplateLiteralLoose(["\n   padding-left: ", "rem;\n color: #fff;\n\n &.primary_wrapper{\n    padding-top:22px;\n }\n\n\n   ", ";\n\n   h4 {\n      padding-bottom: 3rem;\n      padding-bottom:0;\n   }\n   h5 {\n      font-size: ", "rem;\n      padding-bottom: ", "rem;\n\n   }\n   small {\n      display: block;\n      padding-top: 0.5rem;\n  }\n\n  .button_wrapper{\n   padding-top: 22px;\n\n   display: flex;\n   flex-direction: column;\n   align-items: flex-start;\n\n   .btn{\n      margin-bottom: 12px;\n      &:last-child{\n         margin-bottom:0;\n      }\n   }\n  }\n\n   .section__wrap{\n      padding-bottom: .58rem;\n   }\n\t &.black {\n\t\tborder-color: #3f3e3e;\n\t\tcolor: #3f3e3e;\n\t\t/* div{\n\t\t\tborder-color: #3f3e3e;\n\t\t} */\n\t}\n"], ["\n   padding-left: ", "rem;\n color: #fff;\n\n &.primary_wrapper{\n    padding-top:22px;\n }\n\n\n   ", ";\n\n   h4 {\n      padding-bottom: 3rem;\n      padding-bottom:0;\n   }\n   h5 {\n      font-size: ", "rem;\n      padding-bottom: ", "rem;\n\n   }\n   small {\n      display: block;\n      padding-top: 0.5rem;\n  }\n\n  .button_wrapper{\n   padding-top: 22px;\n\n   display: flex;\n   flex-direction: column;\n   align-items: flex-start;\n\n   .btn{\n      margin-bottom: 12px;\n      &:last-child{\n         margin-bottom:0;\n      }\n   }\n  }\n\n   .section__wrap{\n      padding-bottom: .58rem;\n   }\n\t &.black {\n\t\tborder-color: #3f3e3e;\n\t\tcolor: #3f3e3e;\n\t\t/* div{\n\t\t\tborder-color: #3f3e3e;\n\t\t} */\n\t}\n"]),
	    _templateObject15 = _taggedTemplateLiteralLoose(["\n      border-left: none;\n      padding-left: 0;\n   "], ["\n      border-left: none;\n      padding-left: 0;\n   "]),
	    _templateObject16 = _taggedTemplateLiteralLoose(["\n   padding: 0;\n   position: relative;\n   margin-bottom: ", "rem;\n\n   h1 {\n      letter-spacing: .03rem;\n      font-family: ", ";\n      font-weight: normal;\n      font-size:5.7rem;\n      padding-bottom: ", "rem;\n      line-height:1;\n      padding-right: 40px;\n      ", "\n      ", "\n   }\n\n   .form__thankyou  a:not(.link-email):after {\n      content: url(/svg/arrow-dark.svg);\n   }\n   h2 {\n\t\tfont-family: ", ";\n\t\tfont-size:2.3rem;\n\t\tfont-weight: normal;\n\t\t", "\n\t\t", "\n      padding-bottom: ", "rem;\n   }\n\n   .grid .col {\n      min-height: 20rem;\n      ", "\n   }\n\n   .grid .col:first-of-type {\n      border-left: 1px solid ", ";\n      padding-left: ", "rem;\n      ", "\n   }\n\n   .border-left {\n      border-left: 1px solid ", ";\n      padding-left: ", "rem;\n   }\n\n   .mob-border-left {\n      border-left-width: 0;\n      padding-left: ", "rem;\n\n      ", "\n   }\n\n   &.invert-color {\n      background: ", ";\n      color: ", ";\n      margin-top: 6rem;\n\n      .grid .inner div {\n         border-color: ", ";\n      }\n   }\n"], ["\n   padding: 0;\n   position: relative;\n   margin-bottom: ", "rem;\n\n   h1 {\n      letter-spacing: .03rem;\n      font-family: ", ";\n      font-weight: normal;\n      font-size:5.7rem;\n      padding-bottom: ", "rem;\n      line-height:1;\n      padding-right: 40px;\n      ", "\n      ", "\n   }\n\n   .form__thankyou  a:not(.link-email):after {\n      content: url(/svg/arrow-dark.svg);\n   }\n   h2 {\n\t\tfont-family: ", ";\n\t\tfont-size:2.3rem;\n\t\tfont-weight: normal;\n\t\t", "\n\t\t", "\n      padding-bottom: ", "rem;\n   }\n\n   .grid .col {\n      min-height: 20rem;\n      ", "\n   }\n\n   .grid .col:first-of-type {\n      border-left: 1px solid ", ";\n      padding-left: ", "rem;\n      ", "\n   }\n\n   .border-left {\n      border-left: 1px solid ", ";\n      padding-left: ", "rem;\n   }\n\n   .mob-border-left {\n      border-left-width: 0;\n      padding-left: ", "rem;\n\n      ", "\n   }\n\n   &.invert-color {\n      background: ", ";\n      color: ", ";\n      margin-top: 6rem;\n\n      .grid .inner div {\n         border-color: ", ";\n      }\n   }\n"]),
	    _templateObject17 = _taggedTemplateLiteralLoose(["\n         padding-right: 0;\n         font-size:4rem;\n      "], ["\n         padding-right: 0;\n         font-size:4rem;\n      "]),
	    _templateObject18 = _taggedTemplateLiteralLoose(["\n         font-size:2.6rem;\n      "], ["\n         font-size:2.6rem;\n      "]),
	    _templateObject19 = _taggedTemplateLiteralLoose(["\n\t\t\tfont-size:2.3rem;\n\t\t"], ["\n\t\t\tfont-size:2.3rem;\n\t\t"]),
	    _templateObject20 = _taggedTemplateLiteralLoose(["\n\t\t\tfont-size:2rem;\n\t\t"], ["\n\t\t\tfont-size:2rem;\n\t\t"]),
	    _templateObject21 = _taggedTemplateLiteralLoose(["\n         min-height: 0;\n         padding-left: none;\n         border-left: none;\n      "], ["\n         min-height: 0;\n         padding-left: none;\n         border-left: none;\n      "]),
	    _templateObject22 = _taggedTemplateLiteralLoose(["\n         padding-left:0;\n\t\t\t\t border-left: none;\n\t\t\t\t padding-bottom: 25px;\n      "], ["\n         padding-left:0;\n\t\t\t\t border-left: none;\n\t\t\t\t padding-bottom: 25px;\n      "]),
	    _templateObject23 = _taggedTemplateLiteralLoose(["\n         border-left-width: 0.2rem;\n      "], ["\n         border-left-width: 0.2rem;\n      "]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactSlick = __webpack_require__(44);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _parra = __webpack_require__(325);
	
	var _parra2 = _interopRequireDefault(_parra);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _functions = __webpack_require__(6);
	
	var _vars = __webpack_require__(7);
	
	var vars = _interopRequireWildcard(_vars);
	
	var _accordion = __webpack_require__(138);
	
	var _downForm = __webpack_require__(314);
	
	var _downForm2 = _interopRequireDefault(_downForm);
	
	var _downFormFloorplan = __webpack_require__(315);
	
	var _downFormFloorplan2 = _interopRequireDefault(_downFormFloorplan);
	
	var _video = __webpack_require__(46);
	
	var _video2 = _interopRequireDefault(_video);
	
	var _headerMobileNav = __webpack_require__(321);
	
	var _headerMobileNav2 = _interopRequireDefault(_headerMobileNav);
	
	var _content_block = __webpack_require__(89);
	
	var _content_block2 = _interopRequireDefault(_content_block);
	
	var _news_card = __webpack_require__(61);
	
	var _news_card2 = _interopRequireDefault(_news_card);
	
	var _photo_product = __webpack_require__(326);
	
	var _photo_product2 = _interopRequireDefault(_photo_product);
	
	var _prismicReactjs = __webpack_require__(19);
	
	var _arrowRightWhite = __webpack_require__(200);
	
	var _arrowRightWhite2 = _interopRequireDefault(_arrowRightWhite);
	
	var _stickyEnquire = __webpack_require__(52);
	
	var _stickyEnquire2 = _interopRequireDefault(_stickyEnquire);
	
	var _arrows = __webpack_require__(139);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import 'slick-carousel/slick/slick.css' import
	// 'slick-carousel/slick/slick-theme.css'
	
	var settings = {
	   dots: true,
	   autoplay: true,
	   fade: true,
	   infinite: true,
	   autoplaySpeed: 4750,
	   pauseOnHover: false,
	   slidesToShow: 1,
	   slidesToScroll: 1,
	   waitForAnimate: false,
	   nextArrow: _react2.default.createElement(_arrows.NextArrow, null),
	   prevArrow: _react2.default.createElement(_arrows.PrevArrow, null)
	};
	
	var productPage = function (_React$Component) {
	   _inherits(productPage, _React$Component);
	
	   function productPage() {
	      _classCallCheck(this, productPage);
	
	      return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	   }
	
	   // state = {
	   //    location: null
	   // }
	
	   productPage.prototype.scrollFloorplan = function scrollFloorplan(e) {
	      if (typeof window !== "undefined") {
	         window.scrollTo({
	            top: 0,
	            behavior: "smooth"
	         });
	      }
	   };
	
	   productPage.prototype.componentDidMount = function componentDidMount() {
	      // const location = this.props.location.pathname
	      var data = this.props.data.prismicProduct.data;
	      this.props.updateMeta(data.meta_title.text, data.meta_description);
	
	      this.props.updateSlug(this.props.data.prismicProduct.uid);
	      this.props.updatePageType(this.props.data.prismicProduct.type);
	      this.props.togglePopup(false);
	      this.props.updateFooterVisible(true);
	      if (data.hide_footer === true) {
	         this.props.updateProductHide(true);
	      } else {
	         this.props.updateProductHide(false);
	      }
	   };
	
	   productPage.prototype.render = function render() {
	      var _this2 = this;
	
	      var data = this.props.data.prismicProduct.dataString;
	      data = JSON.parse(this.props.data.prismicProduct.dataString);
	      var dataset = this.props.data.prismicProduct.data;
	
	      var element = this.props.data.prismicProduct;
	
	      var allSlides = [];
	
	      // console.log(data);
	
	      // var offering_small_text = null;
	      // try {
	      //    offering_small_text = data.offering_small_text[0].text;
	      // } catch (error) {
	      //    offering_small_text = null;
	      // };
	
	
	      // var availability_small_text = null;
	      // try {
	      //    availability_small_text = data.availability_small_text[0].text;
	      // } catch (error) {
	      //    availability_small_text = null;
	      // };
	
	
	      data.slider.map(function (slide) {
	         var img = [];
	         var img_mobile = [];
	         var img_dimensions = { "width": 2000, "height": 1250 };
	         var img_alt = null;
	         var img_copyright = null;
	         var img_url = slide.slide.url;
	
	         var mobile_dimensions = { "width": 750, "height": 582 };
	
	         var logo = {};
	         var image_anchor = "Center";
	         var header = null;
	         var subheader = null;
	         var text = null;
	         var link = null;
	
	         img_mobile.push({ mobile_dimensions: mobile_dimensions, alt: img_alt, copyright: img_copyright, url: img_url });
	         img.push({ dimensions: img_dimensions, alt: img_alt, copyright: img_copyright, url: img_url, mobile: img_mobile });
	
	         allSlides.push({ img: img, logo: logo, image_anchor: image_anchor, header: header, subheader: subheader, text: text, link: link });
	         // allSlides.push({
	         //    "img": {
	         //       "dimensions": {
	         //          "width": 2000,
	         //          "height": 1250
	         //       },
	         //       "alt": null,
	         //       "copyright": null,
	         //       "url": "/images/feb-19-updates/artisan/mid-slide-03.jpg",
	         //    },
	         //    "logo": {},
	         //    "image_anchor": "Center",
	         //    "header": null,
	         //    "subheader": null,
	         //    "text": null,
	         //    "link": null
	         // });
	         //console.log(allSlides);
	      });
	      var download_title = dataset.project_section_title.text.replace(/.\s*$/, "") + " Download";
	      var download_brochure = element.uid + "-brochure";
	      var property = this.props.data.prismicProduct.uid;
	      //console.log('property',property);
	
	      var i = 0;
	      // const location = this.state.location || ''
	      // const download_floorplan_title = dataset.project_section_title.text.replace(/.\s*$/, "") + " Download";
	      // const download_floorplan = element.uid + "-floorplan";
	
	
	      //console.log(dataset);
	      //console.log(data);
	
	      var current_utm = this.props.utm;
	      //console.log(this.props);
	      return _react2.default.createElement(
	         "div",
	         null,
	         _react2.default.createElement(_headerMobileNav2.default, { togglePopup: this.props.togglePopup, theme: "trans", menu: this.props.data.prismicMainNavigation.data }),
	         _react2.default.createElement(_stickyEnquire2.default, { property: this.props.data.prismicProduct.uid, togglePopupState: this.props.popupVisible, togglePopup: this.props.togglePopup, utm: this.props.utm, updateFormDetails: function updateFormDetails(first_name, last_name, phone, email, property) {
	               return _this2.props.updateFormDetails(first_name, last_name, phone, email, property);
	            } }),
	         _react2.default.createElement(
	            SlideshowWrapper,
	            null,
	            _react2.default.createElement(
	               Overlay,
	               { className: "grid" },
	               _react2.default.createElement(
	                  "div",
	                  { className: "inner" },
	                  _react2.default.createElement("img", { src: data.project_logo.url })
	               )
	            ),
	            _react2.default.createElement(
	               _reactSlick2.default,
	               settings,
	               _react2.default.createElement(
	                  SlideImgWrapper,
	                  null,
	                  _react2.default.createElement(
	                     "div",
	                     { className: "img" },
	                     data.youtube__optional_.url ? _react2.default.createElement(_video2.default, { url: data.youtube__optional_.url, poster: data.project_feature_image.url, popup: true }) : _react2.default.createElement("img", { src: data.project_feature_image.url })
	                  )
	               )
	            )
	         ),
	         _react2.default.createElement(
	            ProjectContent,
	            null,
	            _react2.default.createElement(
	               "div",
	               { className: "grid " },
	               _react2.default.createElement(
	                  "div",
	                  { className: "inner inner_wrapper" },
	                  _react2.default.createElement(
	                     MainCopy,
	                     { className: "col col-xs-12 col-06 " },
	                     _react2.default.createElement(
	                        "h2",
	                        null,
	                        dataset.project_section_title.text.split('\n').map(function (item, key) {
	                           return _react2.default.createElement(
	                              "span",
	                              { key: key },
	                              item,
	                              _react2.default.createElement("br", null)
	                           );
	                        })
	                     ),
	                     _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: dataset.project_section_description.html } })
	                  ),
	                  _react2.default.createElement(
	                     MainTextOther,
	                     { isHero: true, className: "col col-xs-12 col-04 primary_wrapper" },
	                     _react2.default.createElement(
	                        "div",
	                        { className: "section__wrap" },
	                        _react2.default.createElement(
	                           "h4",
	                           null,
	                           data.offering_text[0] && data.offering_text[0].text.split('\n').map(function (item, key) {
	                              return _react2.default.createElement(
	                                 "span",
	                                 { key: key },
	                                 item,
	                                 _react2.default.createElement("br", null)
	                              );
	                           })
	                        ),
	                        _react2.default.createElement(
	                           "small",
	                           null,
	                           dataset.offering_small_text.text && dataset.offering_small_text.text !== null && dataset.offering_small_text.text !== '' ? dataset.offering_small_text.text.split('\n').map(function (item, key) {
	                              return _react2.default.createElement(
	                                 "span",
	                                 { key: key },
	                                 item,
	                                 _react2.default.createElement("br", null)
	                              );
	                           }) : ""
	                        )
	                     ),
	                     _react2.default.createElement(
	                        "div",
	                        { className: "section__wrap" },
	                        _react2.default.createElement(
	                           "h4",
	                           null,
	                           data.availability_text[0] && data.availability_text[0].text.split('\n').map(function (item, key) {
	                              return _react2.default.createElement(
	                                 "span",
	                                 { key: key },
	                                 item,
	                                 _react2.default.createElement("br", null)
	                              );
	                           })
	                        ),
	                        _react2.default.createElement(
	                           "small",
	                           null,
	                           dataset.availability_small_text && dataset.availability_small_text.text && dataset.availability_small_text.text !== null && dataset.availability_small_text.text !== '' ? dataset.availability_small_text.text.split('\n').map(function (item, key) {
	                              return _react2.default.createElement(
	                                 "span",
	                                 { key: key },
	                                 item,
	                                 _react2.default.createElement("br", null)
	                              );
	                           }) : ""
	                        )
	                     ),
	                     _react2.default.createElement(
	                        "div",
	                        { className: "button_wrapper" },
	                        data.body.map(function (slice) {
	                           i++;
	                           switch (slice.slice_type) {
	
	                              case 'text_with_floorplan_download':
	                                 return _react2.default.createElement(
	                                    "button",
	                                    { onClick: function onClick() {
	
	                                          function getElementOffset(el) {
	                                             var top = 0;
	                                             var left = 0;
	                                             var element = el;
	
	                                             // Loop through the DOM tree
	                                             // and add it's parent's offset to get page offset
	                                             do {
	                                                top += element.offsetTop || 0;
	                                                left += element.offsetLeft || 0;
	                                                element = element.offsetParent;
	                                             } while (element);
	
	                                             return {
	                                                top: top,
	                                                left: left
	                                             };
	                                          }
	
	                                          var floorPlan = document.getElementById("view-floorplan");
	                                          var floorPlanLocation = getElementOffset(floorPlan);
	                                          var header = document.getElementsByTagName("header")[0];
	                                          var headerHeight = header.offsetHeight;
	                                          var scrollOffset = floorPlanLocation.top - headerHeight - 50;
	
	                                          window.scrollTo({
	                                             top: scrollOffset,
	                                             behavior: "smooth"
	                                          });
	                                       }, className: "btn btn-square white" },
	                                    _react2.default.createElement(
	                                       "span",
	                                       null,
	                                       "View Floorplan"
	                                    )
	                                 );
	                           }
	                        }),
	                        data.button_link.length > 0 && data.button_link[0].text !== '' ? [
	                        //if internal check
	                        /^\/(?!\/)/.test(data.button_link[0].text) === true ? _react2.default.createElement(
	                           _gatsbyLink2.default,
	                           { className: "btn btn-square white", to: { pathname: data.button_link[0].text, state: { property: property } } },
	                           _react2.default.createElement(
	                              "span",
	                              null,
	                              data.button_text[0].text
	                           )
	                        ) : _react2.default.createElement(
	                           "a",
	                           { href: data.button_link[0].text, className: "btn btn-square white", target: "_blank" },
	                           _react2.default.createElement(
	                              "span",
	                              null,
	                              data.button_text[0].text
	                           )
	                        )] : '',
	                        data.button_2_link.length > 0 && data.button_2_link[0].text !== '' ? [
	                        //if internal check
	                        /^\/(?!\/)/.test(data.button_2_link[0].text) === true ? _react2.default.createElement(
	                           _gatsbyLink2.default,
	                           { className: "btn btn-square white", to: { pathname: data.button_2_link[0].text, state: { property: property } } },
	                           _react2.default.createElement(
	                              "span",
	                              null,
	                              data.button_2_text[0].text
	                           )
	                        ) : _react2.default.createElement(
	                           "a",
	                           { href: data.button_2_link[0].text, className: "btn btn-square white", target: "_blank" },
	                           _react2.default.createElement(
	                              "span",
	                              null,
	                              data.button_2_text[0].text
	                           )
	                        )] : '',
	                        data.button_3_link.length > 0 && data.button_3_link[0].text !== '' ? [
	                        //if internal check
	                        /^\/(?!\/)/.test(data.button_3_link[0].text) === true ? _react2.default.createElement(
	                           _gatsbyLink2.default,
	                           { className: "btn btn-square white", to: { pathname: data.button_3_link[0].text, state: { property: property } } },
	                           _react2.default.createElement(
	                              "span",
	                              null,
	                              data.button_3_text[0].text
	                           )
	                        ) : _react2.default.createElement(
	                           "a",
	                           { href: data.button_3_link[0].text, className: "btn btn-square white", target: "_blank" },
	                           _react2.default.createElement(
	                              "span",
	                              null,
	                              data.button_3_text[0].text
	                           )
	                        )] : ''
	                     )
	                  )
	               )
	            ),
	            _react2.default.createElement(_photo_product2.default, {
	               mini: true,
	               slides: allSlides,
	               fixText: false,
	               hero: false,
	               autoplay: true
	            })
	         ),
	         data.body.map(function (slice) {
	            i++;
	            //console.log(slice);
	            switch (slice.slice_type) {
	
	               case 'carousel':
	                  //console.log(slice);
	
	                  var carouselSlides = [];
	                  slice.items.map(function (slide) {
	                     var img = [];
	                     var img_mobile = [];
	                     var img_dimensions = { "width": 2000, "height": 1250 };
	                     var img_alt = null;
	                     var img_copyright = null;
	                     var img_url = slide.image.url;
	
	                     var mobile_dimensions = { "width": 750, "height": 582 };
	
	                     var logo = {};
	                     var image_anchor = "Center";
	                     var header = slide.title;
	                     var subheader = slide.subtitle;
	                     var text = null;
	                     var link = null;
	
	                     img_mobile.push({ mobile_dimensions: mobile_dimensions, alt: img_alt, copyright: img_copyright, url: img_url });
	                     img.push({ dimensions: img_dimensions, alt: img_alt, copyright: img_copyright, url: img_url, mobile: img_mobile });
	
	                     carouselSlides.push({ img: img, logo: logo, image_anchor: image_anchor, header: header, subheader: subheader, text: text, link: link });
	                  });
	
	                  return _react2.default.createElement(_photo_product2.default, {
	                     mini: true,
	                     slides: carouselSlides,
	                     fixText: false,
	                     hero: false,
	                     dots: false,
	                     autoplay: true
	                  });
	
	               case 'single_image_block':
	                  //console.log(slice);
	                  return _react2.default.createElement(
	                     "div",
	                     { className: "grid" },
	                     _react2.default.createElement(
	                        "div",
	                        { className: "inner" },
	                        _react2.default.createElement("img", {
	                           style: {
	                              marginBottom: '3rem',
	                              width: '100%'
	                           },
	                           src: slice.primary.image.url })
	                     )
	                  );
	
	               case 'accordian':
	
	                  return _react2.default.createElement(
	                     "div",
	                     null,
	                     _react2.default.createElement(
	                        "div",
	                        { className: "grid" },
	                        _react2.default.createElement(
	                           "div",
	                           { className: "inner", style: {
	                                 marginBottom: '-7rem',
	                                 marginTop: '6rem'
	                              } },
	                           _react2.default.createElement(
	                              "div",
	                              null,
	                              _react2.default.createElement(
	                                 "h3",
	                                 null,
	                                 slice.primary.title[0].text && slice.primary.title[0].text !== null && slice.primary.title[0].text !== '' ? slice.primary.title[0].text.split('\n').map(function (item, key) {
	                                    return _react2.default.createElement(
	                                       "span",
	                                       { key: key },
	                                       item,
	                                       _react2.default.createElement("br", null)
	                                    );
	                                 }) : ""
	                              )
	                           )
	                        )
	                     ),
	                     _react2.default.createElement(
	                        _accordion.AccordionContainer,
	                        null,
	                        _react2.default.createElement(
	                           "div",
	                           { className: "grid" },
	                           _react2.default.createElement(
	                              "div",
	                              { className: "inner" },
	                              slice.items.map(function (i, idx) {
	                                 return _react2.default.createElement(_accordion.Accordion, {
	                                    title: "",
	                                    bath: i.bathroom,
	                                    bed: i.bedroom,
	                                    car: i.carpark,
	                                    study: i.study,
	                                    name: "",
	                                    logo: "",
	                                    image: i.image.url,
	                                    dir: "right",
	                                    cta: { link: '', text: 'Read more' },
	                                    html: _prismicReactjs.RichText.render(i.html)
	                                 });
	                              })
	                           )
	                        )
	                     )
	                  );
	
	               case 'text_with_floorplan_download':
	                  //console.log(slice);
	                  return _react2.default.createElement(
	                     Container,
	                     null,
	                     _react2.default.createElement(
	                        "div",
	                        { className: "grid " },
	                        _react2.default.createElement(
	                           "div",
	                           { className: "inner" },
	                           _react2.default.createElement(
	                              MainCopy,
	                              { className: "col col-xs-12 col-06 black " },
	                              _react2.default.createElement(
	                                 "h1",
	                                 null,
	                                 slice.primary.title[0].text
	                              ),
	                              _react2.default.createElement(
	                                 "p",
	                                 { className: "ct__arrow" },
	                                 slice.primary.subtitle[0].text.split('\n').map(function (item, key) {
	                                    return _react2.default.createElement(
	                                       "span",
	                                       { key: key },
	                                       item,
	                                       _react2.default.createElement("br", null)
	                                    );
	                                 })
	                              )
	                           ),
	                           _react2.default.createElement(
	                              MainTextOther,
	                              { className: "col col-xs-12 col-06 black", id: "view-floorplan" },
	                              _react2.default.createElement(
	                                 "h1",
	                                 null,
	                                 slice.primary.form_title[0].text
	                              ),
	                              _react2.default.createElement(_downFormFloorplan2.default, { utm: current_utm, product: property, url: slice.primary.floorplan_url[0].text })
	                           )
	                        )
	                     )
	                  );
	               case 'text_-_full_width':
	                  //console.log(slice);
	                  return _react2.default.createElement(
	                     Container,
	                     null,
	                     _react2.default.createElement(
	                        "div",
	                        { className: "grid " },
	                        _react2.default.createElement(
	                           "div",
	                           { className: "inner" },
	                           _react2.default.createElement(
	                              MainCopy,
	                              { className: "col col-xs-12 col-12 black no-rhs-border " },
	                              _react2.default.createElement(
	                                 "h1",
	                                 null,
	                                 slice.primary.title[0].text
	                              ),
	                              _react2.default.createElement("p", { dangerouslySetInnerHTML: { __html: slice.primary.subtitle[0].text.replace(/\n/g, '<br>') } })
	                           )
	                        )
	                     )
	                  );
	               case 'text_with_brochure_download':
	                  //console.log(slice);
	                  return _react2.default.createElement(
	                     Container,
	                     null,
	                     _react2.default.createElement(
	                        "div",
	                        { className: "grid " },
	                        _react2.default.createElement(
	                           "div",
	                           { className: "inner" },
	                           _react2.default.createElement(
	                              MainCopy,
	                              { className: "col col-xs-12 col-06 black " },
	                              _react2.default.createElement(
	                                 "h1",
	                                 null,
	                                 slice.primary.title[0].text
	                              ),
	                              _react2.default.createElement(
	                                 "p",
	                                 null,
	                                 slice.primary.subtitle[0].text.split('\n\n').map(function (item, key) {
	                                    return _react2.default.createElement(
	                                       "span",
	                                       { key: key },
	                                       item,
	                                       _react2.default.createElement("br", null),
	                                       _react2.default.createElement("br", null)
	                                    );
	                                 })
	                              )
	                           ),
	                           _react2.default.createElement(
	                              MainTextOther,
	                              { className: "col col-xs-12 col-06 black" },
	                              _react2.default.createElement(
	                                 "h1",
	                                 null,
	                                 slice.primary.form_title[0].text
	                              ),
	                              _react2.default.createElement(_downForm2.default, { utm: current_utm, product: property, tags: download_title, brochure: download_brochure, brochure_full: slice.primary.form_brochure_pdf.url })
	                           )
	                        )
	                     )
	                  );
	            }
	         })
	      );
	   };
	
	   return productPage;
	}(_react2.default.Component);
	
	exports.default = productPage;
	
	
	var SlideshowWrapper = _styledComponents2.default.div(_templateObject, _functions.below.tablet(_templateObject2), _arrowRightWhite2.default, _arrowRightWhite2.default, _functions.below.tablet(_templateObject3));
	var SlideImgWrapper = _styledComponents2.default.div(_templateObject4, _functions.below.mobile(_templateObject5), _functions.below.mobile(_templateObject5));
	
	var Overlay = _styledComponents2.default.div(_templateObject6, _functions.below.mobile(_templateObject7));
	
	var ProjectContent = _styledComponents2.default.div(_templateObject8, vars.colors.body, _functions.above.desktop(_templateObject9), _functions.below.mobile(_templateObject10));
	
	var MainCopy = _styledComponents2.default.div(_templateObject11, vars.padding.inner, vars.padding.inner, function (props) {
	   return props.isHero ? '1' : '1';
	}, function (props) {
	   return props.isHero ? '1' : '1';
	}, _functions.below.tablet(_templateObject12), _functions.below.tablet(_templateObject13));
	var MainTextOther = _styledComponents2.default.div(_templateObject14, vars.padding.inner, _functions.below.tablet(_templateObject15), vars.padding.inner / 2, vars.padding.inner / 5);
	
	var Container = _styledComponents2.default.div(_templateObject16, vars.padding.inner * 2, vars.fonts.feature, vars.padding.inner / 2, _functions.below.tablet(_templateObject17), _functions.below.mobile(_templateObject18), vars.fonts.main, _functions.below.tablet(_templateObject19), _functions.below.mobile(_templateObject20), vars.padding.mobInner, _functions.below.tablet(_templateObject21), vars.colors.body, vars.padding.inner, _functions.below.tablet(_templateObject22), vars.colors.body, vars.padding.inner, vars.padding.inner, _functions.below.tablet(_templateObject23), vars.colors.body, vars.colors.blank, vars.colors.blank);
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ 200:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgNTAgNTAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZmZmO30uY2xzLTJ7ZmlsbDojMzEzMTMwO308L3N0eWxlPjxzeW1ib2wgaWQ9IldoaXRlX0Fycm93IiBkYXRhLW5hbWU9IldoaXRlIEFycm93IiB2aWV3Qm94PSIwIDAgMjMgMjMiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTkuNDU4MzcsMTcuMTEzNzcsOC40Mzc2MiwxNi4wOTNsNC41OTMyNi00LjU5MzE0TDguNDM3NjIsNi45MDY3NEg4LjQzOEw5LjQ1ODM3LDUuODg2LDE1LjA3MiwxMS40OTk4OCw5LjQ1ODM3LDE3LjExMzc3TTExLjQ5OTg4LDBBMTEuNSwxMS41LDAsMSwwLDIyLjk5OTc2LDExLjQ5OTg4LDExLjQ5OTg2LDExLjQ5OTg2LDAsMCwwLDExLjQ5OTg4LDAiLz48cG9seWxpbmUgY2xhc3M9ImNscy0yIiBwb2ludHM9IjkuNDU4IDUuODg2IDguNDM4IDYuOTA3IDguNDM4IDYuOTA3IDEzLjAzMSAxMS41IDguNDM4IDE2LjA5MyA5LjQ1OCAxNy4xMTQgMTUuMDcyIDExLjUgOS40NTggNS44ODYiLz48L3N5bWJvbD48L2RlZnM+PHRpdGxlPkdMRTEyNDg3X1dlYnNpdGVfSWNvbnM8L3RpdGxlPjx1c2Ugd2lkdGg9IjIyLjk5OTc2IiBoZWlnaHQ9IjIzLjAwMDA2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMy45OTg3NSAxMy4wMDAyMikiIHhsaW5rOmhyZWY9IiNXaGl0ZV9BcnJvdyIvPjwvc3ZnPg=="

/***/ }),

/***/ 201:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGRhdGEtbmFtZT0iTGF5ZXIgMSIgdmlld0JveD0iMC4wIC0wLjUgMTYgMTYiPgogICAgPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjM2YzZTNlIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iLjUiIGQ9Ik04LjE2NC44OTRhMS44ODYgMS44ODYgMCAwIDEgMi42MDQtLjIyIDIuNDUgMi40NSAwIDAgMSAuMTE4IDMuMzFMOC4xNjQuODk1em01Ljg0NiA2LjM2NVYyLjQ0NmEyLjMxMiAyLjMxMiAwIDAgMC0uODM3LTEuNTkgMS44NDYgMS44NDYgMCAwIDAtMi4yNy4xMzNtMi4zMjYgMTIuMTI4bC4yMzcgMS4xNy0uMzAzLjA3Ni0uMjE4LTEuMDc4bS0xMC4xMzktLjA0NGwtLjI1IDEuMjM1LjMwMy4wNzUuMjM3LTEuMTcxbTExLjU1MS01Ljg0NWE1LjM0MyA1LjM0MyAwIDAgMSAuMzE4IDEuODMzIDQuOTc4IDQuOTc4IDAgMCAxLS45MTggMi45NiAyLjc5NiAyLjc5NiAwIDAgMS0yLjIwOSAxLjIzSDMuOTk0Yy0xLjcyIDAtMy4xMjctMS44ODYtMy4xMjctNC4xOWE1LjM0MyA1LjM0MyAwIDAgMSAuMzE4LTEuODMzIi8+CiAgICA8cGF0aCBmaWxsPSIjM2YzZTNlIiBkPSJNMTUuNzI0IDcuMjQ2SC4yMjhhLjIzNi4yMzYgMCAwIDAgMCAuNDcyaDE1LjQ5NmEuMjM2LjIzNiAwIDAgMCAwLS40NzIiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 202:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMC43NDk4NSAxNS4wNzU0NCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogbm9uZTsKICAgICAgICBzdHJva2U6ICMzZjNlM2U7CiAgICAgICAgc3Ryb2tlLW1pdGVybGltaXQ6IDEwOwogICAgICAgIHN0cm9rZS13aWR0aDogMC41cHg7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDx0aXRsZT5CRUQ8L3RpdGxlPgogIDxnPgogICAgPHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTcuNDIwNTIsNi41OTU2OGguODEyODNhMS4zNjQ0OCwxLjM2NDQ4LDAsMCwxLC43MjczNi4yMSwxLjUzNTY5LDEuNTM1NjksMCwwLDAsLjA4ODQ4LS41MTI5VjEuODcwMTNBMS40NzU5NCwxLjQ3NTk0LDAsMCwwLDE3LjYwMzQ4LjM3NDkzSDMuMzE0MzRhMS40NzUsMS40NzUsMCwwLDAtMS40NDU3MSwxLjQ5NTJWNi4yOTI3NGExLjUzOTQ2LDEuNTM5NDYsMCwwLDAsLjA2MTQ4LjQzNDkxLDEuMzg4NjQsMS4zODg2NCwwLDAsMSwuNTg3ODktLjEzMmguODE0MzNtNy4wNjY1OSwwaC0uMDQ4bTcuMDY5NTksMGEuOTU1NDcuOTU1NDcsMCwwLDAsLjAyNC0uMjA4NDZWNC4zMjk2M2EuOTE0LjkxNCwwLDAsMC0uODk1MzItLjkyNTMxSDExLjI3MDI1YS45MTQuOTE0LDAsMCwwLS44OTUzMi45MjUzMVY2LjM4NzIyYS45NTQ4Ni45NTQ4NiwwLDAsMCwuMDI0LjIwODQ2bS03LjA2NjU5LDBhLjg3MTc1Ljg3MTc1LDAsMCwxLS4wMjQtLjIwODQ2VjQuMzI5NjNhLjkxMjguOTEyOCwwLDAsMSwuODkzODItLjkyNTMxSDkuNDgxMWEuOTEyOC45MTI4LDAsMCwxLC44OTM4My45MjUzMVY2LjM4NzIyYS44NzEyNC44NzEyNCwwLDAsMS0uMDI0LjIwODQ2bS04LjQyMDgyLjEzMmExLjQwNjQ1LDEuNDA2NDUsMCwwLDAtLjQxNTQxLjI5OTk0LDEuNDg4LDEuNDg4LDAsMCwwLS40MTY5MiwxLjAzNjMsMS40NjQ5NCwxLjQ2NDk0LDAsMCwwLC4wNTcuNDA3OTJIMTkuNTk2NThhMS41MjIyLDEuNTIyMiwwLDAsMCwuMDU1NDktLjQwNzkyLDEuNDc2NTksMS40NzY1OSwwLDAsMC0uNjkxMzYtMS4yNTgyNW0tMS41NDAxOS0uMjFoLTcuMDIxNm0tLjA0OCwwSDMuMzMyMzNNMS4xNTQ3Nyw4LjQ3MTgxaC0uMTM1YS42NTgyMy42NTgyMywwLDAsMC0uNjQ0ODcuNjY1ODZ2Mi44MTk0NGEuNjY3NzUuNjY3NzUsMCwwLDAsLjI2MjQ0LjUzMzg5LjYxMjQ3LjYxMjQ3LDAsMCwwLC4zODI0My4xMzJIMTkuNzMxNTVhLjYxMjI0LjYxMjI0LDAsMCwwLC4zODM5My0uMTMzNDguNjY4NzQuNjY4NzQsMCwwLDAsLjI1OTQ1LS41MzIzOVY5LjEzNzY3YS42NTYuNjU2LDAsMCwwLS42NDMzOC0uNjY1ODZoLS4xMzUiLz4KICAgIDxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIwLjEyMDQzLDEyLjQ5djIuMjEwNTZIMTkuNjU3VjEyLjYyMzQzbS0xOC41NjMyOSwwdjIuMDc3MDhILjYzMTgyVjEyLjQ5MTQ1Ii8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ 203:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 204:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 1178:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-product-js-adc907d13ea918294de1.js